(() => {
  'use strict';
  const hero = document.getElementById('jkHero');
  if (!hero) return; // не на этой странице

  // ⛔ М1 (18.08.2026): ОЖИВЛЯЕМ СЕРВЕРНУЮ ЛЕНТУ ПЕРВОЙ СТРОКОЙ ПОСЛЕ ПРОВЕРКИ.
  //    Серверная лента приезжает с data-src у всех кадров, кроме первого, и до
  //    ответа jk_manager.php первый экран держится ИМЕННО на ней: краешки
  //    (hero-peek, js/jk-card.js) показывают предыдущий и следующий кадры.
  //    Файл идёт с defer — разметка уже разобрана, слайды на месте.
  //    ⛔ ЗДЕСЬ, А НЕ НИЖЕ ПО ФАЙЛУ. Сначала вызов стоял на ~590-й строке, за
  //    тремя немедленно исполняемыми блоками: любой throw выше — и галерея
  //    навсегда одна картинка с пустыми краешками, причём молча.
  //    ⛔ Поэтому же heroHydrate НЕ пользуется здешним хелпером $(): он объявлен
  //    ниже через const, до него тут временная мёртвая зона (ReferenceError).
  heroHydrate(0);

  // ⛔ СТРЕЛКИ ВЕШАЕМ ЗДЕСЬ ЖЕ, А НЕ В renderHeroSlides. Кнопки ◄ ► печатает сервер
  //    (jk_content.php), но обработчик им вешала только перерисовка из ответа API —
  //    то есть первые ~0,3 с человек видел стрелки, которые ничего не делают. Здесь
  //    их хватает: goSlide считает кадры по УЗЛАМ серверной ленты, а не по JK.photos.
  //    Флаг _jkBound — тот же, что смотрит renderHeroSlides: второй раз не повесит.
  //    Счётчик «1 / N» тоже заполняем сразу, иначе до ответа API там стоит «1 / 0».
  (function bindServerRibbonArrows() {
    var ssrSlides = document.getElementById('jkHeroSlides');
    var ssrCount = ssrSlides ? ssrSlides.querySelectorAll('.jk-hero-slide').length : 0;
    if (ssrCount < 2) return;
    var l = document.getElementById('heroLeft');
    var r = document.getElementById('heroRight');
    if (l && !l._jkBound) { l.addEventListener('click', function() { goSlide(heroIdx - 1); }); l._jkBound = true; }
    if (r && !r._jkBound) { r.addEventListener('click', function() { goSlide(heroIdx + 1); }); r._jkBound = true; }
    var cnt = document.getElementById('jkPhotoCountNum');
    if (cnt) cnt.textContent = String(ssrCount);
  })();

  // ═══ Аккордеоны инфраструктуры (делегат — работает и для динамически отрисованного списка под картой) ═══
  // B.3-ЖК блок 3 (2026-07-29): тот же делегат раскрывает мобильный аккордеон ипотеки
  // (кнопка [data-acc-toggle] → .is-open на секции [data-acc-host]). Механизм один:
  // второй обработчик на странице не появляется.
  document.addEventListener('click', e => {
    const tog = e.target.closest('[data-infra-toggle],[data-acc-toggle]');
    if (tog) {
      const cat = tog.closest('.jk-infra-cat,[data-acc-host]');
      if (cat) { const open = cat.classList.toggle('is-open'); tog.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      return;
    }
    const more = e.target.closest('[data-infra-more]');
    if (more) {
      // Аккордеон категории (2026-07-06): «показать ещё» раскрывает скрытые POI (>5).
      const cat = more.closest('.jk-infra-cat');
      if (cat) {
        const exp = cat.classList.toggle('is-list-expanded');
        more.setAttribute('aria-expanded', exp ? 'true' : 'false');
        return;
      }
      const wrap = more.previousElementSibling;
      if (wrap && wrap.classList.contains('jk-infra-more')) {
        const wasHidden = wrap.hasAttribute('hidden');
        if (wasHidden) { wrap.removeAttribute('hidden'); more.classList.add('is-open'); } else { wrap.setAttribute('hidden', ''); more.classList.remove('is-open'); }
        more.setAttribute('aria-expanded', wasHidden ? 'true' : 'false');
        const lbl = more.querySelector('.jk-infra-more-btn__txt');
        if (lbl) lbl.textContent = wasHidden ? 'Свернуть' : lbl.dataset.all;
      }
    }
  });

  // Любой переход В секцию ипотеки обязан её раскрыть, иначе пользователь приезжает
  // в закрытый блок. Раскрываем в capture-фазе — ДО обработчиков, которые скроллят.
  // Только раскрываем: якорь никогда не закрывает уже открытое.
  // Живые мобильные пути: прямая ссылка с #jkMortgage (поиск/шаринг) и «назад» по
  // истории (hashchange). Клики по [data-section]/[data-tab] — программные (виджет
  // «платёж от», карточка в рейле) и защита на будущее: сама липкая навигация на
  // ≤640 отключена (initStickyBar живёт под matchMedia('(min-width: 641px)')).
  const openAccHost = id => {
    const host = document.getElementById(id);
    if (!host || !host.hasAttribute('data-acc-host')) return;
    host.classList.add('is-open');
    const btn = host.querySelector('[data-acc-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  };
  const openAccByHash = () => { if (location.hash === '#jkMortgage') openAccHost('jkMortgage'); };
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href="#jkMortgage"],[data-section="jkMortgage"],[data-tab="mortgage"]');
    if (link) openAccHost('jkMortgage');
  }, true);
  // hashchange нужен отдельно: «назад» на …#jkMortgage не перезагружает страницу и
  // клика не даёт — без него возврат приводил бы в свёрнутый блок.
  window.addEventListener('hashchange', openAccByHash);
  openAccByHash();

  // ═══ Прозрачная шапка-оверлей поверх hero (правка владельца 2026-07-14, референс MR Group) ═══
  // header.php выставил body.has-transparent-header (только на jk.php) → шапка прозрачная
  // поверх hero. Пока hero под шапкой в зоне видимости — прозрачно; как только hero ушёл
  // выше линии шапки — возвращаем обычный тёмный фон через #mainHeader.header--solid.
  // Смена без inline (CSP-safe) через IntersectionObserver; нет IO → тихий no-op (сверху
  // остаётся градиент-скрим, читаемость меню сохранена).
  if (document.body.classList.contains('has-transparent-header') && 'IntersectionObserver' in window) {
    const _overlayHdr = document.getElementById('mainHeader');
    if (_overlayHdr) {
      const _overlayIo = new IntersectionObserver(entries => {
        entries.forEach(entry => { _overlayHdr.classList.toggle('header--solid', !entry.isIntersecting); });
      }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 });
      _overlayIo.observe(hero);
    }
  }

  // ═══ HELPERS ═══
  const $ = id => document.getElementById(id);
  // ⛔ Карточка-2026 (первый экран, принятый владельцем 15.08) собирается ТОЛЬКО
  //    на компьютере — телефон владелец просил не трогать. Флаг объявлен здесь, а
  //    не рядом со сборкой: его читают обработчики, которые вешаются раньше неё.
  //    Ширину проверяем ОДИН раз на старте: пересобирать первый экран при каждом
  //    изменении окна — это дёрганье галереи и карты на ровном месте.
  const cardDesktop = !window.matchMedia || window.matchMedia('(min-width: 901px)').matches;
  // ⛔ САМ КОД КАРТОЧКИ-2026 ЛЕЖИТ В ОТДЕЛЬНОМ ФАЙЛЕ js/jk-card.js и грузится
  //    только при cardDesktop (см. jkCardBoot в самом низу). Пока файл не приехал
  //    (телефон, медленная сеть, 404) ссылка равна null — КАЖДЫЙ вызов карточных
  //    функций ниже стоит под проверкой `jkCard`, и страница живёт в прежнем,
  //    серверном виде. Ни одной карточной функции по имени здесь больше нет.
  var jkCard = null;
  // Ответ jk_manager.php мог прийти РАНЬШЕ файла: тогда дополняем экран данными
  // в момент загрузки модуля, а не теряем их молча.
  var jkCardDataArrived = false;
  // esc, fmt, fmtK, calcMonthly → utils.js
  const esc = window.escHtml || (s => { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; });
  // A.3: снять «ЖК » / обрамляющие «» чтобы не было двойного префикса
  const jkBare = s => String(s || '').trim().replace(/^«\s*/u, '').replace(/\s*»$/u, '').replace(/^\s*ЖК\s+«?\s*/iu, '').replace(/\s*»$/u, '').trim();
  // Косметика витрины (15.07.2026): ЗЕРКАЛО app/lib/JkNameHelper.php.
  // Имя из фида уже может начинаться с родового слова («Жилой комплекс HIGH LIFE») —
  // тогда «ЖК» НЕ клеим и имя НЕ режем (это бренд целиком). Иначе была тавтология
  // «ЖК «Жилой комплекс HIGH LIFE»». Список обязан совпадать с JK_GENERIC_PREFIXES.
  // ⛔ Правим ЗДЕСЬ тоже, а не только в PHP: этот файл перерисовывает h1/крошки/
  // sticky после загрузки — иначе серверный фикс затирался бы в браузере.
  const JK_GENERIC_RE = /^(жилой\s+комплекс|жилой\s+квартал|жилой\s+район|жилой\s+дом|клубный\s+дом|клубный\s+квартал|премиум[\s-]квартал|бизнес[\s-]квартал|апарт[\s-]комплекс|апарт[\s-]отель|апартаменты|микрорайон|квартал|дом)(?![\p{L}\p{N}-])/iu;
  // Снять ОБРАМЛЯЮЩИЕ «» только если они парные и внутри баланс не нарушен
  // («Жилой квартал «LIFE-Варшавская»» трогать нельзя — открывающей в начале нет).
  const jkStripOuterQuotes = s => {
    let v = String(s || '').trim();
    for (let i = 0; i < 3; i++) {
      if (!v.startsWith('«') || !v.endsWith('»')) break;
      const inner = v.slice(1, -1).trim();
      if ((inner.match(/«/g) || []).length !== (inner.match(/»/g) || []).length) break;
      v = inner;
    }
    return v;
  };
  const jkHasGeneric = s => JK_GENERIC_RE.test(jkStripOuterQuotes(s));
  // Текстовое отображаемое имя (аналог jkDisplayName в PHP).
  const jkDisplay = s => {
    if (jkHasGeneric(s)) return jkStripOuterQuotes(s);
    const bare = jkBare(s);
    return bare === '' ? 'ЖК' : 'ЖК «' + bare + '»';
  };
  // HTML-вариант для h1: <span> красит золотым градиентом (css/jk.css .jk-hero-title span)
  // именно имя. У родового имени префикса нет → золотим имя целиком.
  const jkDisplayHtml = s => {
    if (jkHasGeneric(s)) return '<span>' + esc(jkStripOuterQuotes(s)) + '</span>';
    const bare = jkBare(s);
    return bare === '' ? 'ЖК' : 'ЖК «<span>' + esc(bare) + '</span>»';
  };
  // SEC-014: валидация CSS-цвета и Font Awesome иконки для innerHTML
  const safeColor = c => /^#[0-9a-fA-F]{3,8}$/.test(c) ? c : '#999';
  const safeIcon = ic => /^fa[a-z-]*\s+fa-[a-z0-9-]+$/.test(ic) || /^fa-[a-z0-9-]+$/.test(ic) ? ic : 'fa-circle';
  const fmt = n => n >= 1e6 ? (n / 1e6).toFixed(n >= 1e7 ? 1 : 2).replace('.', ',') + ' млн \u20bd' : n.toLocaleString('ru') + ' \u20bd';
  const fmtK = window.formatPriceShort || (n => (n / 1e6).toFixed(1).replace('.', ',') + ' млн');
  const calcMonthly = window.calcMonthly || ((price, downPct, rate, years) => {
    const p = price * (1 - downPct / 100), mr = rate / 100 / 12, n = years * 12;
    return mr === 0 ? Math.round(p / n) : Math.round(p * (mr * Math.pow(1 + mr, n)) / (Math.pow(1 + mr, n) - 1));
  });

  // ═══ Phase J: Yandex Maps defer loader ═══
  // Скрипт ymaps грузится один раз при первом вызове. Callback встаёт в очередь.
  var _ymapsLoading = false;
  var _ymapsQueue = [];
  // Пассивные подписчики: рисуются, КОГДА ядро уже приехало, но сами его не зовут.
  var _ymapsPassive = [];
  function _ymapsDrain(list) {
    for (var i = 0; i < list.length; i++) { try { list[i](); } catch (e) {} }
  }
  /**
   * Опустошить пассивную очередь. Вынесено отдельной функцией, потому что
   * точек, где ядро оказывается доступным, ДВЕ: наш onload и «ядро уже здесь»
   * (его привёз кто-то другой). Пропустить любую из них = миниатюра навсегда
   * останется плейсхолдером, причём молча.
   */
  function _ymapsFlushPassive() {
    if (!_ymapsPassive.length) return;
    var p = _ymapsPassive;
    _ymapsPassive = [];
    ymaps.ready(function() { _ymapsDrain(p); });
  }
  function ensureYmaps(cb) {
    if (typeof ymaps !== 'undefined') {
      ymaps.ready(cb);
      // Ядро уже здесь — значит нашего onload не будет, и пассивную очередь
      // опустошать больше некому. Без этой ветки подписчик, вставший в очередь
      // ДО того как ядро привёз кто-то другой, не нарисуется никогда:
      // миниатюра навсегда осталась бы SSR-плейсхолдером.
      _ymapsFlushPassive();
      return;
    }
    _ymapsQueue.push(cb);
    if (_ymapsLoading) return;
    _ymapsLoading = true;
    var s = document.createElement('script');
    // Security Hotfix 2 (2026-04-23): ключ передаётся из PHP через window.YMAPS_KEY (не хардкод).
    s.src = 'https://api-maps.yandex.ru/2.1/?apikey=' + encodeURIComponent(window.YMAPS_KEY || '') + '&lang=ru_RU';
    s.async = true;
    s.onload = function() {
      ymaps.ready(function() {
        var q = _ymapsQueue; _ymapsQueue = [];
        _ymapsDrain(q);
        // Пассивные — вместе с первым же настоящим потребителем: ядро уже в
        // памяти, отрисовать миниатюру стоит копейки. ⛔ Убрать этот вызов —
        // и миниатюра не нарисуется НИКОГДА (пинится поведенческим тестом
        // очереди в tests/JS/jk-ymaps-queue-31-07.test.js).
        _ymapsFlushPassive();
      });
    };
    document.head.appendChild(s);
  }

  /**
   * «Нарисуй, когда ядро появится» — БЕЗ права его загружать.
   *
   * Замер 31.07 (Дюна, 390 и 1920): миниатюра карты в «Характеристиках» стоит на
   * y≈5440px, а секция «Расположение» — на y≈12100px. Обе висели на общем
   * ensureYmapsOnVisible, поэтому ядро Яндекс-карт (3060 КБ распакованных)
   * стартовало уже на scrollY 6400 — за семь экранов до самой карты и ровно в
   * тот момент, когда человек листает планировки. Парсинг давал 228 мс long
   * tasks на быстром десктопе (на телефоне втрое-впятеро) — те самые «фризы,
   * когда разворачиваешь планировки».
   *
   * Теперь ядро заказывает ТОЛЬКО секция «Расположение». Миниатюра до этого
   * показывает свой SSR-плейсхолдер «Смотреть на карте» (он и так в разметке),
   * а клик по ней и раньше лишь пролистывал к секции — интерактив не теряется.
   */
  function whenYmapsLoaded(cb) {
    if (typeof cb !== 'function') return;
    if (typeof ymaps !== 'undefined') { ymaps.ready(cb); return; }
    _ymapsPassive.push(cb);
  }
  // Загружает ymaps когда элемент попадает в viewport. rootMargin 600px: ядро
  // тяжёлое, и стартовать оно должно за экран до карты, а не в момент, когда
  // карта уже на глазах (иначе человек смотрит на пустой прямоугольник).
  function ensureYmapsOnVisible(el, cb) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { ensureYmaps(cb); return; }
    var obs = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) { obs.disconnect(); ensureYmaps(cb); }
    }, { rootMargin: '600px' });
    obs.observe(el);
  }

  // ═══ DATA — will be loaded from API, fallback to inline ═══
  let JK = null;
  let selectedProgram = null;
  let aptFilter = 'all';
  let showAllApts = false;
  let heroAutoTimer = null;

  // Room type mapping for v2 filter buttons
  var filterTypeMap = {
    'all': 'all', 'studio': 'Студия', '1k': '1-комн.',
    '2k': '2-комн.', '3k': '3-комн.', '4k': '4-комн.'
  };

  // ═══ TABS ═══
  const tabsEl = $('jkTabs');
  if (tabsEl) {
    tabsEl.addEventListener('click', e => {
      const btn = e.target.closest('.jk-tab');
      if (!btn) return;
      const tab = btn.dataset.tab;
      tabsEl.querySelectorAll('.jk-tab').forEach(t => { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      document.querySelectorAll('.jk-tab-pane').forEach(p => p.classList.remove('active'));
      const pane = $('pane-' + tab);
      if (pane) pane.classList.add('active');
      // v17.3: lazy init VR tour on first click
      if (tab === 'tour3d') initTour();
    });
  }

  // ═══ DESCRIPTION TOGGLE ═══
  const descToggle = $('jkDescToggle');
  if (descToggle) {
    descToggle.addEventListener('click', () => {
      const desc = $('jkDesc');
      if (!desc) return;
      const clamped = desc.classList.toggle('jk-desc-clamped');
      descToggle.setAttribute('aria-expanded', String(!clamped));
      const icon = descToggle.querySelector('i');
      if (icon) icon.className = clamped ? 'fas fa-chevron-down ico' : 'fas fa-chevron-up ico';
      const txtNode = Array.from(descToggle.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
      if (txtNode) txtNode.textContent = clamped ? 'Читать полностью' : 'Свернуть';
    });
  }

  // ═══ CORPUS ACCORDION ═══
  document.addEventListener('click', e => {
    const hdr = e.target.closest('.jk-corpus-header');
    if (!hdr) return;
    const corpus = hdr.closest('.jk-corpus');
    if (!corpus) return;
    const wasOpen = corpus.classList.contains('open');
    document.querySelectorAll('.jk-corpus.open').forEach(c => c.classList.remove('open'));
    if (!wasOpen) corpus.classList.add('open');
  });

  // Phase C5: маткапитал 2026 (ПФР, ежегодная индексация ~5%)
  const MATCAP_AMOUNTS = { 1: 906526, 2: 1198168 };

  // ═══ MORTGAGE CALC ═══
  function getEffectiveDownPayment(price, downPct) {
    let down = price * (downPct / 100);
    const cb = $('mcMatcap');
    if (cb && cb.checked) {
      const sel = $('mcMatcapType');
      const matcap = sel ? parseInt(sel.value, 10) : MATCAP_AMOUNTS[1];
      down += matcap;
      if (down > price) down = price;
    }
    return down;
  }

  function updateMortgage() {
    if (!JK || !selectedProgram) return;
    const price = parseInt($('mcPrice')?.value) || JK.priceFrom;
    const downPct = parseInt($('mcDown')?.value) || 15;
    const term = parseInt($('mcTerm')?.value) || 25;
    const downAmount = getEffectiveDownPayment(price, downPct);
    const loanAmount = price - downAmount;
    const monthlyRate = selectedProgram.rate / 100 / 12;
    const totalMonths = term * 12;
    const monthly = loanAmount <= 0 ? 0 : (monthlyRate === 0
      ? Math.round(loanAmount / totalMonths)
      : Math.round(loanAmount * (monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) / (Math.pow(1 + monthlyRate, totalMonths) - 1)));
    const totalPaid = monthly * totalMonths;
    const overpay = totalPaid - loanAmount;

    const pv = $('mcPriceVal'); if (pv) pv.textContent = fmt(price);
    const dv = $('mcDownVal'); if (dv) dv.textContent = downPct + '% \xb7 ' + fmt(Math.round(downAmount));
    const tv = $('mcTermVal'); if (tv) tv.textContent = term + ' \u043b\u0435\u0442';
    const mv = $('mcMonthly'); if (mv) mv.textContent = loanAmount <= 0 ? '0 \u20bd' : monthly.toLocaleString('ru') + ' \u20bd';
    const rv = $('mcRate'); if (rv) rv.textContent = selectedProgram.rate + '%';
    const pn = $('mcProgName'); if (pn) pn.textContent = selectedProgram.program;
    const ov = $('mcOverpay'); if (ov) ov.textContent = fmt(Math.max(0, overpay));

    // Phase C5: donut chart + amortization
    updateDonutChart(loanAmount, Math.max(0, overpay), downAmount, totalPaid);
    updateAmortTable(loanAmount, monthlyRate, totalMonths);
  }

  ['mcPrice', 'mcDown', 'mcTerm'].forEach(id => {
    const el = $(id);
    if (el) el.addEventListener('input', updateMortgage);
  });

  // ═══ DONUT CHART (C5) ═══
  function updateDonutChart(body, overpay, downPayment, totalPaid) {
    const total = body + overpay + downPayment;
    const circumference = 2 * Math.PI * 50;
    const bodyPct = total > 0 ? body / total : 0;
    const overpayPct = total > 0 ? overpay / total : 0;

    const donutBody = $('mcDonutBody');
    const donutOverpay = $('mcDonutOverpay');
    const donutTotal = $('mcDonutTotal');

    if (donutBody) {
      donutBody.style.strokeDasharray = circumference;
      donutBody.style.strokeDashoffset = circumference * (1 - bodyPct);
    }
    if (donutOverpay) {
      donutOverpay.style.strokeDasharray = (overpayPct * circumference) + ' ' + circumference;
      donutOverpay.style.strokeDashoffset = -(bodyPct * circumference);
    }
    if (donutTotal) donutTotal.textContent = fmtK(total);

    const legBody = $('mcLegendBody');
    const legOverpay = $('mcLegendOverpay');
    const legDown = $('mcLegendDown');
    if (legBody) legBody.textContent = fmt(body);
    if (legOverpay) legOverpay.textContent = fmt(overpay);
    if (legDown) legDown.textContent = fmt(downPayment);

    const extra = $('jkMcExtra');
    if (extra) extra.classList.remove('jk-hidden');
  }

  // ═══ AMORTIZATION TABLE (C5) ═══
  function updateAmortTable(principal, monthlyRate, totalMonths) {
    const wrap = $('jkAmortWrap');
    const table = $('mcAmortTable');
    if (!wrap || !table || principal <= 0 || totalMonths <= 0) return;
    wrap.classList.remove('jk-hidden');

    let balance = principal;
    const monthlyPayment = monthlyRate === 0
      ? Math.round(principal / totalMonths)
      : Math.round(principal * (monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) / (Math.pow(1 + monthlyRate, totalMonths) - 1));

    const years = [];
    let yearInterest = 0;
    let yearPrincipal = 0;

    for (let m = 1; m <= totalMonths; m++) {
      const interest = Math.round(balance * monthlyRate);
      let princPart = monthlyPayment - interest;
      if (princPart > balance) princPart = balance;
      balance -= princPart;
      if (balance < 0) balance = 0;
      yearInterest += interest;
      yearPrincipal += princPart;

      if (m % 12 === 0 || m === totalMonths) {
        years.push({ year: Math.ceil(m / 12), principal: yearPrincipal, interest: yearInterest, balance: Math.max(0, balance) });
        yearInterest = 0;
        yearPrincipal = 0;
      }
    }

    let html = '<table class="jk-amort"><thead><tr>' +
      '<th>Год</th><th>Тело</th><th>Проценты</th><th>Остаток</th></tr></thead><tbody>';
    for (let i = 0; i < years.length; i++) {
      const y = years[i];
      html += '<tr><td>' + y.year + '</td><td>' + fmt(y.principal) + '</td>' +
        '<td>' + fmt(y.interest) + '</td><td>' + fmt(y.balance) + '</td></tr>';
    }
    html += '</tbody></table>';
    table.innerHTML = html;
  }

  // ═══ MATCAP CHECKBOX (C5) ═══
  (function initMatcap() {
    const cb = $('mcMatcap');
    const sel = $('mcMatcapType');
    if (!cb || !sel) return;
    cb.addEventListener('change', function() {
      sel.disabled = !cb.checked;
      updateMortgage();
    });
    sel.addEventListener('change', function() { updateMortgage(); });
  })();

  // Amortization toggle (C5)
  (function() {
    const toggle = $('mcAmortToggle');
    if (!toggle) return;
    toggle.addEventListener('click', function() {
      const tbl = $('mcAmortTable');
      if (!tbl) return;
      const expanded = tbl.classList.toggle('open');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      const arrow = toggle.querySelector('.jk-mc-amort-arrow');
      if (arrow) arrow.style.transform = expanded ? 'rotate(180deg)' : '';
    });
  })();

  // Apply button → scroll to contact form (C5)
  (function() {
    const btn = $('mcApplyBtn');
    if (!btn) return;
    btn.addEventListener('click', function() {
      const form = document.querySelector('.jk-aside .contact-form') || $('jkCta');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  // Program selection
  document.addEventListener('click', e => {
    const prog = e.target.closest('.jk-mc-program');
    if (!prog || !JK) return;
    const id = parseInt(prog.dataset.id, 10);
    selectedProgram = JK.mortgagePrograms.find(p => p.id === id) || selectedProgram;
    document.querySelectorAll('.jk-mc-program').forEach(p => p.classList.remove('selected'));
    prog.classList.add('selected');
    // Update slider mins
    const downSlider = $('mcDown');
    if (downSlider) { downSlider.min = selectedProgram.minDown; if (parseInt(downSlider.value) < selectedProgram.minDown) downSlider.value = selectedProgram.minDown; }
    const termSlider = $('mcTerm');
    if (termSlider) termSlider.max = selectedProgram.maxTerm;
    updateMortgage();
  });

  // ═══ APARTMENT FILTERS ═══
  document.addEventListener('click', e => {
    const btn = e.target.closest('.jk-apt-filter');
    if (!btn) return;
    aptFilter = btn.dataset.filter;
    showAllApts = false;
    document.querySelectorAll('.jk-apt-filter').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    renderApartments();
  });

  // v2 filter buttons (.jk-filter-btn with data-type)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.jk-filter-btn');
    if (!btn) return;
    var type = btn.dataset.type || 'all';
    aptFilter = type === 'all' ? 'all' : (filterTypeMap[type] || type);
    showAllApts = false;
    var filterWrap = btn.closest('.jk-flats-filter');
    if (filterWrap) filterWrap.querySelectorAll('.jk-filter-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    renderFlatsAccordion();
    renderApartments();
  });

  const aptMoreBtn = $('jkAptMore');
  if (aptMoreBtn) {
    aptMoreBtn.addEventListener('click', () => { showAllApts = !showAllApts; aptMoreBtn.setAttribute('aria-expanded', String(showAllApts)); renderApartments(); });
  }

  // ═══ MAP (full-width Yandex Map) ═══
  var jkMainMap = null;
  var jkMapActivated = false;
  var poiPlacemarks = {};
  var poiPresets = {
    metro:'islands#greenDotIcon', train:'islands#darkGreenDotIcon',
    school:'islands#blueDotIcon', kindergarten:'islands#blueDotIcon',
    university:'islands#darkBlueDotIcon', hospital:'islands#redDotIcon',
    pharmacy:'islands#pinkDotIcon', mall:'islands#violetDotIcon',
    park:'islands#darkGreenDotIcon', sport:'islands#oliveDotIcon',
    bus_stop:'islands#orangeDotIcon', tram:'islands#orangeDotIcon',
    highway:'islands#yellowDotIcon', cafe:'islands#brownDotIcon',
    bank:'islands#grayDotIcon'
  };
  /**
   * ADR-125 (28.08.2026): вид метки САМОГО ЖК на большой карте.
   *
   * ⛔ КАРТОЧКА ЖК НЕ МЕНЯЕТСЯ. Без `window.BRONI_JK_MAP_PHOTO` возвращается ровно тот
   * `preset: 'islands#redDotIcon'`, что стоял здесь до правки, — карточка принята
   * владельцем 16.08 и трогать её вид запрещено. Признак приходит ТОЛЬКО со страницы
   * группы комнатности (public/flats.php печатает его серверной переменной).
   *
   * ⛔ РАЗМЕТКА МЕТКИ — ТА ЖЕ, ЧТО НА КАРТЕ КАТАЛОГА (`.map-marker` > `.map-marker-img`
   * + `.map-marker-label` > `.map-marker-name`, см. catalog-map.js). Владелец 28.08:
   * «на карте должна быть не просто метка, а фото рендера, как у нас на карте» — то
   * есть буквально то же, что человек уже видел на карте города. Своя разметка означала
   * бы вторую метку с тем же смыслом и другим видом.
   *
   * ⛔ КАДР ВСТАВЛЯЕТСЯ СЕРВЕРНЫМ АДРЕСОМ ЧЕРЕЗ `img-thumb.php`, а не исходником из
   * фида: исходники застройщиков весят до 10 МБ на кадр, и катастрофа A.0 карты
   * каталога началась ровно с CDN-адреса в `background-image`.
   *
   * @returns {Object} опции ymaps.Placemark
   */
  function jkMainMarkerOptions() {
    var photo = typeof window.BRONI_JK_MAP_PHOTO === 'string' ? window.BRONI_JK_MAP_PHOTO : '';
    if (!photo || typeof ymaps === 'undefined' || !ymaps.templateLayoutFactory) {
      return {preset: 'islands#redDotIcon'};
    }
    // ⛔ КАДР СТАВИТСЯ ИЗ `build()`, А НЕ АТРИБУТОМ `style` В ШАБЛОНЕ. Две причины, и
    // обе жёсткие: у нас строгий CSP без `unsafe-inline` для стилей (атрибут просто не
    // применится), а подстановка адреса в текст CSS позволила бы кавычке в имени файла
    // закрыть значение и оставить висеть кусок правила.
    var layout = ymaps.templateLayoutFactory.createClass(
      '<div class="map-marker has-photo">'
        + '<div class="map-marker-img"></div>'
        + '<span class="map-marker-label"><span class="map-marker-name">{{ properties.label }}</span></span>'
      + '</div>',
      {
        build: function() {
          layout.superclass.build.call(this);
          var el = this.getParentElement().querySelector('.map-marker-img');
          if (el) el.style.backgroundImage = 'url("' + photo.replace(/["\\]/g, '') + '")';
        }
      }
    );
    return {
      iconLayout: layout,
      // Габарит совпадает с покоем метки каталога (60×60 + подпись под кадром):
      // разъедься они, одна и та же метка «прыгала» бы при переходе между страницами.
      iconShape: {type: 'Rectangle', coordinates: [[-34, -84], [34, 6]]}
    };
  }

  function initMainMap() {
    var mapBox = $('jkMapBox');
    if (!mapBox || !JK || !JK.lat || !JK.lng) return;
    // Phase J: defer — ymaps грузится когда #jkMap в viewport
    ensureYmapsOnVisible(document.getElementById('jkMap') || mapBox, function() {
      jkMainMap = new ymaps.Map(mapBox, {
        center: [JK.lat, JK.lng],
        zoom: 15,
        controls: ['zoomControl', 'geolocationControl']
      });
      jkMainMap.behaviors.disable(['scrollZoom', 'drag', 'multiTouch']);
      jkMainMap.geoObjects.add(new ymaps.Placemark([JK.lat, JK.lng], {
        balloonContent: esc(JK.name),
        label: JK.name || ''
      }, jkMainMarkerOptions()));
      // POI markers
      if (JK.nearby && JK.nearby.length) {
        JK.nearby.forEach(function(n) {
          if (!n.lat || !n.lng) return;
          var pm = new ymaps.Placemark([n.lat, n.lng], {
            hintContent: esc(n.name),
            balloonContentHeader: esc(n.name),
            // ⛔ «пешком» дописываем, только если в dist действительно минуты
            //    ходьбы (см. enrichJK). Иначе на шаре выходило «65.0 км пешком».
            balloonContentBody: esc(n.dist + (n.walkable === false ? '' : ' пешком'))
          }, {
            preset: poiPresets[n.type] || 'islands#grayDotIcon'
          });
          jkMainMap.geoObjects.add(pm);
          if (!poiPlacemarks[n.type]) poiPlacemarks[n.type] = [];
          poiPlacemarks[n.type].push(pm);
        });
      }
      var nameEl = $('jkMapName');
      if (nameEl) nameEl.classList.remove('jk-hidden');
      var openEl = $('jkMapOpen');
      if (openEl) openEl.classList.remove('jk-hidden');
      mapBox.addEventListener('click', function() {
        if (!jkMapActivated && jkMainMap) {
          jkMapActivated = true;
          jkMainMap.behaviors.enable(['scrollZoom', 'drag', 'multiTouch']);
          mapBox.style.cursor = 'grab';
        }
      });
    });
  }
  // jkMainMap init moved inside ensureYmapsOnVisible above
  var mapOpen = $('jkMapOpen');
  if (mapOpen) {
    mapOpen.addEventListener('click', function(e) {
      e.stopPropagation();
      if (JK && JK.lat && JK.lng) window.open('https://yandex.ru/maps/?pt=' + JK.lng + ',' + JK.lat + '&z=16', '_blank');
    });
  }

  // ═══ CTA ═══
  // Лид-модалка: shared-хелпер (класс active + scroll-lock); fallback на случай
  // сбоя загрузки shared.js — лид не должен теряться молча (P1 блока 1.1)
  // ⛔ ЕДИНАЯ ТОЧКА ВХОДА ЗАЯВКИ. Сюда ведут ВСЕ кнопки карточки, и здесь же
  //    решается, какое окно открыть: на компьютере — наше, с карточкой конкретного
  //    ЖК (cardLeadOpen), иначе штатная модалка сайта.
  // ⛔ Перехвата кликов на document БОЛЬШЕ НЕТ. Он висел в фазе погружения со
  //    stopImmediatePropagation и для шести кнопок молча убивал ВСЕ соседние
  //    обработчики — закрытие меню шапки, гео-подсказку и делегат [data-ym]
  //    аналитики (цель Метрики приходилось слать руками). Подмена цели вызова
  //    вместо глушения события ничего не ломает и работает для кнопок, которые
  //    сайт дорисовывает позже.
  // ⛔ Ширину смотрим В МОМЕНТ КЛИКА, а не по флагу загрузки: человек мог сузить
  //    окно, а всё оформление .jkcb-* живёт в @media (min-width: 901px) — иначе
  //    окно открылось бы голым текстом поверх страницы.
  function openLeadModal() {
    if (jkCard && jkCard.leadReady()) { jkCard.leadOpen(); return; }
    if (typeof window.openCallbackModal === 'function') { window.openCallbackModal(); return; }
    const m = document.getElementById('callbackModal');
    if (m) { m.classList.add('active'); document.body.style.overflow = 'hidden'; }
  }
  // Мост для отдельных IIFE в конце файла (ипотека / рассрочка / ЖК без квартир):
  // они лежат вне этой области видимости и звали штатную модалку напрямую.
  window.openJkLeadModal = openLeadModal;
  const cta = $('jkCta');
  if (cta) cta.addEventListener('click', openLeadModal);

  // ═══ FAVORITE ═══
  const fav = $('jkFav');
  if (fav) fav.addEventListener('click', () => fav.classList.toggle('active'));

  // ═══ RENDER FUNCTIONS ═══
  // ═══ HERO PHOTO SLIDER ═══
  let heroIdx = 0;
  let activeHeroPhotos = [];

  // 1.7.5: вынесено из renderHeroSlides отдельной функцией — таб «Планировки»
  // теперь может появиться ПОЗЖЕ первой отрисовки (чертежи приходят от умного
  // фильтра, см. initHeroPlansFromFilter). Перевызывать renderHeroSlides ради
  // этого нельзя: он сбрасывает активную категорию и мотает галерею на первый
  // слайд прямо под руками у человека.
  function renderHeroTabs() {
    const heroTabsEl = $('jkHeroTabs');
    if (!heroTabsEl || !JK) return;
    const photos = JK.photos || [];
    const plans = JK.plans || [];
    const constructionPhotos = JK.constructionPhotos || [];
    {
      const categories = [];
      if (photos.length) categories.push({ key: 'renders', label: '\u0420\u0435\u043d\u0434\u0435\u0440\u044b', count: photos.length, icon: 'fa-image' });
      if (plans.length) categories.push({ key: 'plans', label: '\u041f\u043b\u0430\u043d\u0438\u0440\u043e\u0432\u043a\u0438', count: plans.length, icon: 'fa-drafting-compass' });
      if (constructionPhotos.length) categories.push({ key: 'construction', label: '\u0425\u043e\u0434 \u0441\u0442\u0440\u043e\u0439\u043a\u0438', count: constructionPhotos.length, icon: 'fa-helmet-safety' });

      if (categories.length > 1) {
        heroTabsEl.innerHTML = categories.map(function(c, i) {
          return '<button class="jk-hero-tab' + (i === 0 ? ' active' : '') + '" data-photo-tab="' + c.key + '">' +
            '<i class="fas ' + c.icon + '"></i> ' + esc(c.label) + ' <span class="jk-hero-tab-count">' + c.count + '</span></button>';
        }).join('');
        heroTabsEl.style.display = '';
        if (!heroTabsEl._jkBound) {
          heroTabsEl.addEventListener('click', function(e) {
            var btn = e.target.closest('[data-photo-tab]');
            if (!btn) return;
            heroTabsEl.querySelectorAll('.jk-hero-tab').forEach(function(t) { t.classList.remove('active'); });
            btn.classList.add('active');
            switchPhotoCategory(btn.dataset.photoTab);
          });
          heroTabsEl._jkBound = true;
        }
      } else {
        heroTabsEl.style.display = 'none';
      }
    }
  }

  function renderHeroSlides() {
    const slides = $('jkHeroSlides');
    const dots = $('heroDots');
    const photos = JK.photos || [];
    if (!slides || !photos.length) return;

    renderHeroTabs();

    // Инициализация слайдов (рендеры по умолчанию)
    activeHeroPhotos = photos;
    buildSlides(slides, dots, photos);

    // Счётчик «N / M» ставит buildSlides — он же знает и номер текущего кадра.

    var left = $('heroLeft'), right = $('heroRight');
    if (left && !left._jkBound) { left.addEventListener('click', function() { goSlide(heroIdx - 1); }); left._jkBound = true; }
    if (right && !right._jkBound) { right.addEventListener('click', function() { goSlide(heroIdx + 1); }); right._jkBound = true; }
    var heroEl = $('jkHero');
    if (heroEl && !heroEl._jkWheelBound) {
      var wheelLock = 0;
      heroEl.addEventListener('wheel', function(e) {
        if (!activeHeroPhotos.length || activeHeroPhotos.length < 2) return;
        if (Math.abs(e.deltaX) < 20) return;
        var now = Date.now();
        if (now - wheelLock < 400) { e.preventDefault(); return; }
        wheelLock = now;
        e.preventDefault();
        goSlide(heroIdx + (e.deltaX > 0 ? 1 : -1));
      }, { passive: false });
      var dragStartX = 0, dragging = false;
      heroEl.addEventListener('pointerdown', function(e) {
        if (e.target.closest('button,a')) return;
        dragStartX = e.clientX; dragging = true;
      });
      heroEl.addEventListener('pointerup', function(e) {
        if (!dragging) return; dragging = false;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 50 && activeHeroPhotos.length > 1) goSlide(heroIdx + (dx < 0 ? 1 : -1));
      });
      heroEl.addEventListener('pointercancel', function() { dragging = false; });
      heroEl._jkWheelBound = true;
    }
    if (heroAutoTimer) clearInterval(heroAutoTimer);
    var startAutoTimer = function() {
      if (heroAutoTimer) clearInterval(heroAutoTimer);
      heroAutoTimer = setInterval(function() { goSlide(heroIdx + 1); }, 6000);
    };
    startAutoTimer();

    // Pause autoplay when tab is hidden
    if (!hero._visBound) {
      hero._visBound = true;
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) { if (heroAutoTimer) { clearInterval(heroAutoTimer); heroAutoTimer = null; } }
        else if (!heroAutoTimer && activeHeroPhotos.length) { heroAutoTimer = setInterval(function() { goSlide(heroIdx + 1); }, 6000); }
      });
    }
  }

  function switchPhotoCategory(key) {
    var photoMap = { renders: JK.photos || [], plans: JK.plans || [], construction: JK.constructionPhotos || [] };
    var newPhotos = photoMap[key] || JK.photos || [];
    if (!newPhotos.length) return;
    activeHeroPhotos = newPhotos;
    // Смена категории — это НОВАЯ лента, а не то же место в старой: начинаем с первого
    // кадра. Счётчик «N / M» (оба числа) переставит buildSlides — см. памятку там.
    heroIdx = 0;
    buildSlides($('jkHeroSlides'), $('heroDots'), newPhotos);
    if (jkCard) jkCard.syncPeeks();   // сменилась категория кадров — краешки за ней
  }

  // Владелец 2026-07-27 («рендеры автоматом сжимать без потери качества, чтоб сайт
  // не тормозил»): внешние картинки галереи (CDN застройщиков — Яндекс-облако Гранели,
  // itiso Догмы и т.п.) отдаём через наш WebP-прокси /img-thumb.php (кэш 7 дней,
  // immutable).
  // PERF-1 (2026-08-02): свой хост больше НЕ исключение — локальные рендеры ЖК
  // (до 888 КБ сырого JPEG) шли мимо прокси. Теперь папка building_renders тоже идёт
  // через прокси, как в catalog-map.js. Паритет с PHP-хелпером thumbProxyUrl()
  // в SSR-слайдах jk_content.php.
  // ⛔ Только building_renders, а не вся папка img: img-thumb.php растягивает исходник до
  // запрошенной ширины, поэтому мелкие ассеты (лого 192 px) через прокси становятся
  // ТЯЖЕЛЕЕ оригинала. Паритет с thumbIsLocalThumbable() в app/helpers.php.
  var LOCAL_THUMBABLE_RE = /^\/img\/building_renders\/[\w./-]+\.(?:jpe?g|png|webp)$/i;
  /**
   * ⛔ ТОЧНЫЙ ПАРИТЕТ С rawurlencode() ИЗ PHP (thumbProxyUrl в app/helpers.php).
   *
   * encodeURIComponent НЕ кодирует пять символов, которые кодирует rawurlencode:
   * ! ' ( ) *. На таком имени сервер и браузер собирали ДВА РАЗНЫХ адреса прокси
   * для ОДНОЙ фотографии — то есть кадр, уже скачанный серверной лентой, качался
   * заново при перерисовке. Не теория: ЖК «Пушкино Град» (id 9) держит кадр
   * `…Пушкино Град_0077 с людьми (1).jpg` — единственный такой на 153 ЖК, но
   * лечится это одной строкой, а ловится глазами очень плохо.
   */
  function rfc3986(s) {
    return encodeURIComponent(s).replace(/[!'()*]/g, function(c) {
      return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
  }

  function thumbUrl(url, w) {
    if (!url) return url;
    var path = String(url).replace(/^https?:\/\/(?:www\.)?bronidom\.ru(?=\/)/i, '');
    if (/^https?:\/\//i.test(path)) {
      return '/img-thumb.php?src=' + rfc3986(path) + '&w=' + (w || 1200);
    }
    if (LOCAL_THUMBABLE_RE.test(path) && path.indexOf('..') < 0) {
      return '/img-thumb.php?src=' + rfc3986(path) + '&w=' + (w || 1200);
    }
    return url;
  }

  /**
   * СТЕНД: адрес картинки, который на проде остаётся прежним
   * (доводка 1 блока 2.1 плана local-stand, 10.09.2026).
   *
   * ⛔ ЧТО ЛЕЧИМ. Пять отрисовщиков этого файла кладут в `src` адрес из базы как
   * есть, мимо `thumbUrl()`: генплан, две карточки квартиры (планировка), «похожие
   * ЖК» и полноразмерный кадр лайтбокса. На проде так и задумано — там это адрес
   * застройщика или наш собственный файл. На локальной копии сайта это дыра в
   * изоляции: замер верификатора 10.09 поймал на профиле `mobile-chromium`
   * ШЕСТЬ прямых картинок с `bitrix.1dogma.net` в блоке «похожие ЖК», и от них
   * собственная e2e-проба блока была КРАСНОЙ (`PW_EXIT=1`), пока её гоняли
   * на одном профиле из трёх и этого не видели.
   *
   * ⛔ ПОЧЕМУ ЧЕРЕЗ ФЛАГ, А НЕ ПРОСТО `thumbUrl()`. Прогонять эти кадры через
   * уменьшитель на проде — отдельное решение с отдельной ценой (кадр лайтбокса
   * ПОЛНОРАЗМЕРНЫЙ по прямому слову владельца от 16.08: «увеличить» обязано
   * показывать больше, чем видно на странице). Стенду же нужна ровно изоляция.
   * Поэтому калитка та же, что у Метрики, — `window.BRONIDOM_STAND` из
   * `app/templates/header.php` (ставится по `APP_ENV`, см. StandMedia).
   * Второго опознавателя стенда в JS не заводим.
   *
   * ⛔ Сравнение строгое (`=== true`): на проде флаг `false`, вне шаблона —
   * `undefined`; ни то ни другое ветку не открывает.
   */
  function standSrc(url, w) {
    return window.BRONIDOM_STAND === true ? thumbUrl(url, w) : url;
  }

  /**
   * ⛔ М1 (2026-08-18): ЛЕНТА ГЕРОЯ ГРУЗИТ КАДРЫ ПО ОЧЕРЕДИ, А НЕ ВСЕ СРАЗУ.
   *
   * Человек видит ОДИН кадр из двенадцати, а страница качала все двенадцать.
   * Замер с ПРОГРЕТЫМ кэшем — так ходит живой человек (img-thumb.php отдаёт
   * cache-control public, max-age=604800, immutable). 18.08, покадрово через
   * прод-прокси, w=1200, каждый адрес один раз:
   *    curl -s -o /dev/null -w '%{size_download}' \
   *      'https://bronidom.ru/img-thumb.php?src=<адрес>&w=1200'
   *    ЖК VEER (id 67, 12 кадров):    2148 → 661 КиБ (−70 %)
   *    ЖК Космопарк (id 1, 7 кадров):  886 → 374 КиБ (−58 %)
   * «До» — все кадры ленты; «после» — текущий, следующий и последний.
   * ⛔ ЧИСЛА «4297 → 1036, −76 %» И «4,1 МБ = 89 %» БЫЛИ ЗАВЫШЕНЫ РОВНО ВДВОЕ:
   *    замер гоняли на зеркале в режиме no-store, браузер перекачивал те же
   *    адреса. Не возвращать — на этих числах строят следующие решения.
   * ⛔ «375 / 361 КиБ» тоже не воспроизводятся: их мерили на vision-порядке
   *    ленты, снятом 18.08 — греются ДРУГИЕ три файла.
   * Проставленный loading="lazy" не помогал и помочь не мог: слайды лежат друг
   * на друге в первом экране (position:absolute;inset:0), браузер считает их
   * видимыми и качает подряд.
   *
   * Здесь адрес переезжает из src в data-src, и src получают текущий кадр плюс
   * соседи. Соседи нужны не «на всякий случай» — краешки (hero-peek,
   * js/jk-card.js) показывают их прямо в первом экране, и листание обязано
   * оставаться мгновенным.
   *
   * ⛔ РАДИУС РАЗНЫЙ: 1 на открытии и 2 при листании — это осознанный размен.
   *    На открытии платит КАЖДЫЙ посетитель, поэтому там ровно три кадра (в этом
   *    вся экономия блока). Листает меньшинство, зато быстро: замер — четыре
   *    нажатия ► за секунду, а при радиусе 1 следующий кадр начинал грузиться
   *    только в момент показа, и человек видел тёмный прямоугольник.
   *    Фона под слайдом не хватило бы: .jk-hero уже залит var(--dark2), то есть
   *    «пустой прямоугольник» УЖЕ этого цвета — красить нечего, нужен запас
   *    времени. Радиус 2 даёт кадру фору в два шага вместо одного.
   * ⛔ ПЕРВЫЙ СЛАЙД НЕ ТРОГАЕМ: он приходит с живым src и fetchpriority="high"
   *    из разметки — это LCP страницы, отложить его значит испортить главное
   *    измерение скорости.
   * ⛔ data-src ПОСЛЕ подстановки НЕ УДАЛЯЕМ: по нему модуль карточки достаёт
   *    полный список кадров для окна заявки (cardLeadGallery) и для краешков.
   *
   * @param {number} idx    кадр, вокруг которого греем ленту
   * @param {number} [span] радиус подстановки: 1 (по умолчанию) или 2
   */
  // ⛔ ТА ЖЕ СТРОКА, ЧТО В app/templates/pages/jk_content.php ($_blankPx).
  //    Прозрачный GIF 1×1: <img> без src невалиден по HTML, а отложенных кадров
  //    на странице до 29. Заглушка ничего не качает и невидима под object-fit.
  //    Разъедется с шаблоном — перерисовка ленты станет отличаться от серверной.
  var BLANK_PX = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  function heroHydrate(idx, span) {
    // ⛔ getElementById, а не хелпер $(): heroHydrate зовётся первой строкой
    //    файла, а $ объявлен ниже через const — до него временная мёртвая зона.
    var slides = document.getElementById('jkHeroSlides');
    if (!slides) return;
    var imgs = slides.querySelectorAll('.jk-hero-slide-img');
    var n = imgs.length;
    if (!n) return;
    var at = ((idx % n) + n) % n;
    // ⛔ РАДИУС — ЭТО ЗАПАС, А НЕ ВИДИМАЯ ЗОНА. Видно три кадра (краешки слева и
    //    справа), поэтому радиус 1 обеспечивает ровно показанное и ничего сверх:
    //    следующий краешек начинал грузиться в момент, когда его уже показывают.
    //    Значение приходит числом: 1 — только видимое (первая отрисовка),
    //    больше — с запасом на столько шагов вперёд.
    var r = span > 1 ? Math.min(span, 4) : 1;
    for (var d = -r; d <= r; d++) {
      var img = imgs[((at + d) % n + n) % n];
      if (!img) continue;
      var src = img.getAttribute('data-src');
      if (!src) continue;
      // Уже с картинкой (первый слайд либо пролистанный ранее) — не перезаписываем:
      // повторный set src перезапустил бы загрузку и моргнул кадром.
      // ⛔ ЗАГЛУШКА — ЭТО «КАДРА ЕЩЁ НЕТ». У отложенных слайдов в src стоит
      //    прозрачный GIF 1×1 (data:…), иначе тег <img> невалиден по HTML.
      //    Без этой проверки лента замерла бы на первом кадре: src непустой,
      //    значит «уже загружено». Заглушка — ЕДИНСТВЕННОЕ, что можно
      //    перезаписать, и узнаём её по схеме data:, а не по длине строки.
      var cur = img.getAttribute('src');
      if (cur && cur.slice(0, 5) !== 'data:') continue;
      img.setAttribute('src', src);
    }

    // ⛔ ЗАПАС БЕРЁМ ПОЗЖЕ И ТОЛЬКО РАЗ. Владелец 19.08.2026: «чернеют и пустой
    //    появляется, где рендеры крутятся — то слева чёрное, то справа, то по
    //    центру, потом всё нормально». Замер: до листания готовы кадры 0-4, а
    //    пятый начинал грузиться РОВНО в момент нажатия стрелки — быстрое
    //    листание обгоняло загрузку.
    // ⛔ ПОЧЕМУ НЕ СРАЗУ: первый экран специально облегчили, и возвращать
    //    «качаем всё» нельзя. Кольцо шире видимого берём, когда браузер
    //    свободен, то есть уже после показа первого экрана. На LCP не влияет.
    // ⛔ Планируем ЗДЕСЬ, а не строкой запуска: тогда этот кусок самодостаточен
    //    и работает одинаково, откуда бы гидратацию ни позвали.
    if (!heroHydrate._warmed && !span) {
      heroHydrate._warmed = true;
      var warm = function () { heroHydrate(at, 3); };
      if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(warm, { timeout: 2500 });
      } else {
        setTimeout(warm, 1200);
      }
    }
  }

  function buildSlides(slides, dots, photos) {
    if (!slides || !photos.length) return;
    // ⛔ М1 (18.08.2026): ЛЕНТУ НЕ МОТАЕМ НА ПЕРВЫЙ КАДР ПОД РУКАМИ У ЧЕЛОВЕКА.
    //    Стрелки живут с первой миллисекунды (bindServerRibbonArrows в начале файла),
    //    поэтому к моменту ответа API человек уже мог пролистать серверную ленту.
    //    Раньше здесь безусловно вешался active ПЕРВОМУ слайду и первой точке, а
    //    heroIdx не трогался вовсе: фотография сама уезжала назад, счётчик продолжал
    //    показывать старый номер, а следующее нажатие ► перескакивало через кадр —
    //    и этот кадр человек не видел уже никогда (ни стрелкой, ни автолистанием:
    //    таймер тоже считает от heroIdx). Воспроизведено исполнением, сторож —
    //    tests/JS/jk-hero-rebuild-keeps-place.test.js.
    //    ⛔ Остаток по длине НОВОГО списка обязателен: категорий кадров три
    //    («Рендеры»/«Планировки»/«Ход стройки»), и в них разное число фотографий.
    var curIdx = ((heroIdx % photos.length) + photos.length) % photos.length;
    heroIdx = curIdx;
    var jkLabel = (typeof JK !== 'undefined' && JK && JK.name) ? jkDisplay(JK.name) : 'ЖК';
    // Город в alt — как в SSR (SEO-Ф1.7): гидрация не должна терять ключ
    // «в {городе}» из alt (верификатор P1, 23.07). Источник — data-city-prep на H1.
    var h1El = document.querySelector('[data-city-prep]');
    var cityPrep = h1El ? (h1El.getAttribute('data-city-prep') || '') : '';
    if (cityPrep) jkLabel += ' в ' + cityPrep;
    // ⛔ М1: адрес кадра пишем в data-src ВСЕМ, кроме первого. Паритет с SSR-лентой
    //    в app/templates/pages/jk_content.php — вплоть до заглушки в src. Подставляет
    //    настоящий адрес heroHydrate(). Разметка, размеры и порядок слайдов те же.
    slides.innerHTML = photos.map(function(url, i) {
      var isFirst = i === 0;
      var src = esc(thumbUrl(url, 1200));
      // ⛔ Первый слайд — LCP страницы: у него всегда живой src и fetchpriority="high",
      //    и НИКОГДА loading="lazy".
      var srcAttr = isFirst
        ? ' src="' + src + '" fetchpriority="high"'
        : ' src="' + BLANK_PX + '" data-src="' + src + '"';
      // ⛔ КЛЮЧЕВАЯ ФРАЗА — ТОЛЬКО У ПЕРВОГО КАДРА (блок С-1, 08.09.2026), паритет
      //    с SSR-лентой в app/templates/pages/jk_content.php. До правки название ЖК
      //    стояло у всех 29 кадров; лента лежит ВЫШЕ <h1>, и Яндекс тащил эту строку
      //    в сниппет вместо описания. ⛔ Правка ОБЯЗАНА быть в обоих местах: робот
      //    Яндекса исполняет наш JS, и гидрация вернула бы ключ на все кадры.
      var altText = isFirst
        ? jkLabel + ' — фото 1 из ' + photos.length
        : 'Фото ' + (i + 1) + ' из ' + photos.length;
      // ⛔ ПОКАЗАННЫЙ КАДР И «ПЕРВЫЙ» — РАЗНЫЕ ВЕЩИ. active получает тот, на котором
      //    стоит человек (curIdx), а живой src с fetchpriority="high" — всегда кадр
      //    номер один: это LCP страницы, и отложить его нельзя. Совпадают они только
      //    при curIdx === 0, то есть в обычном случае.
      return '<div class="jk-hero-slide' + (i === curIdx ? ' active' : '') + '">' +
        '<img' + srcAttr + ' alt="' + esc(altText) + '" class="jk-hero-slide-img" width="1920" height="1000" decoding="async"></div>';
    }).join('');
    // Текущий кадр и соседи — сразу: краешки первого экрана (hero-peek) показывают
    // предыдущий и следующий, значит их нельзя оставлять пустыми.
    heroHydrate(curIdx);
    if (dots) {
      var dotCount = photos.length;
      var dotsHtml = '';
      for (var di = 0; di < dotCount; di++) {
        dotsHtml += '<span class="jk-hero-dot' + (di === curIdx ? ' active' : '') + '" data-idx="' + esc(di) + '"></span>';
      }
      dots.innerHTML = dotsHtml;
      if (!dots._jkBound) { dots.addEventListener('click', function(e) { var d = e.target.closest('[data-idx]'); if (d) goSlide(+d.dataset.idx); }); dots._jkBound = true; }
    }
    // ⛔ СЧЁТЧИК «N / M» ЗАПОЛНЯЕТСЯ ЗДЕСЬ, И ЭТО ЕГО ЕДИНСТВЕННЫЙ ХОЗЯИН НА ВЕСЬ
    //    ФАЙЛ (кроме goSlide, который двигает только номер). Раньше знаменатель
    //    ставила renderHeroSlides, а switchPhotoCategory не ставил вовсе — и после
    //    «Рендеры (12) → Планировки (4)» на экране оставалось «2 / 12» при четырёх
    //    кадрах. Пока счётчик до ответа API стоял «1 / 0», это было почти незаметно;
    //    теперь он заполнен с первой миллисекунды, и враньё стало видным.
    var countNum = $('jkPhotoCountNum');
    if (countNum) countNum.textContent = String(photos.length);
    var curNum = $('jkHeroCurrentSlide');
    if (curNum) curNum.textContent = String(curIdx + 1);
  }

  function goSlide(idx) {
    var slides = $('jkHeroSlides');
    var nodes = slides ? slides.querySelectorAll('.jk-hero-slide') : [];
    var total = nodes.length || activeHeroPhotos.length;
    if (!total) return;
    heroIdx = (idx + total) % total;
    // ⛔ Кадр подставляем ДО показа слайда: иначе человек на долю секунды видит
    // пустой прямоугольник вместо фотографии.
    // ⛔ ЗАПАС ТРИ, А НЕ ДВА (19.08.2026). При двух следующий краешек начинал
    // грузиться ровно в тот миг, когда становился видимым, и быстрое листание
    // его обгоняло — владелец видел чёрные прямоугольники слева и справа.
    heroHydrate(heroIdx, 3);
    nodes.forEach(function(s, i) { s.classList.toggle('active', i === heroIdx); });
    var dots = $('heroDots');
    if (dots) dots.querySelectorAll('.jk-hero-dot').forEach(function(d, i) { d.classList.toggle('active', i === heroIdx); });
    var currentSlide = $('jkHeroCurrentSlide');
    if (currentSlide) currentSlide.textContent = heroIdx + 1;
    // Краешки соседних кадров следуют за листанием (карточка-2026).
    if (jkCard) jkCard.syncPeeks();
  }


  // ═══ АДРЕС: ДВЕ СТРОКИ, ОДИН ИСТОЧНИК ═══
  // Адрес очищает BuildingAddress на сервере. Здесь только регистр капса и
  // прежняя приписка района; регион, город и детали повторно не разбираются.
  function jkAddressText(raw) {
    var text = String(raw || '');
    var letters = (text.match(/[A-Za-zА-Яа-яЁё]/g) || []).length;
    var upper = (text.match(/[A-ZА-ЯЁ]/g) || []).length;
    if (!letters || upper / letters <= 0.8) return text;
    var lowerWords = /^(г|город|ул|улица|пр|проспект|пер|переулок|ш|шоссе|наб|набережная|мкр|микрорайон|д|дом|к|корп|корпус|стр|строение|вл|им|район|округ|поселение|сельское|городское|территория|линия|тракт|литера|владение|участок|здание)$/;
    return text.toLowerCase().replace(/[a-zа-яё]+/g, function(word) {
      return lowerWords.test(word) ? word : word.charAt(0).toUpperCase() + word.slice(1);
    });
  }

  function jkDistrictSuffix(address, district, city) {
    var name = String(district || '').replace(/\s*(район|р-н|мкр\.?|микрорайон)\s*$/i, '').trim();
    if (!name || /област|край|республик|округ|^(мо|[свюзцтн]{1,3}ао|москва|санкт[- ]петербург|севастополь)$/i.test(name)) return '';
    var key = function(text) {
      return String(text || '').trim().toLowerCase().replace(/ё/g, 'е')
        .replace(/^(г\.?|город)\s+/i, '').replace(/\s*(район|р-н)\s*$/i, '').replace(/[^а-яa-z0-9]/g, '');
    };
    if (key(name) === key(city)) return '';
    if (String(address).split(/[,·]/).some(function(part) { return key(part) === key(name); })) return '';
    return ' \xb7 ' + jkAddressText(name) + ' р-н';
  }

  function jkApplyStripAddress() {
    if (!JK) return;
    var addr = $('jkAddress');
    if (!addr) return;
    var line = jkAddressText(JK.address);
    line += jkDistrictSuffix(line, JK.district, JK.city);
    if (!cardDesktop && JK.developer) line += ' \xb7 ' + JK.developer;
    addr.textContent = line;
  }

  function jkApplyInfoAddress() {
    if (!JK) return;
    var addr = $('jkInfoAddress');
    if (!addr) return;
    var line = jkAddressText(JK.address);
    line += jkDistrictSuffix(line, JK.district, JK.city);
    addr.innerHTML = '<i class="fas fa-location-dot"></i><span>' + esc(line) + '</span>';
  }

  function renderAll() {
    if (!JK) return;

    // Photo gallery slider
    renderHeroSlides();

    // Breadcrumb
    // 10.10.2026: видимая крошка = звено BreadcrumbList (jkDisplayName), как до 07.10.
    const bc = $('bcJkName'); if (bc) bc.textContent = jkDisplay(JK.name);

    // Sticky bar (C7)
    const stickyName = $('jkStickyName');
    if (stickyName) stickyName.textContent = jkDisplay(JK.name);
    const stickyPrice = $('jkStickyPrice');
    if (stickyPrice) stickyPrice.textContent = JK.priceFrom ? fmt(JK.priceFrom) : '';

    // Hero
    // SEO Ф1.2: сохраняем предложный город в H1 при клиентской перерисовке. Сервер
    // рендерит «ЖК «X» в Москве» + data-city-prep="Москве"; jkDisplayHtml золотит имя,
    // но без до-клейки города отрисованный H1 потерял бы «в Москве» (SSR↔DOM рассинхрон).
    // ⛔ ADR-125 (28.08.2026): ЗАГОЛОВОК, ПРИКАЗАННЫЙ СЕРВЕРОМ, НЕ ПЕРЕРИСОВЫВАЕМ.
    //    На странице комнатности H1 звучит «Купить 2-комнатную квартиру в ЖК X» — это
    //    и есть тема страницы. Перерисуй мы его именем дома, страница потеряла бы
    //    заголовок, ради которого создана, причём НЕ НА ГЛАЗАХ: сервер отдаёт верный
    //    текст, подмена случается через ~0,3 с. Робот Яндекса исполняет наш JS (замер
    //    23.08.2026, приветствие чат-помощника попало в сниппет 1456 страниц) — то есть
    //    в индекс уехал бы именно подменённый заголовок.
    const title = $('jkTitle');
    // ⛔ `typeof window` — НЕ ПЕРЕСТРАХОВКА. Этот кусок ВЫРЕЗАЕТСЯ ИЗ ФАЙЛА И
    //    ИСПОЛНЯЕТСЯ тестом (tests/JS/jk-h1-city-survives-render.test.js) в голом
    //    `new Function`, где глобального `window` нет вовсе: голая ссылка на него
    //    уронила бы проверку ReferenceError'ом, а сама она про другое.
    if (title && (typeof window === 'undefined' || !window.BRONI_JK_H1_PINNED)) {
      const cityPrep = (title.dataset && title.dataset.cityPrep) ? title.dataset.cityPrep : '';
      const displayName = (title.dataset && title.dataset.displayName) ? title.dataset.displayName : '';
      title.innerHTML = jkDisplayHtml(String(JK.name || '').trim() ? (displayName || JK.name) : '') + (cityPrep ? ' в ' + esc(cityPrep) : '');
    }
    // \u26d4 \u0422\u041e\u041b\u042c\u041a\u041e \u041d\u0410 \u041a\u041e\u041c\u041f\u042c\u042e\u0422\u0415\u0420\u0415. \u0422\u0435\u043b\u0435\u0444\u043e\u043d \u0432\u043b\u0430\u0434\u0435\u043b\u0435\u0446 \u043f\u0440\u043e\u0441\u0438\u043b \u043d\u0435 \u0442\u0440\u043e\u0433\u0430\u0442\u044c: \u0442\u0430\u043c \u043e\u0441\u0442\u0430\u0451\u0442\u0441\u044f
    //    \u043f\u0440\u0435\u0436\u043d\u044f\u044f \u0441\u0442\u0440\u043e\u043a\u0430 \u0441\u043b\u043e\u0432\u043e \u0432 \u0441\u043b\u043e\u0432\u043e, \u0430 110-\u0441\u0442\u0440\u043e\u0447\u043d\u044b\u0439 \u0440\u0430\u0437\u0431\u043e\u0440\u0449\u0438\u043a \u0430\u0434\u0440\u0435\u0441\u0430 \u0432\u043e\u043e\u0431\u0449\u0435 \u043d\u0435
    //    \u0438\u0441\u043f\u043e\u043b\u043d\u044f\u0435\u0442\u0441\u044f.
    // \u26d4 \u0427\u0442\u043e \u0447\u0438\u043d\u0438\u0442 \u0434\u0435\u0441\u043a\u0442\u043e\u043f\u043d\u0430\u044f \u0432\u0435\u0442\u043a\u0430: \u0431\u044b\u043b\u043e \u00ab\u0430\u0434\u0440\u0435\u0441 + ' \u00b7 ' + \u0440\u0430\u0439\u043e\u043d + ' \u0440-\u043d \u00b7 ' +
    //    \u0437\u0430\u0441\u0442\u0440\u043e\u0439\u0449\u0438\u043a\u00bb \u0411\u0415\u0417 \u043f\u0440\u043e\u0432\u0435\u0440\u043e\u043a. \u0423 61 % \u043a\u0430\u0440\u0442\u043e\u0447\u0435\u043a \u0440\u0430\u0439\u043e\u043d \u043f\u0443\u0441\u0442 \u2014 \u0432 \u043f\u043e\u043b\u043e\u0441\u0435 \u0432\u0438\u0441\u0435\u043b\u043e
    //    \u00ab \u00b7 \u0440-\u043d \u00b7 \u00bb, \u0430 \u0437\u0430\u0441\u0442\u0440\u043e\u0439\u0449\u0438\u043a \u043f\u043e\u0432\u0442\u043e\u0440\u044f\u043b \u0441\u043e\u0441\u0435\u0434\u043d\u044e\u044e \u044f\u0447\u0435\u0439\u043a\u0443 \u0442\u043e\u0439 \u0436\u0435 \u043f\u043e\u043b\u043e\u0441\u044b. \u0422\u0435\u043f\u0435\u0440\u044c:
    //    \u043a\u043e\u0440\u043e\u0442\u043a\u0438\u0439 \u0430\u0434\u0440\u0435\u0441 (jkShortAddress \u2014 \u0431\u0435\u0437 \u0441\u0442\u0440\u0430\u043d\u044b, \u043e\u0431\u043b\u0430\u0441\u0442\u0438 \u0438 \u00ab\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u043e\u0433\u043e
    //    \u043e\u043a\u0440\u0443\u0433\u0430\u00bb, \u0431\u0435\u0437 \u0437\u0430\u0434\u0432\u043e\u0435\u043d\u0438\u044f \u0438\u0437 \u0444\u0438\u0434\u0430), \u0440\u0430\u0439\u043e\u043d \u0442\u043e\u043b\u044c\u043a\u043e \u0435\u0441\u043b\u0438 \u043e\u043d \u0433\u043e\u0432\u043e\u0440\u0438\u0442 \u041d\u041e\u0412\u041e\u0415,
    //    \u0437\u0430\u0441\u0442\u0440\u043e\u0439\u0449\u0438\u043a\u0430 \u0432 \u044d\u0442\u0443 \u0441\u0442\u0440\u043e\u043a\u0443 \u043d\u0435 \u0432\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u043c.
    jkApplyStripAddress();
    const statusText = $('jkStatusText'); if (statusText) statusText.textContent = JK.deadlineLabel;

    // Badges
    const badgesEl = $('jkBadges');
    if (badgesEl) {
      badgesEl.innerHTML = JK.badges.map(b => {
        const cls = b.includes('\u0438\u043f\u043e\u0442') ? 'green' : b.includes('\u0441\u0435\u0440\u0442') ? 'gold' : 'red';
        const icon = b.includes('\u0438\u043f\u043e\u0442') ? 'fa-percent' : b.includes('\u0441\u0435\u0440\u0442') ? 'fa-certificate' : 'fa-fire';
        return '<span class="jk-hero-badge jk-hero-badge-' + cls + '"><i class="fas ' + icon + '"></i> ' + esc(b) + '</span>';
      }).join('');
    }

    // Rating
    const ratingEl = $('jkRating');
    if (ratingEl) {
      let html = '';
      var safeRating = parseFloat(JK.rating) || 0;
      var safeReviews = parseInt(JK.reviewsCount, 10) || 0;
      for (let i = 0; i < 5; i++) html += '<span class="' + (i < Math.floor(safeRating) ? 'jk-star-on' : 'jk-star-off') + '">\u2605</span>';
      html += '<b>' + safeRating + '</b>';
      html += '<span class="jk-reviews-link" data-tab="reviews">' + safeReviews + ' \u043e\u0442\u0437\u044b\u0432\u043e\u0432</span>';
      ratingEl.innerHTML = html;
    }

    // Stats
    const sf = $('statFlats'); if (sf) sf.textContent = JK.totalFlats;
    const sfl = $('statFloors'); if (sfl) sfl.textContent = JK.floors;
    const sa = $('statArea'); if (sa) sa.textContent = JK.areaRange;
    // A1.1: hero «Сдача» — SSOT уже отрендерен сервером через BuildStatus VO
    // (готов→label, протухший/пустой срок→«срок уточняется»). НЕ затираем серверное
    // значение сырым JK.deadline — иначе hero «3 кв. 2024» ≠ паспорт «Построен».
    // Заполняем лишь если SSR-ячейка пуста: тогда честное значение через helper
    // (JK без status/progress_pct → fallback на JK.deadline внутри cell()).
    const sd = $('statDeadline');
    if (sd && !sd.textContent.trim() && JK.deadline) {
      sd.textContent = JK.deadline_display !== undefined ? (JK.deadline_display || 'срок уточняется') : (window.BuildStatus
        ? window.BuildStatus.cell(JK.status, JK.deadline, JK.progress_pct)
        : JK.deadline) || JK.deadline;
    }

    // Rooms
    const roomsEl = $('jkRooms');
    if (roomsEl) {
      roomsEl.innerHTML = JK.rooms.map(r =>
        '<div class="jk-room"><i class="fas ' + safeIcon(r.icon || 'fa-door-open') + ' jk-room-icon"></i>' +
        '<span class="jk-room-type">' + esc(r.type) + '</span>' +
        '<span class="jk-room-count">' + (parseInt(r.count, 10) || 0) + '</span>' +
        '<span class="jk-room-price">\u043e\u0442 ' + fmtK(r.priceFrom) + '</span></div>'
      ).join('');
    }

    // Price
    const pf = $('jkPriceFrom'); if (pf) pf.textContent = fmt(JK.priceFrom);
    const pm = $('jkPriceM2'); if (pm) pm.textContent = '\u043e\u0442 ' + JK.priceM2From.toLocaleString('ru') + ' \u20bd/\u043c\xb2';
    const pu = $('jkPriceUpdated'); if (pu) pu.textContent = '\u0426\u0435\u043d\u044b \u043e\u0442 ' + (JK.updatedAt || '') + ' \u043f\u043e \u0434\u0430\u043d\u043d\u044b\u043c \u0437\u0430\u0441\u0442\u0440\u043e\u0439\u0449\u0438\u043a\u0430';

    // FOMO: индикатор изменения цены из price_history (C1)
    if (JK.price_history && JK.price_history.last_change) {
      var lc = JK.price_history.last_change;
      var chg = parseFloat(lc.change_percent) || 0;
      if (chg !== 0 && !document.querySelector('.jk-fomo-inline')) {
        var fomoEl = document.createElement('div');
        fomoEl.className = chg < 0 ? 'jk-fomo-inline jk-fomo-down' : 'jk-fomo-inline jk-fomo-up';
        fomoEl.innerHTML = '<i class="fas ' + (chg < 0 ? 'fa-arrow-trend-down' : 'fa-arrow-trend-up') + '"></i> ' +
          (chg > 0 ? '+' : '') + chg.toFixed(1) + '% за месяц';
        var priceBlock = document.querySelector('.jk-price-left');
        if (priceBlock) priceBlock.appendChild(fomoEl);
      }
    }

    // Monthly payment
    renderMonthlyPayment();

    // Spark chart
    renderSpark();

    // Price change + FOMO (C9)
    renderPriceChange();

    // Promos + call banner
    renderPromos();
    renderCallBanner();

    // Description
    const descEl = $('jkDesc');
    if (descEl) descEl.textContent = JK.description || '';

    // About specs (old section)
    renderAboutSpecs();

    // Documents
    renderDocs();

    // Features
    renderFeatures();

    // FEED-030: расширенные блоки из фидов
    renderFeedInfra();
    renderFeedPromos();
    renderFeedMortgage();
    renderFeedVideo();

    // Expert
    renderExpert();

    // 2.3 (jk-page-redesign): renderCorpus()/renderCorpusProgress() удалены —
    // целились в #jkCorpusList, которого нет в разметке с v2 (мёртвый no-op код);
    // SSR-дубль #jkCorpus тоже удалён, корпуса живут в ленте #jkCorpusStrip (2.2).

    // Genplan + corpus tabs + apartments
    renderGenplan();
    renderCorpusTabs();
    renderApartments();
    renderFlatsAccordion();
    renderFlatsSummary();

    // Mortgage programs
    renderMortgagePrograms();

    // Construction
    renderConstruction();

    // Map label
    const mapName = $('jkMapName'); if (mapName) mapName.textContent = jkDisplay(JK.name) + ' \xb7 ' + JK.address;

    // Schools & kindergartens
    renderSchools();

    // Nearby
    renderNearby();

    // Reviews
    renderReviews();

    // QA
    renderQA();

    // View stats
    renderViewStats();

    // Market comparison + Cadastral (C2)
    renderMarketComparison();
    renderCadastral();

    // AI description (C3)
    renderAiDescription();

    // Landmarks / travel time (C4)
    renderLandmarks();

    // Facts accordion
    renderFacts();

    // Price history (C1) + Chart.js (Phase 4)
    renderPriceHistory();
    initPriceChart();

    // Infrastructure map
    renderInfrastructure();

    // Main map (full-width Yandex Map)
    initMainMap();

    // Рейтинг района (8 пилюль + клик-тултип с топ-3)
    renderDistrictPills();

    // Similar
    renderSimilar();

    // SEO crosslinks
    renderSeoLinks();

    // Manager
    renderManager();

    // Developer sidebar
    renderDeveloper();

    // v2 redesign blocks
    renderSpecs();
    renderInfoHeader();
    renderGalleryTags();
    renderBookingSidebar();
    bindHeroButtons();
    renderMortgageMini();
    renderTimeline();
    initPromoTimer();
    renderReviewsSummary();
    renderHotOffer();

    // Карточка-2026: ответ API только ДОПОЛНЯЕТ уже собранный первый экран
    // (прочерки в ячейках, цена — если сервер её не напечатал, подпись кнопки).
    // ⛔ Отметку ставим ВСЕГДА, а не только когда модуль уже здесь: файл мог не
    //    успеть приехать, и тогда дополнит экран он сам, в BroniJkCardHost.ready.
    jkCardDataArrived = true;
    if (jkCard) jkCard.applyData();

    // Increment view counter
    // jk-audit 2026-05-04 #3 (P1): view-counter — только POST (защита от
    // накрутки через <img src> с чужого сайта).
    //
    // ⛔ БЕЗ _csrf (блок 0.2 realty-feed-guard, 24.09.2026). Сервер проверяет у
    //    просмотра Origin/Referer, лимит и гейт повторов (JkViewCounter), а токен
    //    не трогает. Раньше просмотр шёл через requireCsrf, тот после успеха
    //    МЕНЯЛ токен сессии, и все формы этой вкладки (отзыв, обратная связь,
    //    ипотека) получали ложный 403. Не возвращать токен сюда «для надёжности».
    //
    // ⛔ СО СТРАНИЦЫ КОМНАТНОСТИ ПРОСМОТР НЕ ШЛЁМ (ADR-125, верификация 28.08.2026).
    //    Страниц групп ~570 на 153 дома, и каждая рисуется этим же скриптом: считай мы
    //    просмотр отсюда, счётчик карточки ЖК вырос бы в разы на ровном месте, а
    //    владелец принимает решения по этим числам. Признак страницы группы ОДИН на
    //    весь код — `window.BRONI_JK_ROOMS_PINNED` (его ставит только public/flats.php
    //    на адресе группы); второй признак означал бы два ответа на вопрос «где мы».
    var _isRoomsPage = typeof window !== 'undefined' && !!window.BRONI_JK_ROOMS_PINNED;
    var _viewId = _isRoomsPage ? 0 : (parseInt(JK.id, 10) || 0);
    if (_viewId > 0) {
      fetch('/jk_manager.php', {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        credentials: 'same-origin',
        body: 'action=view&id=' + _viewId
      }).catch(function() {});
    }

    // Init mortgage calc
    const mcPrice = $('mcPrice');
    if (mcPrice) { mcPrice.min = JK.priceFrom; mcPrice.max = JK.priceTo; mcPrice.value = JK.priceFrom; }
    const mcDown = $('mcDown'); if (mcDown) mcDown.value = 15;
    const mcTerm = $('mcTerm'); if (mcTerm) mcTerm.value = 25;
    // jk-audit 2026-05-04 #8 (P2): по умолчанию — программа с МИНИМАЛЬНОЙ ставкой,
    // не magic-index 1. Иначе калькулятор стартует не с лучшего предложения.
    selectedProgram = (JK.mortgagePrograms && JK.mortgagePrograms.length)
      ? JK.mortgagePrograms.reduce(function(min, p) {
          return (p && typeof p.rate === 'number' && p.rate < min.rate) ? p : min;
        }, JK.mortgagePrograms[0])
      : null;
    updateMortgage();
  }

  function renderMonthlyPayment() {
    const el = $('jkMonthly');
    if (!el || !JK || !JK.priceFrom || !JK.mortgagePrograms || !JK.mortgagePrograms.length) return;

    // Лучшая ставка (минимальная)
    const bestProg = JK.mortgagePrograms.reduce(function(a, b) { return a.rate < b.rate ? a : b; });
    const price = JK.priceFrom;
    const downPct = bestProg.minDown || 15;
    const years = 25;
    const monthly = calcMonthly(price, downPct, bestProg.rate, years);
    if (monthly <= 0) return;

    const loanAmount = price * (1 - downPct / 100);
    const totalPaid = monthly * years * 12;
    const overpay = totalPaid - loanAmount;

    const valEl = $('jkMonthlyValue');
    if (valEl) valEl.textContent = monthly.toLocaleString('ru') + ' \u20bd/\u043c\u0435\u0441';

    const detEl = $('jkMonthlyDetails');
    if (detEl) {
      detEl.textContent = bestProg.program + ' ' + bestProg.rate + '% \xb7 ' +
        '\u041f\u0412 ' + downPct + '% \xb7 ' + years + ' \u043b\u0435\u0442 \xb7 ' +
        '\u043f\u0435\u0440\u0435\u043f\u043b\u0430\u0442\u0430 ' + fmt(overpay);
    }

    el.classList.remove('jk-hidden');

    // Клик → переключить на таб ипотека
    const btn = $('jkMonthlyBtn');
    if (btn) {
      btn.addEventListener('click', function() {
        const mortTab = tabsEl ? tabsEl.querySelector('[data-tab="mortgage"]') : null;
        if (mortTab) mortTab.click();
        const pane = $('pane-mortgage');
        if (pane) pane.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function renderSpark() {
    // W7 audit-fix (2026-05-11): backend отдаёт price_history.sparkline (snake_case
    // + nested key). Старый код читал camelCase property — спарк никогда не рендерился.
    const svg = $('jkSpark'); if (!svg || !JK.price_history || !JK.price_history.sparkline) return;
    const data = JK.price_history.sparkline;
    // jk-audit 2026-05-04 #9 (P2): при data.length<2 формула i/(length-1) = 0/0 = NaN,
    // SVG-координаты ломаются. Спарк-график без 2+ точек не имеет смысла.
    if (!Array.isArray(data) || data.length < 2) return;
    var vals = data.map(d => d.p);
    const max = Math.max.apply(null, vals), min = Math.min.apply(null, vals), r = max - min || 1;
    const pts = data.map((d, i) => (i / (data.length - 1)) * 140 + ',' + (38 - ((d.p - min) / r) * 30)).join(' ');
    svg.innerHTML = '<defs><linearGradient id="jkSparkGrad" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#c8a96e" stop-opacity=".2"/><stop offset="100%" stop-color="#c8a96e" stop-opacity="0"/></linearGradient></defs>' +
      '<polygon points="0,42 ' + pts + ' 140,42" fill="url(#jkSparkGrad)"/>' +
      '<polyline points="' + pts + '" fill="none" stroke="#c8a96e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      data.map((d, i) => '<text x="' + (i / (data.length - 1)) * 140 + '" y="50" text-anchor="middle" fill="#444" font-size="7">' + esc(d.m) + '</text>').join('');
    const trend = $('jkTrend'); if (trend) { var tSpan = trend.querySelector('span'); if (tSpan) tSpan.textContent = '+4.3% \u0437\u0430 6 \u043c\u0435\u0441.'; }
  }

  // ═══ PRICE CHANGE BADGE + FOMO (C9) ═══
  function renderPriceChange() {
    const badge = $('jkPriceChange');
    const fomoEl = $('jkFomo');
    if (!JK) return;

    const pc = JK.price_change;
    if (badge && pc && pc.change_percent) {
      const pct = pc.change_percent;
      const isDown = pc.direction === 'down';
      const icon = isDown ? 'fa-arrow-trend-down' : 'fa-arrow-trend-up';
      const colorClass = isDown ? 'green' : 'red';
      const sign = pct > 0 ? '+' : '';

      badge.className = 'jk-price-change jk-price-change-' + colorClass;
      badge.innerHTML =
        '<i class="fas ' + icon + '"></i> ' +
        '<span>' + sign + pct + '% ' + esc(pc.period || '') + '</span>';
    }

    const viewers = parseInt(JK.recent_viewers, 10) || 0;
    if (fomoEl && (viewers >= 3 || (pc && pc.direction === 'down'))) {
      const parts = [];
      if (pc && pc.direction === 'down') {
        parts.push('<span class="jk-fomo-badge jk-fomo-badge-hot"><i class="fas fa-fire"></i> \u0426\u0435\u043d\u0430 \u0441\u043d\u0438\u0437\u0438\u043b\u0430\u0441\u044c!</span>');
      }
      if (viewers >= 3) {
        parts.push('<span class="jk-fomo-viewers"><i class="fas fa-eye"></i> ' + viewers + ' \u0447\u0435\u043b. \u0441\u043c\u043e\u0442\u0440\u044f\u0442 \u0441\u0435\u0439\u0447\u0430\u0441</span>');
      }
      if (parts.length) {
        fomoEl.innerHTML = parts.join('');
        fomoEl.classList.remove('jk-hidden');
      }
    }
  }

  function renderPromos() {
    const el = $('jkPromos'); if (!el || !JK.promos) return;
    el.innerHTML = JK.promos.map(p => {
      const c = safeColor(p.color);
      return '<div class="jk-promo" style="border-color:' + c + '33">' +
      '<div class="jk-promo-icon" style="color:' + c + '"><i class="fas ' + safeIcon(p.icon || 'fa-fire') + '"></i></div>' +
      '<div><div class="jk-promo-title" style="color:' + c + '">' + esc(p.title) + '</div>' +
      '<div class="jk-promo-desc">' + esc(p.desc) + '</div>' +
      '<div class="jk-promo-deadline" style="color:' + c + '"><i class="fas fa-clock"></i> \u0434\u043e ' + esc(p.deadline) + '</div></div></div>';
    }).join('');
  }

  function renderCallBanner() {
    var banner = $('jkCallBanner');
    if (!banner || !JK || !JK.promos || !JK.promos.length) return;
    banner.classList.remove('jk-hidden');
    var btn = $('jkCallBannerBtn');
    if (btn) btn.addEventListener('click', function() { window.location.href = 'tel:+79191701918'; });
  }

  function renderAboutSpecs() {
    const el = $('jkAboutSpecs'); if (!el) return;
    const specs = [
      ['fa-building', JK.developer, 'Застройщик'],
      ['fa-gem', JK.class, 'Класс'],
      ['fa-cubes', JK.buildingType, 'Тип здания'],
      ['fa-arrow-up-9-1', JK.floors, 'Этажность'],
      ['fa-arrows-up-down', JK.ceiling_text || (JK.ceilingHeight ? JK.ceilingHeight + ' м' : null), 'Потолки'],
      ['fa-square-parking', JK.parking, 'Парковка'],
      ['fa-file-contract', JK.contract_type, 'Тип договора'],
      ['fa-shield-halved', JK.escrow ? 'ДДУ с эскроу' : null, 'Покупка'],
      ['fa-rotate', JK.tradeIn ? 'Да' : null, 'Трейд-ин'],
    ];
    el.innerHTML = specs.filter(([, v]) => v).map(([ic, v, l]) =>
      '<div class="jk-spec"><span class="jk-spec-label"><i class="fas ' + ic + '"></i> ' + esc(l) + '</span><span class="jk-spec-value">' + esc(String(v)) + '</span></div>'
    ).join('');
  }

  function renderDocs() {
    const el = $('jkDocs'); if (!el || !JK.documents) return;
    el.innerHTML = JK.documents.map(d =>
      '<div class="jk-doc"><i class="fas fa-file-pdf jk-doc-icon"></i><span class="jk-doc-name">' + esc(d.name) + '</span>' +
      '<span class="jk-doc-size">PDF ' + esc(d.size) + '</span><span class="jk-doc-dl"><i class="fas fa-download"></i> \u0421\u043a\u0430\u0447\u0430\u0442\u044c</span></div>'
    ).join('');
  }

  function renderFeatures() {
    const el = $('jkFeatures'); if (!el || !JK.features) return;
    el.innerHTML = JK.features.map(f =>
      '<div class="jk-feature"><i class="fas ' + safeIcon(f.icon || 'fa-check') + '"></i> ' + esc(f.name) + '</div>'
    ).join('');
  }

  // FEED-030 / jk-redesign 6.1: дворовая инфра застройщика — фирменные золотые чипы
  function renderFeedInfra() {
    const el = $('jkFeedInfra'); if (!el || !JK.infrastructure || !JK.infrastructure.length) return;
    // 6.1: добавлены playground/sports_ground/security (данные neometriaYardInfra, блок 6.0)
    var infraIcons = {school:'fa-school',kindergarten:'fa-child-reaching',playground:'fa-baseball',sports_ground:'fa-futbol',security:'fa-shield-halved',hospital:'fa-hospital',mall:'fa-bag-shopping',park:'fa-tree-city',sport:'fa-dumbbell',pharmacy:'fa-prescription-bottle-medical',bank:'fa-building-columns',restaurant:'fa-utensils',supermarket:'fa-cart-shopping',tram:'fa-train-tram',university:'fa-graduation-cap',cafe:'fa-mug-hot',bus_stop:'fa-bus',highway:'fa-road',metro:'fa-subway',train:'fa-train'};
    el.innerHTML = JK.infrastructure.map(function(item) {
      var name = typeof item === 'string' ? item : (item.name || '');
      if (!name) return '';
      var type = typeof item === 'string' ? '' : (item.type || '');
      var icon = infraIcons[type] || 'fa-location-dot';
      return '<span class="jk-yard-chip"><i class="fas ' + safeIcon(icon) + '" aria-hidden="true"></i>' + esc(name) + '</span>';
    }).join('');
    var sec = $('jkFeedInfraSection'); if (sec) sec.classList.remove('jk-hidden');
  }

  // FEED-030: Акции застройщика
  function renderFeedPromos() {
    const el = $('jkFeedPromos'); if (!el || !JK.promotions || !JK.promotions.length) return;
    el.innerHTML = JK.promotions.map(function(p) {
      var name = typeof p === 'string' ? p : (p.name || p.title || '');
      var desc = typeof p === 'string' ? '' : (p.description || '');
      var end = typeof p === 'string' ? '' : (p.end_date || p.deadline || '');
      return '<div class="jk-feed-promo">' +
        '<div class="jk-feed-promo-icon"><i class="fas fa-gift"></i></div>' +
        '<div class="jk-feed-promo-body">' +
        '<div class="jk-feed-promo-title">' + esc(name) + '</div>' +
        (desc ? '<div class="jk-feed-promo-desc">' + esc(desc) + '</div>' : '') +
        (end ? '<div class="jk-feed-promo-deadline"><i class="fas fa-clock"></i> до ' + esc(end) + '</div>' : '') +
        '</div></div>';
    }).join('');
    var sec = $('jkFeedPromosSection'); if (sec) sec.classList.remove('jk-hidden');
  }

  // FEED-030: Ипотечные программы из фида
  function renderFeedMortgage() {
    const el = $('jkFeedMortgage'); if (!el || !JK.mortgage_programs || !JK.mortgage_programs.length) return;
    el.innerHTML = JK.mortgage_programs.map(function(m) {
      var name = typeof m === 'string' ? m : (m.name || 'Ипотека');
      var rate = typeof m === 'string' ? '' : (m.rate || '');
      var downpayment = typeof m === 'string' ? '' : (m.downpayment || m.min_downpayment || '');
      return '<div class="jk-feed-mortgage-card">' +
        '<div class="jk-feed-mortgage-name">' + esc(name) + '</div>' +
        (rate ? '<div class="jk-feed-mortgage-rate"><i class="fas fa-percent"></i> от ' + esc(String(rate)) + '%</div>' : '') +
        (downpayment ? '<div class="jk-feed-mortgage-down"><i class="fas fa-coins"></i> ПВ от ' + esc(String(downpayment)) + '%</div>' : '') +
        '</div>';
    }).join('');
    var sec = $('jkFeedMortgageSection'); if (sec) sec.classList.remove('jk-hidden');
  }

  // FEED-030: Видео ЖК
  // jk-audit 2026-05-04 #1 (P0 XSS): video_url из БД может быть `javascript:alert(1)`.
  // esc() HTML-кодирует, но не блокирует javascript:-схему. Защита через safeUrl whitelist.
  function renderFeedVideo() {
    const el = $('jkFeedVideo'); if (!el || !JK.video_url) return;
    var url = JK.video_url;
    // Поддержка YouTube embed (короткие ID не имеют схемы — обрабатываем ДО safeUrl).
    var ytMatch = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([a-zA-Z0-9_-]{11})/);
    if (ytMatch) {
      el.innerHTML = '<div class="jk-feed-video-wrap"><iframe src="https://www.youtube.com/embed/' + esc(ytMatch[1]) + '" frameborder="0" allowfullscreen loading="lazy" title="Видео ЖК"></iframe></div>';
    } else {
      // Whitelist http(s) — javascript:/data:/vbscript: блокируются.
      var safeFn = window.safeUrl || function(u) { return /^https?:\/\//i.test(String(u || '')) ? String(u) : ''; };
      var safeHref = safeFn(url, '');
      if (!safeHref) {
        if (window.console && console.warn) console.warn('[jk] Blocked non-http(s) video URL:', url);
        return;
      }
      el.innerHTML = '<a href="' + esc(safeHref) + '" target="_blank" rel="noopener" class="jk-feed-video-link"><i class="fas fa-play-circle"></i> Смотреть видео</a>';
    }
    var sec = $('jkFeedVideoSection'); if (sec) sec.classList.remove('jk-hidden');
  }

  function renderExpert() {
    const el = $('jkExpert'); if (!el || !JK.expert) return;
    const e = JK.expert;
    el.innerHTML = '<div class="jk-expert-header"><div class="jk-expert-avatar">' + esc(e.name.split(' ').map(w => w[0]).join('')) + '</div>' +
      '<div><div class="jk-expert-name">' + esc(e.name) + '</div><div class="jk-expert-role"><i class="fas fa-user-tie ico-xs ico-gold"></i> ' + esc(e.role) + '</div></div></div>' +
      '<div class="jk-expert-text">' + esc(e.text) + '</div>';
  }

  // 2.3 (jk-page-redesign): renderCorpus() + renderCorpusProgress() удалены.
  // Обе рендерили в #jkCorpusList, существовавший только в v1-шаблоне
  // (jk_content_v1_backup.php) — с v2 обе были no-op (guard if(!el) return).
  // Чужих обработчиков внутри не было (урок R4.1 — проверено): только DOM-сборка
  // и локальный IntersectionObserver на собственный progressEl.

  // ⚠️ jk-smart-filter 1.7.4 — СТАРАЯ механика секции «Квартиры» (карточки типов
  // → планировки → квартиры) на проде БОЛЬШЕ НЕ РЕНДЕРИТСЯ: её заменил умный
  // фильтр (js/jk-filter.js + js/jk-filter-results.js), а разметка убрана под
  // флаг $jkFlatsLegacyCards в public/jk.php.
  //
  // Код ниже (renderApartments / renderCorpusTabs / renderFlatsSummary /
  // renderFlatsAccordion / renderFloorplans / filterTypesByCorpus + делегаты
  // .jk-apt-filter / .jk-filter-btn / .jk-flat-row) НАМЕРЕННО оставлен: он и есть
  // то, что оживает при откате флага в true. Каждая функция начинается с guard'а
  // по своему узлу, поэтому при выключённом флаге все они — тихие no-op'ы.
  // Физический снос — отдельным блоком после недели наблюдения за конверсией;
  // удалять по частям нельзя, иначе «откат одним коммитом» перестанет быть
  // откатом.
  function renderApartments() {
    const body = $('jkAptBody'); if (!body || !JK.apartments) return;
    const filtered = aptFilter === 'all' ? JK.apartments : JK.apartments.filter(a => a.rooms === aptFilter);
    const visible = showAllApts ? filtered : filtered.slice(0, 4);

    // DOM-009: DocumentFragment вместо innerHTML (вызывается на каждый клик фильтра)
    const frag = document.createDocumentFragment();
    for (let i = 0; i < visible.length; i++) {
      const a = visible[i];
      const tr = document.createElement('tr');
      const tdRooms = document.createElement('td'); tdRooms.style.fontWeight = '700'; tdRooms.textContent = a.rooms;
      const tdArea = document.createElement('td'); tdArea.textContent = a.area + ' \u043c\xb2';
      const tdFloor = document.createElement('td'); tdFloor.textContent = a.floor + '/' + a.floors;
      const tdCorpus = document.createElement('td'); tdCorpus.textContent = a.corpus;
      const tdPrice = document.createElement('td'); tdPrice.className = 'jk-apt-price';
      if (a.price_old && a.price_old > a.price) {
        const oldSpan = document.createElement('span'); oldSpan.className = 'jk-apt-price-old'; oldSpan.textContent = fmt(a.price_old);
        const newSpan = document.createElement('span'); newSpan.textContent = fmt(a.price);
        tdPrice.append(oldSpan, ' ', newSpan);
      } else {
        tdPrice.textContent = fmt(a.price);
      }
      const tdDecor = document.createElement('td'); tdDecor.className = 'jk-apt-decor'; tdDecor.textContent = a.decoration || '—';
      const tdStatus = document.createElement('td');
      const span = document.createElement('span');
      span.className = 'jk-apt-status jk-apt-status-' + a.status;
      span.textContent = a.status === 'sale' ? '\u0412 \u043f\u0440\u043e\u0434\u0430\u0436\u0435' : '\u0411\u0440\u043e\u043d\u044c';
      tdStatus.appendChild(span);
      tr.append(tdRooms, tdArea, tdFloor, tdCorpus, tdDecor, tdPrice, tdStatus);
      // Фаза 1: кликабельные строки → страница квартиры
      if (a.id) {
        tr.style.cursor = 'pointer';
        tr.dataset.flatId = a.id;
        tr.addEventListener('click', () => { window.location = '/flat.php?id=' + a.id; });
      }
      frag.appendChild(tr);
    }
    body.textContent = ''; // Быстрая очистка
    body.appendChild(frag);

    const more = $('jkAptMore');
    if (more) {
      more.style.display = filtered.length > 4 ? 'flex' : 'none';
      more.innerHTML = showAllApts ? '<i class="fas fa-chevron-up ico"></i>\u0421\u0432\u0435\u0440\u043d\u0443\u0442\u044c' : '<i class="fas fa-chevron-down ico"></i>\u0412\u0441\u0435 ' + filtered.length + ' \u043a\u0432\u0430\u0440\u0442\u0438\u0440';
    }
    // Фаза 1: ссылка «Все квартиры ЖК» в каталоге
    let allLink = $('jkAptAllLink');
    if (!allLink && JK && JK.city && JK.id) {
      allLink = document.createElement('a');
      allLink.id = 'jkAptAllLink';
      allLink.className = 'jk-apt-all-link';
      allLink.href = '/flats.php?city=' + encodeURIComponent(JK.city) + '&building_id=' + JK.id;
      allLink.textContent = '\u2192 \u0412\u0441\u0435 ' + filtered.length + ' \u043a\u0432\u0430\u0440\u0442\u0438\u0440 \u044d\u0442\u043e\u0433\u043e \u0416\u041a \u0432 \u043a\u0430\u0442\u0430\u043b\u043e\u0433\u0435';
      const aptSection = body.closest('.jk-tab-pane') || body.parentElement;
      if (aptSection) aptSection.appendChild(allLink);
    } else if (allLink) {
      allLink.textContent = '\u2192 \u0412\u0441\u0435 ' + filtered.length + ' \u043a\u0432\u0430\u0440\u0442\u0438\u0440 \u044d\u0442\u043e\u0433\u043e \u0416\u041a \u0432 \u043a\u0430\u0442\u0430\u043b\u043e\u0433\u0435';
    }
    // Filters (однократно)
    const filtersEl = $('jkAptFilters');
    if (filtersEl && !filtersEl.children.length) {
      const filterFrag = document.createDocumentFragment();
      // jk-audit 2026-05-18 #1 (P0): case mismatch с parseRooms() — 'Студия' (uppercase 'С')
      // должна совпадать со значением из jk_manager.php parseRooms() для строгого === на line 1057.
      ['all', '\u0421\u0442\u0443\u0434\u0438\u044f', '1-\u043a\u043e\u043c\u043d.', '2-\u043a\u043e\u043c\u043d.', '3-\u043a\u043e\u043c\u043d.'].forEach(f => {
        const btn = document.createElement('button');
        btn.className = 'jk-apt-filter' + (f === aptFilter ? ' active' : '');
        btn.dataset.filter = f;
        btn.textContent = f === 'all' ? '\u0412\u0441\u0435' : f;
        filterFrag.appendChild(btn);
      });
      filtersEl.appendChild(filterFrag);
    }
  }

  // ═══ GENPLAN (ЦИАН-стиль, Phase 4) ═══
  function renderGenplan() {
    var container = $('jkGenplan');
    var section = $('jkGenplanSection');
    if (!container || !JK || !JK.genplan_url) return;
    if (section) section.classList.remove('jk-hidden');

    var img = document.createElement('img');
    img.className = 'jk-genplan__img';
    img.src = standSrc(JK.genplan_url, 1200);
    img.alt = 'Генплан ' + (JK.name || '');
    img.loading = 'lazy';
    container.appendChild(img);

    // Corpus markers on genplan
    if (JK.corpuses && JK.corpuses.length) {
      JK.corpuses.forEach(function(c) {
        if (!c.genplan_x || !c.genplan_y) return;
        var marker = document.createElement('div');
        marker.className = 'jk-genplan__marker';
        marker.style.left = c.genplan_x + '%';
        marker.style.top = c.genplan_y + '%';
        marker.textContent = c.name || c.id;
        marker.title = 'Корпус ' + (c.name || c.id);
        marker.addEventListener('click', function() {
          var flats = $('jkFlats');
          if (flats) flats.scrollIntoView({ behavior: 'smooth' });
          setCorpusFilter(c.name || c.id);
        });
        container.appendChild(marker);
      });
    }
  }

  // ═══ CORPUS TABS (ЦИАН-стиль, Phase 4) ═══
  var corpusFilter = 'all';

  function setCorpusFilter(corpus) {
    corpusFilter = corpus;
    var tabs = $('jkCorpusTabs');
    if (tabs) tabs.querySelectorAll('.jk-corpus-tab').forEach(function(t) {
      t.classList.toggle('active', t.dataset.corpus === corpus);
    });
    // 2.2 (jk-page-redesign): синхронизируем active-состояние ленты корпусов
    // (золотая рамка выбранного) — фильтр общий для табов/генплана/ленты.
    if (corpusStripEl) corpusStripEl.querySelectorAll('.jk-corpus-strip__card').forEach(function(c) {
      c.classList.toggle('active', c.dataset.corpus === corpus);
    });
    renderFlatsAccordion();
    renderFlatsSummary();
  }

  // ═══ ЛЕНТА КОРПУСОВ (jk-page-redesign 2.2) — server-rendered #jkCorpusStrip ═══
  // Карточка ленты дёргает ТОТ ЖЕ корпус-фильтр (setCorpusFilter) + плавно
  // скроллит к #jkFlats. Повторный клик по активной карточке — сброс ('all').
  // data-corpus-alias — сырые section-имена stale-хвостов, слитых в карточку на
  // бэке (CorpusStrip::build, дедуп по displayName): corpusMatches() матчит
  // квартиру и по primary-имени, и по алиасам, чтобы счётчик карточки совпадал
  // с числом квартир после фильтра. Метрика corpus_card_click — data-ym делегат.
  var corpusStripEl = $('jkCorpusStrip');
  var corpusAliasMap = {};
  if (corpusStripEl) {
    corpusStripEl.querySelectorAll('.jk-corpus-strip__card').forEach(function(card) {
      if (card.dataset.corpusAlias) corpusAliasMap[card.dataset.corpus] = card.dataset.corpusAlias.split('||');
    });
    corpusStripEl.addEventListener('click', function(e) {
      var card = e.target.closest('.jk-corpus-strip__card');
      if (!card) return;
      var wasActive = card.classList.contains('active');
      setCorpusFilter(wasActive ? 'all' : card.dataset.corpus);
      if (!wasActive) {
        var flats = $('jkFlats');
        // fix-раунд 2.2: уважение prefers-reduced-motion (плавный скролл — анимация)
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (flats) flats.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  // Квартира (её сырой corpus = map_flats.section) попадает под текущий фильтр?
  function corpusMatches(sectionValue) {
    if (corpusFilter === 'all') return true;
    if (sectionValue === corpusFilter) return true;
    var alias = corpusAliasMap[corpusFilter];
    return !!(alias && alias.indexOf(sectionValue) !== -1);
  }

  // Человеческая метка корпуса для счётчиков («4» → «Корпус 4», иначе как есть).
  function corpusLabel(name) {
    return /^\d+$/.test(name) ? 'Корпус ' + name : name;
  }

  function renderCorpusTabs() {
    // J2/J3: при группировке по типам планировок корпус-табы не применимы
    // (тип охватывает несколько корпусов) — корпус виден в строке этажа модалки.
    if (JK && Array.isArray(JK.floorplansByType) && JK.floorplansByType.length) return;
    var container = $('jkCorpusTabs');
    if (!container || !JK || !JK.apartments || !JK.apartments.length) return;

    // Extract unique corpuses (skip placeholder '—')
    var corpusMap = {};
    JK.apartments.forEach(function(a) {
      if (!a.corpus || a.corpus === '—' || a.corpus === '') return;
      if (!corpusMap[a.corpus]) corpusMap[a.corpus] = { name: a.corpus, count: 0 };
      corpusMap[a.corpus].count++;
    });
    var corpusList = Object.values(corpusMap);
    // Sort numerically
    corpusList.sort(function(a, b) {
      var na = parseInt(a.name), nb = parseInt(b.name);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      return a.name.localeCompare(b.name);
    });
    if (corpusList.length < 2) return;

    container.classList.remove('jk-hidden');
    var frag = document.createDocumentFragment();

    // "Все корпуса" tab
    var allBtn = document.createElement('button');
    allBtn.className = 'jk-corpus-tab active';
    allBtn.dataset.corpus = 'all';
    allBtn.textContent = 'Все корпуса';
    frag.appendChild(allBtn);

    var deadline = JK.deadlineLabel !== undefined ? JK.deadlineLabel : (JK.deadline || '');

    corpusList.forEach(function(c) {
      var btn = document.createElement('button');
      btn.className = 'jk-corpus-tab';
      btn.dataset.corpus = c.name;
      // Label: "Корпус N" if name is a number, otherwise as-is
      var label = /^\d+$/.test(c.name) ? 'Корпус ' + c.name : c.name;
      btn.innerHTML = '<span class="jk-corpus-tab__name">' + esc(label) + '</span>' +
        (deadline ? '<span class="jk-corpus-tab__deadline">' + esc(deadline) + '</span>' : '');
      frag.appendChild(btn);
    });

    container.appendChild(frag);
    container.addEventListener('click', function(e) {
      var btn = e.target.closest('.jk-corpus-tab');
      if (!btn) return;
      setCorpusFilter(btn.dataset.corpus);
    });
  }

  // ═══ FLATS SUMMARY (ЦИАН-стиль, Phase 4) ═══
  function renderFlatsSummary() {
    var summary = $('jkFlatsSummary');
    if (!summary || !JK || !JK.apartments || !JK.apartments.length) return;
    summary.classList.remove('jk-hidden');

    // N5 fix-раунд: «Всего N квартир» — только в продаже (синхронно с #jkFlatsTotal
    // и сайдбаром); reserved не в счётчике, но видимы в списках с плашкой.
    var summaryFlats = JK.apartments.filter(function(a) { return isForSaleStatus(a.status); });
    var count = summaryFlats.length;
    if (corpusFilter !== 'all') {
      // 2.2: матчим и алиасы слитых stale-хвостов (corpusMatches), не только ===.
      count = summaryFlats.filter(function(a) { return corpusMatches(a.corpus); }).length;
    }
    var countEl = $('jkFlatsSummaryCount');
    if (countEl) countEl.textContent = count;

    // F.4 (14.08.2026): переписывание href у #jkFlatsAllLink УБРАНО. Сервер печатает
    // канонический адрес страницы квартир (JkUrl, ЧПУ), а этот код затирал его старым
    // `/flats.php?city=…&building_id=…`. Яндекс исполняет JS — значит робот видел
    // именно переписанный адрес, то есть ссылку на 301, и серверная правка F.4 до него
    // бы не доехала. Город в адресе не нужен: страница резолвит ЖК по своему пути.
  }

  // ═══ FLOORPLANS BY TYPE (план jk-card-accuracy, J2/J3; J6 — DRY shared module) ═══
  // J6: рендер карточек-типов + модалка вариаций + зум чертежа вынесены в ОБЩИЙ модуль
  // js/floorplans.js (window.BroniFloorplans), переиспользуемый каталогом одного ЖК на
  // flats.php (НЕ копипаст — единый код). Здесь осталась тонкая обёртка: счётчики секции
  // «Квартиры» (jk-специфичный DOM jkFlatsTotal/jkFlatsSubcount) + делегирование отрисовки
  // сетки/модалки общему модулю. true = есть типы планировок (renderFlatsAccordion отдаёт
  // им приоритет над группировкой по комнатности).
  // 2.2 (jk-page-redesign): корпус-фильтр в режиме «планировки по типам».
  // floorplansByType перекрывает аккордеон (renderFloorplans first) — без этой
  // пересборки клик по карточке ленты корпусов ВИЗУАЛЬНО ничего не менял бы.
  // Типы пересобираются из floors[].section (сырой map_flats.section в каждой
  // квартире планировки): floors фильтруются corpusMatches, счётчики/«от»-агрегаты
  // планировки и типа пересчитываются, пустые планировки/типы выпадают.
  // N5 fix-раунд: «в продаже» для счётчиков и «от X ₽». Универсально для двух
  // источников статуса: сырой map_flats ('available'/'reserved'/'sold') и
  // нормализованный JK.apartments ('sale'/'reserved'). Пустой статус = в продаже
  // (легаси-данные без lifecycle).
  function isForSaleStatus(status) {
    var st = String(status == null ? '' : status).toLowerCase();
    return st === '' || st === 'available' || st === 'sale';
  }

  function filterTypesByCorpus(types) {
    if (corpusFilter === 'all') return types;
    var out = [];
    types.forEach(function(t) {
      var plans = [];
      (Array.isArray(t.plans) ? t.plans : []).forEach(function(p) {
        var floors = (Array.isArray(p.floors) ? p.floors : []).filter(function(fl) {
          return corpusMatches(String(fl.section == null ? '' : fl.section).trim());
        });
        if (!floors.length) return;
        // N5 fix-раунд: счётчик и цены пересобранной планировки — только available
        // (синхронно с бэком FloorplanGrouper); диапазон площадей — все этажи.
        var availFloors = floors.filter(function(fl) { return isForSaleStatus(fl.status); });
        var prices = availFloors.map(function(f) { return Number(f.price) || 0; }).filter(function(n) { return n > 0; });
        var areas = floors.map(function(f) { return Number(f.area) || 0; }).filter(function(n) { return n > 0; });
        plans.push(Object.assign({}, p, {
          floors: floors,
          count: availFloors.length,
          price_min: prices.length ? Math.min.apply(null, prices) : null,
          price_max: prices.length ? Math.max.apply(null, prices) : null,
          area_min: areas.length ? Math.min.apply(null, areas) : p.area_min,
          area_max: areas.length ? Math.max.apply(null, areas) : p.area_max,
        }));
      });
      if (!plans.length) return;
      var flatsCount = plans.reduce(function(s, p) { return s + p.count; }, 0);
      var priceFroms = plans.map(function(p) { return Number(p.price_min) || 0; }).filter(function(v) { return v > 0; });
      var areaFroms = plans.map(function(p) { return Number(p.area_min) || 0; }).filter(function(v) { return v > 0; });
      out.push(Object.assign({}, t, {
        plans: plans,
        plans_count: plans.length,
        flats_count: flatsCount,
        price_from: priceFroms.length ? Math.min.apply(null, priceFroms) : null,
        area_from: areaFroms.length ? Math.min.apply(null, areaFroms) : t.area_from,
      }));
    });
    return out;
  }

  function renderFloorplans() {
    var container = $('jkFlatsAccordion');
    if (!container || !JK || !Array.isArray(JK.floorplansByType) || !JK.floorplansByType.length) return false;
    if (!window.BroniFloorplans || typeof window.BroniFloorplans.render !== 'function') return false;

    var types = filterTypesByCorpus(JK.floorplansByType);
    // Защитный откат: фильтр не должен опустошить секцию (например, рассинхрон
    // имени секции) — показываем все типы, лента лишь не сузит выдачу.
    if (!types.length) types = JK.floorplansByType;
    var total = types.reduce(function(s, t) { return s + (Number(t.flats_count) || 0); }, 0);

    var totalEl = $('jkFlatsTotal');
    if (totalEl) totalEl.textContent = total;
    var subcount = $('jkFlatsSubcount');
    if (subcount) {
      subcount.textContent = types.length + ' ' +
        pluralize(types.length, 'тип планировки', 'типа планировок', 'типов планировок') +
        ' \xb7 ' + total + ' ' + flatsPlural(total) +
        (corpusFilter !== 'all' ? ' \xb7 ' + corpusLabel(corpusFilter) : '');
    }

    return window.BroniFloorplans.render(container, types);
  }

  // ═══ FLATS TABLE (ЦИАН-стиль, Phase 10) ═══
  function renderFlatsAccordion() {
    // I2/I3: если бэк отдал сгруппированные планировки — рисуем их (1 карточка на
    // уникальную планировку + аккордеон этажей) вместо группировки по комнатности.
    if (renderFloorplans()) return;
    var container = $('jkFlatsAccordion');
    if (!container || !JK || !JK.apartments || !JK.apartments.length) return;

    var flats = JK.apartments;
    if (corpusFilter !== 'all') {
      // 2.2: матчим и алиасы слитых stale-хвостов (corpusMatches), не только ===.
      flats = flats.filter(function(a) { return corpusMatches(a.corpus); });
    }

    // N5 fix-раунд: счётчики секции — только «в продаже» (совпадают с сайдбаром
    // «N в продаже»); reserved-карточки остаются в сетке с плашкой «Забронирована».
    var availTotal = flats.filter(function(a) { return isForSaleStatus(a.status); }).length;

    // Update total count
    var totalEl = $('jkFlatsTotal');
    if (totalEl) totalEl.textContent = availTotal;

    // Update subcount
    var subcount = $('jkFlatsSubcount');
    if (subcount) subcount.textContent = availTotal + ' ' + flatsPlural(availTotal) + (corpusFilter !== 'all' ? ' · ' + corpusLabel(corpusFilter) : '');

    // Group by room type
    var groups = {};
    var groupOrder = [];
    flats.forEach(function(f) {
      var key = f.rooms || 'Другое';
      if (!groups[key]) {
        groups[key] = { type: key, items: [], minPrice: Infinity, maxPrice: 0, minArea: Infinity };
        groupOrder.push(key);
      }
      groups[key].items.push(f);
      // N5: диапазон цен группы — только свободные (reserved не в min-ценах).
      if (isForSaleStatus(f.status)) {
        if (f.price > 0 && f.price < groups[key].minPrice) groups[key].minPrice = f.price;
        if (f.price > 0 && f.price > groups[key].maxPrice) groups[key].maxPrice = f.price;
      }
      if (f.area > 0 && f.area < groups[key].minArea) groups[key].minArea = f.area;
    });

    if (!groupOrder.length) {
      container.innerHTML = '<div class="jk-accordion-empty">Нет квартир по выбранным параметрам</div>';
      return;
    }

    // Build ЦИАН-style table rows
    var frag = document.createDocumentFragment();
    groupOrder.forEach(function(key) {
      var g = groups[key];
      // N5 fix-раунд: «N предложений» группы — только в продаже (без reserved).
      var availCnt = g.items.filter(function(f) { return isForSaleStatus(f.status); }).length;

      var row = document.createElement('div');
      row.className = 'jk-flat-row';
      row.setAttribute('role', 'button');
      row.setAttribute('tabindex', '0');
      row.dataset.type = key;

      var priceMin = g.minPrice < Infinity ? fmtShort(g.minPrice) : '—';
      var priceMax = g.maxPrice > 0 ? fmtShort(g.maxPrice) : '';
      var priceRange = priceMin === priceMax || !priceMax ? priceMin : priceMin + '–' + priceMax;

      var roomStr = String(key);
      var roomMatch = roomStr.match(/\d+/);
      var roomClass = /студ/i.test(roomStr) ? 'studio' : (roomMatch ? 'r' + Math.min(5, parseInt(roomMatch[0], 10)) : 'other');
      var roomIcon = /студ/i.test(roomStr) ? 'fa-couch' : (roomMatch && parseInt(roomMatch[0], 10) >= 4 ? 'fa-house' : 'fa-bed');
      row.dataset.room = roomClass;

      row.innerHTML =
        '<div class="jk-flat-row__type">' +
          '<span class="jk-flat-row__icon"><i class="fas ' + roomIcon + '"></i></span>' +
          '<span class="jk-flat-row__label">' + esc(g.type) + '</span>' +
        '</div>' +
        '<div class="jk-flat-row__area"><i class="fas fa-ruler-combined"></i><span>От ' + g.minArea.toFixed(0) + ' м²</span></div>' +
        '<div class="jk-flat-row__price"><span class="jk-flat-row__price-value">' + priceRange + '</span></div>' +
        '<div class="jk-flat-row__count">' +
          // N5 fix-раунд: чип «N предложений» — только в продаже; 0 available →
          // «Нет в продаже» (консистентно с CorpusStrip-фантомами). Reserved-карточки
          // при этом видимы в развёртке с плашкой.
          '<span class="jk-flat-row__chip">' + (availCnt > 0 ? availCnt + ' ' + pluralize(availCnt, 'предложение', 'предложения', 'предложений') : 'Нет в продаже') + '</span>' +
          '<i class="fas fa-chevron-down jk-flat-row__arrow"></i>' +
        '</div>';

      // Expanded body with flat cards
      var body = document.createElement('div');
      body.className = 'jk-flat-row__body';

      var grid = document.createElement('div');
      grid.className = 'jk-flats-grid';

      var visible = g.items.slice(0, 6);
      visible.forEach(function(f) {
        var card = document.createElement('div');
        card.className = 'jk-flat-card';
        if (f.id) { card.dataset.flatId = f.id; card.style.cursor = 'pointer'; }
        var priceHtml = '';
        // 6.1bcdef fix-раунд (P2 data-верификатора): floor + порог 3% — паритет с SSOT
        // FlatDiscount (PHP) и каталогом 5.1; Math.round без порога давал −1%/−2% и ±1 п.п.
        var discount = (f.price_old && f.price_old > f.price && f.price > 0)
          ? Math.floor((f.price_old - f.price) / f.price_old * 100) : 0;
        if (discount >= 3) {
          priceHtml = '<div class="jk-flat-card__price-old">' + fmt(f.price_old) + '</div>' +
            '<div class="jk-flat-card__price">' + (f.price > 0 ? fmt(f.price) : '—') +
            '<span class="jk-flat-card__discount">-' + discount + '%</span></div>';
        } else {
          priceHtml = '<div class="jk-flat-card__price">' + (f.price > 0 ? fmt(f.price) : '—') + '</div>';
        }
        // Security hotfix 2026-05-23 (claude_full audit CRITICAL #3): defence-in-depth
        // против stored-XSS из feed-данных. Числовые поля (area/floor/floors/living_area)
        // приводим к Number; если NaN — '—'. Так даже если feed подсунет '10<svg>',
        // отрисуется безопасное число или плейсхолдер. Строковые поля
        // (rooms/decoration/windows_view) уже завёрнуты в esc().
        var detailParts = [];
        var livingAreaNum = Number(f.living_area);
        if (livingAreaNum > 0) detailParts.push('жилая ' + livingAreaNum + ' м²');
        if (f.decoration) detailParts.push(esc(f.decoration));
        if (f.windows_view) detailParts.push(esc(f.windows_view));
        var detailHtml = detailParts.length ? '<div class="jk-flat-card__details">' + detailParts.join(' · ') + '</div>' : '';

        var areaNum   = Number(f.area);
        var floorNum  = Number(f.floor);
        var floorsNum = Number(f.floors);
        var areaStr   = isFinite(areaNum) ? areaNum : '—';
        var floorStr  = floorNum > 0 ? (floorNum + '/' + (floorsNum > 0 ? floorsNum : '—') + ' эт.') : '';

        // N5 lifecycle: приглушённая плашка «Забронирована» на карточке квартиры.
        var reservedHtml = f.status === 'reserved'
          ? '<div class="jk-flat-card__reserved">Забронирована</div>'
          : '';
        card.innerHTML =
          '<div class="jk-flat-card__plan">' +
            (f.layout_url ? '<img src="' + esc(standSrc(f.layout_url, 320)) + '" alt="Планировка" loading="lazy">' : '<i class="fas fa-drafting-compass"></i>') +
          '</div>' +
          '<div class="jk-flat-card__info">' +
            '<div class="jk-flat-card__type">' + esc(f.rooms) + '</div>' +
            '<div class="jk-flat-card__area">' + areaStr + ' м²' + (floorStr ? ' · ' + floorStr : '') + '</div>' +
            reservedHtml +
            detailHtml +
            priceHtml +
          '</div>';
        grid.appendChild(card);
      });

      body.appendChild(grid);

      if (g.items.length > 6) {
        var moreBtn = document.createElement('button');
        moreBtn.className = 'jk-accordion-show-more';
        moreBtn.dataset.type = key;
        moreBtn.innerHTML = '<i class="fas fa-chevron-down"></i> Ещё ' + (g.items.length - 6) + ' ' + flatsPlural(g.items.length - 6);
        body.appendChild(moreBtn);
      }

      frag.appendChild(row);
      frag.appendChild(body);
    });

    container.textContent = '';
    container.appendChild(frag);

    // Авто-раскрытие секции по #room-<class> из URL
    var hash = (location.hash || '').replace(/^#/, '');
    var m = hash.match(/^room-(studio|r[1-5])$/);
    if (m) {
      var target = container.querySelector('.jk-flat-row[data-room="' + m[1] + '"]');
      if (target) {
        var body = target.nextElementSibling;
        if (body && body.classList.contains('jk-flat-row__body')) {
          target.classList.add('open');
          body.classList.add('open');
          target.setAttribute('aria-expanded', 'true');
          setTimeout(function() {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 250);
        }
      }
    }
  }

  // Short price format: 4,45 млн ₽
  function fmtShort(n) {
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace('.0', '') + ' млн ₽';
    if (n >= 1000) return Math.round(n / 1000) + ' тыс ₽';
    return n + ' ₽';
  }

  // Row toggle (event delegation) — ЦИАН-стиль
  document.addEventListener('click', function(e) {
    var row = e.target.closest('.jk-flat-row');
    if (!row) return;
    var body = row.nextElementSibling;
    if (!body || !body.classList.contains('jk-flat-row__body')) return;
    var wasOpen = row.classList.contains('open');
    row.classList.toggle('open');
    body.classList.toggle('open');
    row.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
  });

  // Row keyboard support
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var row = e.target.closest('.jk-flat-row');
    if (!row) return;
    e.preventDefault();
    row.click();
  });

  // Accordion "show more" button
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.jk-accordion-show-more');
    if (!btn || !JK || !JK.apartments) return;
    var body = btn.closest('.jk-accordion-body');
    var grid = body ? body.querySelector('.jk-flats-grid') : null;
    if (!grid) return;

    var type = btn.dataset.type;
    var allOfType = JK.apartments.filter(function(a) { return a.rooms === type; });
    var existing = grid.children.length;

    allOfType.slice(existing).forEach(function(f) {
      var card = document.createElement('div');
      card.className = 'jk-flat-card';
      if (f.id) { card.dataset.flatId = f.id; card.style.cursor = 'pointer'; }
      // Security hotfix 2026-05-23 (claude_full audit CRITICAL #3): см. комментарий выше.
      var areaN  = Number(f.area);
      var floorN = Number(f.floor);
      var areaS  = isFinite(areaN) ? areaN : '—';
      var floorS = floorN > 0 ? (floorN + ' эт.') : '';
      card.innerHTML =
        '<div class="jk-flat-card__plan">' +
          (f.layout_url ? '<img src="' + esc(standSrc(f.layout_url, 320)) + '" alt="Планировка" loading="lazy">' : '<i class="fas fa-drafting-compass"></i>') +
        '</div>' +
        '<div class="jk-flat-card__info">' +
          '<div class="jk-flat-card__type">' + esc(f.rooms) + '</div>' +
          '<div class="jk-flat-card__area">' + areaS + ' м²' + (floorS ? ' · ' + floorS : '') + '</div>' +
          '<div class="jk-flat-card__price">' + (f.price > 0 ? fmt(f.price) : '—') + '</div>' +
        '</div>';
      grid.appendChild(card);
    });
    btn.remove();
  });

  // Flat card click → navigate to flat page
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.jk-flat-card[data-flat-id]');
    if (!card || e.target.closest('button')) return;
    window.location = '/flat.php?id=' + card.dataset.flatId;
  });

  function renderMortgagePrograms() {
    const el = $('jkMcPrograms'); if (!el || !JK.mortgagePrograms) return;
    el.innerHTML = JK.mortgagePrograms.map(p =>
      '<div class="jk-mc-program' + (selectedProgram && selectedProgram.id === p.id ? ' selected' : '') + '" data-id="' + p.id + '">' +
      '<div class="jk-mc-prog-icon" style="background:' + safeColor(p.color) + '"><i class="fas ' + safeIcon(p.icon || 'fa-landmark') + '"></i></div>' +
      '<div style="flex:1;min-width:0"><div class="jk-mc-prog-bank">' + esc(p.bank) + '</div><div class="jk-mc-prog-name">' + esc(p.program) + '</div></div>' +
      '<div class="jk-mc-prog-rate">' + p.rate + '%</div></div>'
    ).join('');
  }

  function renderConstruction() {
    const el = $('jkConstruction'); if (!el || !JK.construction) return;
    el.innerHTML = JK.construction.map(c =>
      '<div class="jk-build fade-up"><div class="jk-build-date"><i class="fas fa-calendar-day ico-xs"></i> ' + esc(c.date) + '</div>' +
      '<div class="jk-build-bar"><div class="jk-build-label"><i class="fas fa-crane ico-xs ico-gold"></i> ' + esc(c.label) + '</div>' +
      '<div class="jk-build-track"><div class="jk-build-fill" style="width:' + (parseInt(c.progress, 10) || 0) + '%"></div></div>' +
      '<div class="jk-build-pct">' + (parseInt(c.progress, 10) || 0) + '%</div></div></div>'
    ).join('');
  }

  function renderSchools() {
    var section = $('jkSchoolsSection');
    var el = $('jkSchools');
    if (!el || !JK.nearby) return;
    var schools = JK.nearby.filter(function(n) { return n.type === 'school' || n.type === 'kindergarten'; });
    if (!schools.length) return;
    if (section) section.classList.remove('jk-hidden');
    el.innerHTML = schools.map(function(s) {
      var icon = s.type === 'kindergarten' ? 'fa-child' : 'fa-school';
      var label = s.type === 'kindergarten' ? '\u0414\u0435\u0442\u0441\u043a\u0438\u0439 \u0441\u0430\u0434' : '\u0428\u043a\u043e\u043b\u0430';
      var dist = s.distance_km ? s.distance_km.toFixed(1) + ' \u043a\u043c' : s.dist || '';
      // \u26d4 \u0422\u0440\u0435\u0442\u044c\u044f \u0442\u043e\u0447\u043a\u0430 \u0442\u043e\u0439 \u0436\u0435 \u0444\u043e\u0440\u043c\u0443\u043b\u044b. \u041f\u043e\u0440\u043e\u0433 \u0442\u043e\u0442 \u0436\u0435 \u0438 \u043f\u043e \u0442\u043e\u0439 \u0436\u0435 \u043f\u0440\u0438\u0447\u0438\u043d\u0435, \u043d\u0430 \u0432\u0441\u0435\u0445
      //    \u0448\u0438\u0440\u0438\u043d\u0430\u0445.
      var walk = (s.distance_km && s.distance_km <= 5)
        ? Math.round(s.distance_km / 5 * 60) + ' \u043c\u0438\u043d \u043f\u0435\u0448\u043a\u043e\u043c' : '';
      return '<div class="jk-school-card">' +
        '<div class="jk-school-icon"><i class="fas ' + icon + '"></i></div>' +
        '<div class="jk-school-info">' +
        '<div class="jk-school-name">' + esc(s.name) + '</div>' +
        '<div class="jk-school-meta"><span class="jk-school-type">' + label + '</span>' +
        (dist ? ' <span class="jk-school-dist"><i class="fas fa-route ico-xs"></i> ' + dist + '</span>' : '') +
        (walk ? ' <span class="jk-school-walk"><i class="fas fa-person-walking ico-xs"></i> ' + walk + '</span>' : '') +
        '</div></div></div>';
    }).join('');
  }

  function renderNearby() {
    const el = $('jkNearby'); if (!el || !JK.nearby) return;
    el.innerHTML = JK.nearby.map(n =>
      '<div class="jk-nearby-item"><i class="fas ' + safeIcon(n.icon || 'fa-location-dot') + ' jk-nearby-icon icon-glow"></i>' +
      // Значок пешехода — только там, где это правда минуты ходьбы (см. enrichJK).
      '<div><div class="jk-nearby-name">' + esc(n.name) + '</div><div class="jk-nearby-dist"><i class="fas ' + (n.walkable === false ? 'fa-route' : 'fa-person-walking') + ' ico-xs"></i> ' + esc(n.dist) + '</div></div></div>'
    ).join('');
  }

  function renderReviews() {
    const el = $('jkReviews'); if (!el || !JK.reviews) return;
    // DOM-009: DocumentFragment
    const frag = document.createDocumentFragment();
    JK.reviews.forEach(r => {
      const initials = (r.author || '?').charAt(0).toUpperCase();
      const div = document.createElement('div');
      div.className = 'jk-review fade-up';
      div.innerHTML =
        '<div class="jk-review-header"><span class="jk-review-author"><span class="jk-review-avatar">' + esc(initials) + '</span> ' + esc(r.author) + '</span><span class="jk-review-date">' + esc(r.date) + '</span></div>' +
        '<div class="jk-review-stars">' + Array.from({length: 5}, (_, i) => '<i class="fas fa-star"></i>').join('') + '</div>' +
        '<div class="jk-review-pros">' + (r.pros || []).map(p => '<span class="jk-review-pro"><i class="fas fa-check ico-xs"></i> ' + esc(p) + '</span>').join('') + '</div>' +
        '<div class="jk-review-text">' + esc(r.text) + '</div>';
      // Set star colors via class instead of inline style
      var stars = div.querySelectorAll('.jk-review-stars i');
      for (var si = 0; si < stars.length; si++) {
        stars[si].className = si < r.rating ? 'fas fa-star jk-star-on' : 'fas fa-star jk-star-off';
      }
      frag.appendChild(div);
    });
    el.textContent = '';
    el.appendChild(frag);
  }

  function renderQA() {
    const el = $('jkQA'); if (!el || !JK.qa) return;
    el.innerHTML = JK.qa.map(q =>
      '<div class="jk-qa fade-up">' +
      '<div class="jk-qa-header" role="button" tabindex="0" aria-expanded="false">' +
      '<div class="jk-qa-question"><i class="fas fa-circle-question"></i> ' + esc(q.q) + '</div>' +
      '<i class="fas fa-chevron-down jk-qa-arrow"></i></div>' +
      '<div class="jk-qa-body">' +
      '<div class="jk-qa-meta"><span><i class="fas fa-user ico-xs"></i> ' + esc(q.author) + '</span><span>' + esc(q.date) + '</span></div>' +
      '<div class="jk-qa-answer">' + esc(q.a) + '</div></div></div>'
    ).join('');
    // Accordion toggle
    el.querySelectorAll('.jk-qa-header').forEach(function(hdr) {
      hdr.addEventListener('click', function() {
        var qa = hdr.closest('.jk-qa');
        var isOpen = qa.classList.contains('open');
        qa.classList.toggle('open');
        hdr.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
      hdr.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hdr.click(); }
      });
    });
  }

  // ═══ SIMILAR / DEV-JK / NEARBY — крупные карточки 3-в-ряд + авто-ротация (3.1.2/3.1.3) ═══
  // ⛔ 7.3 (24.09.2026): КАРТОЧКИ ВСЕХ ТРЁХ СЕТОК ПЕЧАТАЕТ СЕРВЕР (jk.php →
  //    BroniDom\Seo\JkCardLinks, разметка components/jk-similar-card.php). Прежний
  //    buildSimilarBigCard рисовал «Другие ЖК застройщика» из поля same_developer после
  //    ответа jk_manager.php — в HTML сервера секция была пустой, и робот без скрипта
  //    не видел ни одной ссылки. Второй рисовальщик здесь не нужен: он задвоил бы
  //    сетку или перезаписал бы серверный состав своим (отбор по точному имени).

  // Авто-ротация крупной сетки: всегда 3 карточки; при >3 крутит окно из 3 по
  // одной каждые 3с (циклично). Пауза на hover, уважает prefers-reduced-motion.
  function jkBigRotator(grid) {
    if (!grid) return;
    const cards = Array.prototype.slice.call(grid.querySelectorAll('.jk-similar-card'));
    const n = cards.length;
    if (n <= 3) return; // всё влезает в один ряд — ротация не нужна
    const mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    // На мобиле сетка = горизонтальный scroll-snap (css ≤767px). Скрытие карточек
    // через display:none сломало бы свайп → не ротируем, оставляем нативный скролл.
    if (mq && mq.matches) return;
    const show = function(s) {
      for (let i = 0; i < n; i++) {
        const vis = (i === s % n) || (i === (s + 1) % n) || (i === (s + 2) % n);
        cards[i].style.display = vis ? '' : 'none';
      }
    };
    show(0);
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; // статично первые 3
    let start = 0;
    let timer = null;
    const tick = function() {
      // не ротировать, пока фокус внутри сетки (keyboard-юзер не теряет карточку)
      if (grid.contains(document.activeElement)) return;
      grid.classList.add('jk-rotating');
      setTimeout(function() { start = (start + 1) % n; show(start); grid.classList.remove('jk-rotating'); }, 220);
    };
    const play = function() { if (!timer) timer = setInterval(tick, 3000); };
    const pause = function() { if (timer) { clearInterval(timer); timer = null; } };
    grid.addEventListener('mouseenter', pause);
    grid.addEventListener('mouseleave', play);
    play();
  }

  function renderSimilar() {
    // 3.1.3: авто-ротация серверных сеток при > 3 карточек. #jkDevJkGrid наполнен
    // сервером (7.3) — скрипт только крутит, ничего в него не пишет.
    jkBigRotator($('jkDevJkGrid'));
    jkBigRotator(document.querySelector('#jkSimilarServer .jk-similar-grid'));
    jkBigRotator(document.querySelector('#jkNearbyJkSection .jk-similar-grid'));
  }

  // ═══ VIEW STATS ═══
  function renderViewStats() {
    var el = $('jkViewStats');
    if (!el || !JK.view_stats) return;
    var vs = JK.view_stats;
    if (!vs.total && !vs.days_on_site) return;
    var parts = [];
    var days = parseInt(vs.days_on_site, 10) || 0;
    var week = parseInt(vs.week, 10) || 0;
    var total = parseInt(vs.total, 10) || 0;
    if (days > 0) parts.push('<span><i class="fas fa-calendar-day"></i> ' + days + ' дн. на сайте</span>');
    if (week > 0) parts.push('<span><i class="fas fa-eye"></i> ' + week + ' просм. за неделю</span>');
    if (total > 0) parts.push('<span><i class="fas fa-chart-simple"></i> ' + total + ' всего</span>');
    if (parts.length) { el.innerHTML = parts.join(''); el.classList.remove('jk-hidden'); }
  }

  // ═══ MARKET COMPARISON (C2) ═══
  function renderMarketComparison() {
    var section = $('jkMarketSection');
    var el = $('jkMarket');
    if (!el || !JK || !JK.market_comparison) return;
    var mc = JK.market_comparison;
    if (!mc.median) return;
    if (section) section.classList.remove('jk-hidden');

    var diffAbs = Math.abs(mc.diff_percent);
    var colorClass = mc.diff_percent < -3 ? 'green' : mc.diff_percent > 3 ? 'red' : 'neutral';
    var icon = mc.diff_percent < -3 ? 'fa-arrow-trend-down' : mc.diff_percent > 3 ? 'fa-arrow-trend-up' : 'fa-equals';
    var barWidth = Math.min(100, Math.max(5, 50 + mc.diff_percent));

    el.innerHTML =
      '<div class="jk-market-row">' +
        '<div class="jk-market-label">\u0426\u0435\u043d\u0430 \u044d\u0442\u043e\u0433\u043e \u0416\u041a</div>' +
        '<div class="jk-market-value">' + (JK.priceM2From || 0).toLocaleString('ru') + ' \u20bd/\u043c\xb2</div>' +
      '</div>' +
      '<div class="jk-market-bar">' +
        '<div class="jk-market-fill jk-market-fill-' + colorClass + '" style="width:' + barWidth + '%"></div>' +
        '<div class="jk-market-median-line" style="left:50%"></div>' +
      '</div>' +
      '<div class="jk-market-row">' +
        '<div class="jk-market-label">\u041c\u0435\u0434\u0438\u0430\u043d\u0430 \u043f\u043e ' + esc(JK.city || '\u0433\u043e\u0440\u043e\u0434\u0443') + '</div>' +
        '<div class="jk-market-value">' + mc.median.toLocaleString('ru') + ' \u20bd/\u043c\xb2</div>' +
      '</div>' +
      '<div class="jk-market-verdict jk-market-verdict-' + colorClass + '">' +
        '<i class="fas ' + icon + '"></i> ' +
        '<span>' + esc(mc.label) + (diffAbs >= 3 ? ' \u043d\u0430 ' + diffAbs + '%' : '') + '</span>' +
      '</div>';
  }

  // ═══ CADASTRAL (C2) ═══
  function renderCadastral() {
    var section = $('jkCadastralSection');
    var el = $('jkCadastral');
    if (!el || !JK || !JK.cadastral) return;
    var c = JK.cadastral;
    if (!c.cadastral_number && !c.permit_number) return;
    if (section) section.classList.remove('jk-hidden');

    var rows = [];
    if (c.cadastral_number) rows.push(['fa-map-pin', '\u041a\u0430\u0434\u0430\u0441\u0442\u0440\u043e\u0432\u044b\u0439 \u043d\u043e\u043c\u0435\u0440', c.cadastral_number]);
    if (c.land_area) rows.push(['fa-ruler-combined', '\u041f\u043b\u043e\u0449\u0430\u0434\u044c \u0443\u0447\u0430\u0441\u0442\u043a\u0430', c.land_area + ' \u043c\xb2']);
    if (c.land_use) rows.push(['fa-scroll', '\u0412\u0438\u0434 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u043d\u0438\u044f', c.land_use]);
    if (c.permit_number) rows.push(['fa-file-signature', '\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043d\u0438\u0435', c.permit_number]);
    if (c.permit_date) rows.push(['fa-calendar', '\u0414\u0430\u0442\u0430 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043d\u0438\u044f', c.permit_date]);
    if (c.developer_inn) rows.push(['fa-building-columns', '\u0418\u041d\u041d \u0437\u0430\u0441\u0442\u0440\u043e\u0439\u0449\u0438\u043a\u0430', c.developer_inn]);
    if (c.escrow_bank) rows.push(['fa-shield-halved', '\u042d\u0441\u043a\u0440\u043e\u0443-\u0431\u0430\u043d\u043a', c.escrow_bank]);

    el.innerHTML = rows.map(function(r) {
      return '<div class="jk-cadastral-row">' +
        '<i class="fas ' + r[0] + ' jk-cadastral-icon"></i>' +
        '<span class="jk-cadastral-label">' + esc(r[1]) + '</span>' +
        '<span class="jk-cadastral-value">' + esc(String(r[2])) + '</span>' +
      '</div>';
    }).join('') +
    (c.project_declaration_url ?
      '<a href="' + esc(c.project_declaration_url) + '" class="jk-cadastral-link" target="_blank" rel="noopener">' +
      '<i class="fas fa-external-link"></i> \u041f\u0440\u043e\u0435\u043a\u0442\u043d\u0430\u044f \u0434\u0435\u043a\u043b\u0430\u0440\u0430\u0446\u0438\u044f</a>' : '');
  }

  // ═══ AI DESCRIPTION — Phase C (2026-04-23): удалён legacy-рендер (#jkAiDescSection).
  // Серверный SSR в jk_content.php#jkAiDescServer полностью закрывает этот блок —
  // дубликат вызывал две одинаковых секции на странице после AI-бэкфилла.
  function renderAiDescription() { /* no-op: см. server-side #jkAiDescServer */ }

  // ═══ LANDMARKS / TRAVEL TIME (C4) ═══
  function renderLandmarks() {
    var section = $('jkLandmarksSection');
    var el = $('jkLandmarks');
    if (!el || !JK || !JK.landmarks || !JK.landmarks.length) return;
    if (section) section.classList.remove('jk-hidden');

    el.innerHTML = '<div class="jk-landmarks-grid">' +
      JK.landmarks.map(function(lm) {
        var walkText = lm.walk_min ? lm.walk_min + ' \u043c\u0438\u043d \u043f\u0435\u0448\u043a\u043e\u043c' : '';
        var driveText = lm.drive_min ? lm.drive_min + ' \u043c\u0438\u043d \u043d\u0430 \u0430\u0432\u0442\u043e' : '';
        var kmText = lm.distance_km ? lm.distance_km + ' \u043a\u043c' : '';
        var kmVal = parseFloat(lm.distance_km) || 0;
        var colorClass = kmVal > 0 && kmVal <= 3 ? 'green' : kmVal > 0 && kmVal <= 10 ? 'yellow' : 'neutral';

        return '<div class="jk-landmark">' +
          '<div class="jk-landmark-icon jk-landmark-icon-' + colorClass + '">' +
            '<i class="fas ' + safeIcon(lm.icon || 'fa-location-dot') + '"></i>' +
          '</div>' +
          '<div class="jk-landmark-body">' +
            '<div class="jk-landmark-name">' + esc(lm.name) + '</div>' +
            '<div class="jk-landmark-meta">' +
              '<span><i class="fas fa-road ico-xs"></i> ' + esc(kmText) + '</span>' +
              (driveText ? '<span><i class="fas fa-car ico-xs"></i> ' + esc(driveText) + '</span>' : '') +
              (walkText ? '<span><i class="fas fa-person-walking ico-xs"></i> ' + esc(walkText) + '</span>' : '') +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('') +
    '</div>';
  }

  // ═══ FACTS ACCORDION ═══
  function renderFacts() {
    var el = $('jkFacts');
    var section = $('jkFactsSection');
    if (!el || !JK) return;

    var sections = [];

    // Квартира
    var apt = [];
    if (JK.rooms && JK.rooms.length) apt.push('Комнат: ' + JK.rooms.map(function(r) { return r.type; }).join(', '));
    if (JK.areaRange) apt.push('Площадь: ' + JK.areaRange);
    if (JK.ceiling_text || JK.ceiling_height) apt.push('Высота потолков: ' + (JK.ceiling_text || (JK.ceiling_height + ' м')));
    if (JK.finishing_type) apt.push('Отделка: ' + JK.finishing_type);
    if (apt.length) sections.push({title: 'Квартира', icon: 'fa-door-open', items: apt});

    // О доме
    var house = [];
    if (JK.building_class) house.push('Класс: ' + JK.building_class);
    if (JK.floors) house.push('Этажность: ' + JK.floors);
    if (JK.wall_material) house.push('Материал: ' + JK.wall_material);
    if (JK.apartments_count) house.push(flatsLabelCap() + ': ' + JK.apartments_count);
    if (JK.developer) house.push('Застройщик: ' + JK.developer);
    if (JK.deadlineLabel) house.push(window.BuildStatus.deadlineLine(JK.deadlineLabel));
    if (house.length) sections.push({title: 'О доме', icon: 'fa-building', items: house});

    // Коммуникации
    var comm = [];
    if (JK.parking_type) comm.push('Паркинг: ' + JK.parking_type);
    if (JK.contract_type) comm.push('Тип договора: ' + JK.contract_type);
    if (JK.escrow_bank) comm.push('Эскроу: ' + JK.escrow_bank);
    if (comm.length) sections.push({title: 'Покупка и паркинг', icon: 'fa-shield-halved', items: comm});

    // Инфраструктура
    if (JK.features && JK.features.length) {
      sections.push({title: 'На территории', icon: 'fa-tree', items: JK.features.map(function(f) { return f.name; })});
    }

    // Ипотека
    if (JK.mortgagePrograms && JK.mortgagePrograms.length) {
      sections.push({title: 'Ипотека', icon: 'fa-landmark', items: JK.mortgagePrograms.map(function(p) { return p.program + ' — ' + p.rate + '% (' + p.bank + ')'; })});
    }

    if (!sections.length) return;
    if (section) section.classList.remove('jk-hidden');

    el.innerHTML = sections.map(function(s) {
      return '<div class="jk-fact-section">' +
        '<div class="jk-fact-header"><i class="fas ' + s.icon + '"></i> ' + esc(s.title) + '</div>' +
        '<div class="jk-fact-group">' + s.items.map(function(item) {
          return '<div class="jk-fact-item">' + esc(item) + '</div>';
        }).join('') + '</div></div>';
    }).join('');
  }

  // Facts toggle
  var factsToggle = $('jkFactsToggle');
  if (factsToggle) {
    factsToggle.addEventListener('click', function() {
      var facts = $('jkFacts');
      if (!facts) return;
      var expanded = facts.classList.toggle('expanded');
      factsToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var icon = factsToggle.querySelector('i');
      if (icon) icon.className = expanded ? 'fas fa-chevron-up ico' : 'fas fa-chevron-down ico';
      var txtNode = Array.from(factsToggle.childNodes).find(function(n) { return n.nodeType === 3 && n.textContent.trim(); });
      if (txtNode) txtNode.textContent = expanded ? 'Скрыть характеристики' : 'Показать все характеристики';
    });
  }

  // ═══ PRICE HISTORY (C1) ═══
  var phFilterType = '';
  var phMonths = 3;

  function renderPriceHistory() {
    var section = $('jkPriceHistSection');
    if (!section || !JK || !JK.price_history || !JK.price_history.events || !JK.price_history.events.length) return;
    section.classList.remove('jk-hidden');
    renderPhTable();
    renderPhSparkline();
  }

  function renderPhTable() {
    var body = $('jkPhBody');
    if (!body || !JK.price_history) return;
    var events = JK.price_history.events;
    if (phFilterType) {
      events = events.filter(function(e) { return e.flat_type === phFilterType || !e.flat_type; });
    }

    var eventLabels = {
      listed: 'Старт продаж', price_up: 'Повышение', price_down: 'Снижение',
      promo_start: 'Начало акции', promo_end: 'Конец акции',
      phase_start: 'Новый корпус', sold_out: 'Распродано'
    };
    var eventIcons = {
      listed: 'fa-flag', price_up: 'fa-arrow-trend-up', price_down: 'fa-arrow-trend-down',
      promo_start: 'fa-fire', promo_end: 'fa-ban', phase_start: 'fa-building', sold_out: 'fa-check-circle'
    };

    body.innerHTML = events.slice(0, 20).map(function(ev) {
      var chg = parseFloat(ev.change_percent) || 0;
      var chgClass = chg > 0 ? 'jk-ph-up' : chg < 0 ? 'jk-ph-down' : '';
      var chgText = chg ? (chg > 0 ? '+' : '') + chg.toFixed(1) + '%' : '\u2014';
      var icon = eventIcons[ev.event_type] || 'fa-circle';
      var label = eventLabels[ev.event_type] || ev.event_type;
      var price = parseInt(ev.price_from, 10) || 0;
      var m2 = parseInt(ev.price_per_sqm, 10) || 0;
      return '<tr>' +
        '<td>' + esc(ev.date_ru) + '</td>' +
        '<td><i class="fas ' + icon + ' jk-ph-icon ' + chgClass + '"></i> ' + esc(label) + '</td>' +
        '<td>' + (price ? fmt(price) : '\u2014') + '</td>' +
        '<td>' + (m2 ? m2.toLocaleString('ru') + ' \u20bd' : '\u2014') + '</td>' +
        '<td class="' + chgClass + '">' + chgText + '</td>' +
        '</tr>';
    }).join('');
  }

  function renderPhSparkline() {
    var svg = $('jkPhSpark');
    if (!svg || !JK.price_history || !JK.price_history.sparkline) return;
    var data = JK.price_history.sparkline;
    if (data.length < 2) { svg.innerHTML = ''; return; }

    var cutoff = new Date();
    cutoff.setMonth(cutoff.getMonth() - phMonths);
    var cutoffStr = cutoff.toISOString().slice(0, 7);
    data = data.filter(function(d) { return d.month >= cutoffStr; });
    if (data.length < 2) { svg.innerHTML = ''; return; }

    var vals = data.map(function(d) { return parseFloat(d.avg_m2) || 0; });
    var max = Math.max.apply(null, vals);
    var min = Math.min.apply(null, vals);
    var range = max - min || 1;
    var w = 300, h = 48, pad = 6;

    var pts = data.map(function(d, i) {
      var x = pad + (i / (data.length - 1)) * (w - pad * 2);
      var y = pad + (1 - (vals[i] - min) / range) * (h - pad * 2);
      return x.toFixed(1) + ',' + y.toFixed(1);
    });

    var polyPts = pts.join(' ');
    var areaPts = pad + ',' + (h - pad) + ' ' + polyPts + ' ' + (w - pad) + ',' + (h - pad);

    var months = ['\u044f\u043d\u0432','\u0444\u0435\u0432','\u043c\u0430\u0440','\u0430\u043f\u0440','\u043c\u0430\u0439','\u0438\u044e\u043d','\u0438\u044e\u043b','\u0430\u0432\u0433','\u0441\u0435\u043d','\u043e\u043a\u0442','\u043d\u043e\u044f','\u0434\u0435\u043a'];
    var labels = data.map(function(d, i) {
      var x = pad + (i / (data.length - 1)) * (w - pad * 2);
      var m = parseInt(d.month.split('-')[1], 10) - 1;
      return '<text x="' + x.toFixed(1) + '" y="58" text-anchor="middle" fill="var(--text-muted)" font-size="8">' + months[m] + '</text>';
    });

    svg.innerHTML =
      '<defs><linearGradient id="phG" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0%" stop-color="var(--gold)" stop-opacity=".25"/>' +
        '<stop offset="100%" stop-color="var(--gold)" stop-opacity="0"/>' +
      '</linearGradient></defs>' +
      '<polygon points="' + areaPts + '" fill="url(#phG)"/>' +
      '<polyline points="' + polyPts + '" fill="none" stroke="var(--gold)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      labels.join('');
  }

  // ═══ PERF-1 (2026-08-02): ленивая загрузка тяжёлых внешних движков ═══
  // Раньше chart.umd.min.js (59 КБ) и pannellum.js + pannellum.css висели в jk.php
  // ПАРСЕР-БЛОКИРУЮЩИМИ тегами на КАЖДОЙ карточке ЖК, хотя график нужен только при
  // JK.price_history.sparkline, а тур — только при JK.tours.scenes. Замер 02.08:
  // ни то, ни другое на проде не срабатывало ни разу (#jkPriceCanvas нет ни в одном
  // шаблоне, JK.tours не заполняет ни один бэкенд) — то есть качали и не использовали.
  // Теперь движок подтягивается ТОЛЬКО когда данные реально пришли.
  // SRI (integrity + crossorigin) сохранён. CSP: под 'strict-dynamic' скрипт, вставленный
  // нашим nonce-скриптом, доверенный — правки app/csp.php не требуется.
  var VENDOR = {
    chart: {
      js: 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.1/chart.umd.min.js',
      jsSri: 'sha384-bs/nf9FbdNouRbMiFcrcZfLXYPKiPaGVGplVbv7dLGECccEXDW+S3zjqSKR5ZEaD'
    },
    pannellum: {
      css: 'https://cdnjs.cloudflare.com/ajax/libs/pannellum/2.5.6/pannellum.css',
      cssSri: 'sha384-02yn80EH0cF+s23taAmuhEZ04p3CTbQvV0QZMr2reUxajpfvcLNKlzsPkZwx14mf',
      js: 'https://cdnjs.cloudflare.com/ajax/libs/pannellum/2.5.6/pannellum.js',
      jsSri: 'sha384-S5+w/JlcNAOymqXGNrvzn2F++XsaHTJdex6KE5VbKryfFgqJiRUJOgOkUqaiOZTf'
    }
  };
  var vendorState = {};

  function loadVendor(key, cb) {
    var known = vendorState[key];
    if (known === 'ok' || known === 'fail') { cb(known === 'ok'); return; }
    var v = VENDOR[key];
    if (!v) { cb(false); return; }
    vendorState[key] = 'loading';
    if (v.css) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = v.css;
      link.integrity = v.cssSri;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }
    var s = document.createElement('script');
    s.src = v.js;
    s.integrity = v.jsSri;
    s.crossOrigin = 'anonymous';
    s.async = true;
    s.onload = function() { vendorState[key] = 'ok'; cb(true); };
    s.onerror = function() { vendorState[key] = 'fail'; cb(false); };
    document.head.appendChild(s);
  }

  // ═══ CHART.JS PRICE CHART (Phase 4, v2 redesign) ═══
  var priceChart = null;

  function initPriceChart() {
    var canvas = $('jkPriceCanvas');
    // Сначала данные, потом движок: без истории цен Chart.js не качается вовсе.
    if (!canvas || !JK || !JK.price_history || !JK.price_history.sparkline) return;
    if (typeof Chart === 'undefined') {
      loadVendor('chart', function(ok) { if (ok) initPriceChart(); });
      return;
    }

    var data = JK.price_history.sparkline;
    if (data.length < 2) return;

    // Filter by range
    var cutoff = new Date();
    cutoff.setMonth(cutoff.getMonth() - phMonths);
    var cutoffStr = cutoff.toISOString().slice(0, 7);
    data = data.filter(function(d) { return d.month >= cutoffStr; });
    if (data.length < 2) return;

    // Hide SVG fallback, show canvas
    var svg = $('jkPhSpark');
    if (svg) svg.classList.add('jk-hidden');
    canvas.classList.remove('jk-hidden');

    var months = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек'];
    var labels = data.map(function(d) {
      var m = parseInt(d.month.split('-')[1], 10) - 1;
      return months[m] + ' ' + d.month.split('-')[0].slice(2);
    });
    var values = data.map(function(d) { return parseFloat(d.avg_m2) || 0; });

    // Gold gradient
    var ctx = canvas.getContext('2d');
    var gradient = ctx.createLinearGradient(0, 0, 0, canvas.height || 200);
    gradient.addColorStop(0, 'rgba(200, 169, 110, 0.25)');
    gradient.addColorStop(1, 'rgba(200, 169, 110, 0)');

    if (priceChart) priceChart.destroy();

    priceChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: 'Цена за м²',
          data: values,
          borderColor: '#c8a96e',
          backgroundColor: gradient,
          borderWidth: 2,
          pointBackgroundColor: '#c8a96e',
          pointBorderColor: '#0d0d0f',
          pointBorderWidth: 2,
          pointRadius: 3,
          pointHoverRadius: 6,
          fill: true,
          tension: 0.3
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: 'rgba(13, 13, 15, 0.95)',
            titleColor: '#c8a96e',
            bodyColor: '#e0e0e0',
            borderColor: 'rgba(200, 169, 110, 0.3)',
            borderWidth: 1,
            padding: 12,
            displayColors: false,
            callbacks: {
              label: function(context) {
                return context.parsed.y.toLocaleString('ru') + ' ₽/м²';
              }
            }
          }
        },
        scales: {
          x: {
            grid: { color: 'rgba(255,255,255,0.04)', drawBorder: false },
            ticks: { color: 'rgba(255,255,255,0.4)', font: { size: 11, family: 'Mulish' }, maxRotation: 0 }
          },
          y: {
            grid: { color: 'rgba(255,255,255,0.04)', drawBorder: false },
            ticks: {
              color: 'rgba(255,255,255,0.4)',
              font: { size: 11, family: 'Mulish' },
              callback: function(val) { return (val / 1000).toFixed(0) + 'к'; }
            }
          }
        }
      }
    });
  }

  // Price History tabs
  var phTabsEl = $('jkPhTabs');
  if (phTabsEl) {
    phTabsEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.jk-ph-tab');
      if (!btn) return;
      phFilterType = btn.dataset.phType || '';
      phTabsEl.querySelectorAll('.jk-ph-tab').forEach(function(t) { t.classList.remove('active'); });
      btn.classList.add('active');
      renderPhTable();
    });
  }

  // Price History range
  var phRangeEl = $('jkPhRange');
  if (phRangeEl) {
    phRangeEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.jk-ph-range-btn');
      if (!btn) return;
      phMonths = parseInt(btn.dataset.months, 10) || 6;
      phRangeEl.querySelectorAll('.jk-ph-range-btn').forEach(function(t) { t.classList.remove('active'); });
      btn.classList.add('active');
      renderPhSparkline();
      initPriceChart();
    });
  }

  // ═══ INFRASTRUCTURE MAP ═══
  // Список POI под картой: свёрнут до 5 ближайших + кнопка «Показать все N» (анти-раздутость)
  function jkBuildInfraList(items) {
    var poiIcons = {metro:'fa-subway',train:'fa-train',highway:'fa-road',school:'fa-school',kindergarten:'fa-child-reaching',hospital:'fa-hospital',mall:'fa-shopping-bag',park:'fa-tree',sport:'fa-dumbbell',bus_stop:'fa-bus',tram:'fa-train-tram',university:'fa-graduation-cap',pharmacy:'fa-prescription-bottle-medical',supermarket:'fa-cart-shopping',cafe:'fa-mug-hot',bank:'fa-building-columns'};
    var itemHtml = function(n) {
      var km = n.distance_km || 0;
      var colorClass = km <= 1 ? 'green' : km <= 3 ? 'yellow' : 'red';
      var icon = safeIcon(poiIcons[n.type] || n.icon || 'fa-location-dot');
      // ⛔ «820 мин пешком» до Домодедово — выдумка формулы «расстояние ÷ 5 км/ч».
      //    Дальше 5 км (это больше часа ходу) время не печатаем вовсе: расстояние
      //    настоящее, а часы ходьбы до аэропорта за 65 км в жизни не существуют.
      // ⛔ Порог действует и на телефоне (решение 16.08): правило «телефон не
      //    трогаем» про вёрстку редизайна, а не про право оставлять заведомо
      //    ложную подпись. Правка чисто текстовая, раскладку не двигает.
      var walkMin = (km && km <= 5) ? Math.round(km / 5 * 60) : 0;
      return '<div class="jk-infra-item">' +
        '<div class="jk-infra-icon jk-infra-icon-' + colorClass + '"><i class="fas ' + icon + '"></i></div>' +
        '<div><div class="jk-infra-name">' + esc(n.name) + '</div>' +
        '<div class="jk-infra-meta">' +
        (km ? '<span><i class="fas fa-route ico-xs"></i> ' + km.toFixed(1) + ' км</span>' : '') +
        (walkMin ? '<span><i class="fas fa-person-walking ico-xs"></i> ' + walkMin + ' мин</span>' : '') +
        '</div></div></div>';
    };
    if (!items || !items.length) return '<div class="jk-infra-empty">Нет данных для этой категории</div>';
    var VISIBLE = 5;
    if (items.length <= VISIBLE) return items.map(itemHtml).join('');
    var allTxt = 'Показать все ' + items.length + ' объектов';
    return items.slice(0, VISIBLE).map(itemHtml).join('') +
      '<div class="jk-infra-more" hidden>' + items.slice(VISIBLE).map(itemHtml).join('') + '</div>' +
      '<button type="button" class="jk-infra-more-btn" data-infra-more aria-expanded="false">' +
      '<span class="jk-infra-more-btn__txt" data-all="' + allTxt + '">' + allTxt + '</span> ' +
      '<i class="fas fa-chevron-down" aria-hidden="true"></i></button>';
  }

  function renderInfrastructure() {
    var section = $('jkInfraSection');
    var mapEl = $('jkInfraMap');
    var listEl = $('jkInfraList');
    if (!JK || !JK.nearby || !JK.nearby.length) return;
    if (section) section.classList.remove('jk-hidden');

    // List (свёрнут до 5 ближайших + «Показать все N» — анти-раздутость)
    if (listEl) {
      var infraHtml = jkBuildInfraList(JK.nearby);
      listEl.innerHTML = infraHtml;
    }

    // Yandex Map with POI markers — Phase J: единый defer через ensureYmapsOnVisible
    if (mapEl && JK.lat && JK.lng) {
      var mapId = 'jkInfraYMap';
      mapEl.innerHTML = '<div id="' + mapId + '" class="jk-infra-ymap"></div>';
      ensureYmapsOnVisible(mapEl, function() {
        var map = new ymaps.Map(mapId, {center: [JK.lat, JK.lng], zoom: 15, controls: ['zoomControl']});
        map.geoObjects.add(new ymaps.Placemark([JK.lat, JK.lng], {balloonContent: esc(JK.name)}, {preset: 'islands#redDotIcon'}));
        JK.nearby.forEach(function(n) {
          if (n.lat && n.lng) {
            map.geoObjects.add(new ymaps.Placemark([n.lat, n.lng], {balloonContent: esc(n.name)}, {preset: 'islands#blueDotIcon'}));
          }
        });
      });
    }
  }

  // ═══ MAP LAYER FILTERS (Phase 7, v2 redesign) ═══
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.jk-map-filter');
    if (!btn) return;
    var layerTypes = {
      metro: ['metro', 'train'],
      schools: ['school', 'kindergarten', 'university'],
      shops: ['mall', 'supermarket', 'bank'],
      hospitals: ['hospital', 'pharmacy'],
      parks: ['park', 'sport'],
      transport: ['bus_stop', 'tram', 'highway'],
      food: ['cafe']
    };
    var layer = btn.dataset.layer;
    btn.closest('.jk-map-filter-bar').querySelectorAll('.jk-map-filter').forEach(function(b) { b.classList.toggle('active', b === btn); });

    // Filter POI markers on map
    if (jkMainMap && poiPlacemarks) {
      var visibleTypes = layerTypes[layer] || [];
      Object.keys(poiPlacemarks).forEach(function(type) {
        var show = !visibleTypes.length || visibleTypes.indexOf(type) >= 0;
        poiPlacemarks[type].forEach(function(pm) {
          pm.options.set('visible', show);
        });
      });
    }

    // ⛔ Проверка на null обязательна: узла может не быть на этой карточке, и
    //    первый же клик по слою карты ронял бы страницу с TypeError.
    var listEl = $('jkInfraList');
    if (!listEl || !JK || !JK.nearby) return;
    var types = layerTypes[layer] || [];
    var filtered = types.length ? JK.nearby.filter(function(n) { return types.indexOf(n.type) >= 0; }) : JK.nearby;

    var filteredHtml = jkBuildInfraList(filtered);
    listEl.innerHTML = filteredHtml;
  });

  // ═══ TRANSPORT SCORES (#jkScores) — УДАЛЕНО 2026-07-15 (правка владельца) ═══
  // Блок из трёх колец 0-100 (Район/Транспорт/Для детей) убран как дубль верхней
  // SSR-секции «Рейтинг ЖК».
  // ⛔ 26.08.2026: верхней секции тоже больше НЕТ — оценки убраны из вёрстки совсем
  // (решение владельца). На карточке не осталось ни одного места, где печатается
  // балл района/транспорта/детей. Данные JK.area_score/transit_score/kids_score
  // в объекте JK сохранены — их читают другие потребители, но вёрстка их не рисует.
  // Замер и условие возврата — в app/templates/pages/jk_content.php,
  // ищи «ОЦЕНКИ ЖК УБРАНЫ ИЗ ВЁРСТКИ».

  // ═══ DISTRICT PILLS (8 категорий POI на странице ЖК) ═══
  var DP_CATS = ['school', 'kindergarten', 'hospital', 'park', 'mall', 'sport', 'pharmacy', 'cafe'];
  var DP_LABELS = {
    school: 'Школы', kindergarten: 'Сады', hospital: 'Больницы',
    park: 'Парки', mall: 'ТЦ', sport: 'Спорт',
    pharmacy: 'Аптеки', cafe: 'Кафе'
  };
  var DP_RADIUS = {
    school: 2, kindergarten: 1, hospital: 2, park: 1,
    mall: 2, sport: 1, pharmacy: 1, cafe: 1
  };

  function renderDistrictPills() {
    var wrap = $('jkDistrictPills');
    var listEl = $('jkDistrictPillsList');
    if (!wrap || !listEl || !JK) return;
    var rating = JK.district_rating;
    var counts = (JK.district_counts && typeof JK.district_counts === 'object') ? JK.district_counts : {};
    var nearest = (JK.district_nearest && typeof JK.district_nearest === 'object') ? JK.district_nearest : {};
    if (rating == null) return; // не пересчитано — не показываем

    var rounded = (+rating).toFixed(1);
    var head = '<div class="jk-district-pills__score" title="Рейтинг района ' + rounded + ' из 10">'
      + '<i class="fas fa-chart-simple"></i> Рейтинг района <strong>' + rounded + '</strong><small>/10</small>'
      + '</div>';

    var pills = DP_CATS.map(function(cat) {
      var n = +(counts[cat] || 0);
      var label = DP_LABELS[cat];
      var radius = DP_RADIUS[cat];
      var iconRef = '/img/district-icons.svg#di-' + cat;
      var base = '<svg class="di-icon" aria-hidden="true"><use href="' + iconRef + '"></use></svg>'
        + '<span class="di-pill__cat">' + esc(label) + '</span>';
      if (n > 0) {
        return '<button type="button" class="di-pill jk-dp-pill" data-cat="' + cat + '" data-n="' + n + '" data-radius="' + radius + '" aria-label="' + esc(label + ': ' + n) + '">'
          + base + '<span class="di-pill__n">' + n + '</span></button>';
      }
      var ne = nearest[cat];
      if (ne && ne.dist_km) {
        var km = Math.round((+ne.dist_km) * 10) / 10;
        return '<button type="button" class="di-pill di-pill--empty jk-dp-pill" data-cat="' + cat + '" data-n="0" data-radius="' + radius + '" data-nearest-name="' + esc(ne.name || '') + '" data-nearest-km="' + km + '" aria-label="' + esc(label + ': нет в радиусе, ближайший ' + km + ' км') + '">'
          + base + '<span class="di-pill__n">' + km + ' км</span></button>';
      }
      return '<button type="button" class="di-pill di-pill--empty jk-dp-pill" data-cat="' + cat + '" data-n="0" data-radius="' + radius + '" aria-label="' + esc(label + ': нет данных') + '">'
        + base + '<span class="di-pill__n">—</span></button>';
    }).join('');

    var html = head + pills;
    listEl.innerHTML = html;
    wrap.classList.remove('jk-hidden');
    bindDistrictPillEvents();
  }

  var _dpTooltipCache = {};
  function bindDistrictPillEvents() {
    var pills = document.querySelectorAll('.jk-dp-pill');
    pills.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        openDistrictTooltip(btn);
      });
    });
    var closeBtn = document.querySelector('.jk-district-tooltip__close');
    if (closeBtn && !closeBtn._dpBound) {
      closeBtn._dpBound = true;
      closeBtn.addEventListener('click', function(e) { e.stopPropagation(); closeDistrictTooltip(); });
    }
    if (!document._dpOutsideBound) {
      document._dpOutsideBound = true;
      document.addEventListener('click', function(e) {
        var tip = $('jkDistrictTooltip');
        if (tip && !tip.classList.contains('jk-hidden') && !tip.contains(e.target)) closeDistrictTooltip();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeDistrictTooltip();
      });
    }
  }

  function closeDistrictTooltip() {
    var tip = $('jkDistrictTooltip');
    if (!tip) return;
    tip.classList.add('jk-hidden');
    tip.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('.jk-dp-pill.active').forEach(function(b) { b.classList.remove('active'); });
  }

  function openDistrictTooltip(btn) {
    var tip = $('jkDistrictTooltip');
    var title = $('jkDistrictTooltipTitle');
    var list = $('jkDistrictTooltipList');
    if (!tip || !title || !list || !JK) return;
    var cat = btn.getAttribute('data-cat');
    var n = +btn.getAttribute('data-n');
    var radius = btn.getAttribute('data-radius');
    var label = DP_LABELS[cat] || cat;

    document.querySelectorAll('.jk-dp-pill.active').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');

    title.textContent = label + (n > 0 ? ' в радиусе ' + radius + ' км (' + n + ')' : ' — нет в радиусе ' + radius + ' км');
    list.innerHTML = '<li class="jk-district-tooltip__loading">Загрузка…</li>';
    tip.classList.remove('jk-hidden');
    tip.setAttribute('aria-hidden', 'false');

    if (n === 0) {
      var name = btn.getAttribute('data-nearest-name') || '';
      var km = btn.getAttribute('data-nearest-km') || '';
      if (name && km) {
        list.innerHTML = '<li class="jk-district-tooltip__empty">Ближайший: <strong>' + esc(name) + '</strong> — ' + esc(km) + ' км</li>';
      } else {
        list.innerHTML = '<li class="jk-district-tooltip__empty">Нет данных</li>';
      }
      return;
    }

    var cacheKey = JK.id + '|' + cat;
    if (_dpTooltipCache[cacheKey]) {
      renderDistrictTooltipItems(list, _dpTooltipCache[cacheKey]);
      return;
    }
    fetch('/map_api.php?action=district_top&building_id=' + encodeURIComponent(JK.id) + '&category=' + encodeURIComponent(cat) + '&limit=3', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(j) {
        if (!j || !j.ok || !Array.isArray(j.items)) throw new Error('bad resp');
        _dpTooltipCache[cacheKey] = j.items;
        renderDistrictTooltipItems(list, j.items);
      })
      .catch(function() { list.innerHTML = '<li class="jk-district-tooltip__empty">Не удалось загрузить</li>'; });
  }

  function renderDistrictTooltipItems(list, items) {
    if (!items.length) { list.innerHTML = '<li class="jk-district-tooltip__empty">Пусто</li>'; return; }
    list.innerHTML = items.map(function(it) {
      var distM = +it.distance_m || 0;
      var walk = +it.walk_minutes || 0;
      var distTxt = distM >= 1000 ? (distM / 1000).toFixed(1) + ' км' : distM + ' м';
      return '<li class="jk-district-tooltip__item">'
        + '<span class="jk-district-tooltip__name">' + esc(it.name || '—') + '</span>'
        + '<span class="jk-district-tooltip__meta">' + esc(distTxt) + ' · <i class="fas fa-person-walking"></i> ' + walk + ' мин</span>'
        + '</li>';
    }).join('');
  }

  // ═══ SEO CROSSLINKS EXPANDED (C8) ═══
  function renderSeoLinks() {
    const el = $('jkSeoLinks');
    if (!el || !JK) return;

    const seo = JK.seo_links;
    const hasDynamic = seo && (seo.cities && seo.cities.length || seo.districts && seo.districts.length);

    if (!hasDynamic) {
      const cities = ['\u041a\u0443\u0440\u0441\u043a', '\u0411\u0435\u043b\u0433\u043e\u0440\u043e\u0434', '\u0412\u043e\u0440\u043e\u043d\u0435\u0436', '\u041c\u043e\u0441\u043a\u0432\u0430', '\u0421\u0430\u043d\u043a\u0442-\u041f\u0435\u0442\u0435\u0440\u0431\u0443\u0440\u0433', '\u041a\u0440\u0430\u0441\u043d\u043e\u0434\u0430\u0440'];
      const citiesEl = $('jkSeoCities');
      if (citiesEl) {
        citiesEl.innerHTML = '<h4><i class="fas fa-city"></i> \u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u043f\u043e \u0433\u043e\u0440\u043e\u0434\u0430\u043c</h4>' +
          cities.map(function(c) { return '<a href="/catalog.php?city=' + encodeURIComponent(c) + '">' + esc(c) + '</a>'; }).join('');
      }
      el.classList.remove('jk-hidden');
      return;
    }

    el.classList.remove('jk-hidden');

    const citiesEl = $('jkSeoCities');
    if (citiesEl && seo.cities && seo.cities.length) {
      citiesEl.innerHTML = '<h4><i class="fas fa-city"></i> \u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u043f\u043e \u0433\u043e\u0440\u043e\u0434\u0430\u043c</h4>' +
        seo.cities.map(function(c) {
          return '<a href="' + esc(c.url) + '">' + esc(c.name) +
            ' <span class="jk-seo-count">' + (parseInt(c.count, 10) || 0) + '</span></a>';
        }).join('');
    }

    const distEl = $('jkSeoDistricts');
    if (distEl && seo.districts && seo.districts.length) {
      distEl.innerHTML = '<h4><i class="fas fa-map"></i> \u0420\u0430\u0439\u043e\u043d\u044b ' + esc(JK.city || '') + '</h4>' +
        seo.districts.map(function(d) {
          return '<a href="' + esc(d.url) + '">' + esc(d.name) +
            ' <span class="jk-seo-count">' + (parseInt(d.count, 10) || 0) + '</span></a>';
        }).join('');
    }

    const devEl = $('jkSeoDevelopers');
    if (devEl && seo.developers && seo.developers.length) {
      devEl.innerHTML = '<h4><i class="fas fa-building-user"></i> \u0417\u0430\u0441\u0442\u0440\u043e\u0439\u0449\u0438\u043a\u0438</h4>' +
        seo.developers.map(function(d) {
          return '<a href="' + esc(d.url) + '">' + esc(d.name) +
            ' <span class="jk-seo-count">' + (parseInt(d.count, 10) || 0) + '</span></a>';
        }).join('');
    }

    const roomsEl = $('jkSeoRooms');
    if (roomsEl && seo.rooms && seo.rooms.length) {
      roomsEl.innerHTML = '<h4><i class="fas fa-door-open"></i> \u041f\u043e \u043a\u043e\u043c\u043d\u0430\u0442\u043d\u043e\u0441\u0442\u0438</h4>' +
        seo.rooms.map(function(r) {
          return '<a href="' + esc(r.url) + '">' + esc(r.name) + '</a>';
        }).join('');
    }
  }

  // ═══ MANAGER ═══
  function renderManager() {
    var card = $('jkManagerCard');
    var el = $('jkManager');
    if (!el || !card || !JK || !JK.manager) return;
    var m = JK.manager;
    card.classList.remove('jk-hidden');

    var avatar = m.manager_photo
      ? '<img src="' + esc(standSrc(m.manager_photo, 160)) + '" alt="' + esc(m.manager_name) + '" loading="lazy">'
      : '<i class="fas fa-user-tie"></i>';

    el.innerHTML =
      '<div class="jk-mgr-avatar">' + avatar + '</div>' +
      '<div><div class="jk-mgr-name">' + esc(m.manager_name) + '</div>' +
      '<div class="jk-mgr-role">Менеджер по новостройкам</div></div>';

    var actions = '<div class="jk-mgr-actions">';
    if (m.manager_phone && /^\+?[\d\s\-()]+$/.test(m.manager_phone)) actions += '<a href="tel:' + esc(m.manager_phone) + '" class="jk-mgr-btn jk-mgr-btn-call"><i class="fas fa-phone"></i> Позвонить</a>';
    if (m.manager_telegram && /^[a-zA-Z0-9_]{4,32}$/.test(m.manager_telegram)) actions += '<a href="https://t.me/' + esc(m.manager_telegram) + '" class="jk-mgr-btn jk-mgr-btn-tg" target="_blank" rel="noopener"><i class="fab fa-telegram"></i> Написать</a>';
    actions += '</div>';
    el.innerHTML += actions;
  }

  function renderDeveloper() {
    const logo = $('jkDevLogo'); if (logo) logo.innerHTML = '<i class="fas fa-building"></i>';
    // ⛔ 7.3: у имени может быть серверная ссылка на страницу застройщика —
    //    textContent стёр бы её вместе с узлом <a>. Тогда имя не трогаем: сервер
    //    уже напечатал то же значение из той же строки карточки.
    const name = $('jkDevName'); if (name && !name.querySelector('a')) name.textContent = JK.developer;
    const sub = $('jkDevSub'); if (sub) sub.textContent = JK.city + ' \xb7 \u0441 ' + (JK.devSince || '');
    const stats = $('jkDevStats');
    if (stats) {
      var html = '';
      if (JK.devBuilt) html += '<div class="jk-dev-stat"><div class="jk-dev-stat-val">' + JK.devBuilt + '</div><div class="jk-dev-stat-label">Домов сдано</div></div>';
      if (JK.devProjects) html += '<div class="jk-dev-stat"><div class="jk-dev-stat-val">' + JK.devProjects + '</div><div class="jk-dev-stat-label">ЖК сдано</div></div>';
      if (JK.devRating) html += '<div class="jk-dev-stat"><div class="jk-dev-stat-val">' + JK.devRating + '</div><div class="jk-dev-stat-label">Рейтинг</div></div>';
      if (!html) html = '<div class="jk-dev-stat"><div class="jk-dev-stat-val">—</div><div class="jk-dev-stat-label">Данные уточняются</div></div>';
      stats.innerHTML = html;
    }
  }

  // ═══ V2 REDESIGN RENDER FUNCTIONS ═══

  function renderInfoHeader() {
    if (!JK) return;
    var title = $('jkInfoTitle');
    if (title) title.innerHTML = '\u0416\u041a \xab<span>' + esc(JK.name) + '</span>\xbb';
    // \u26d4 \u0422\u043e\u0442 \u0436\u0435 \u043a\u043e\u0440\u043e\u0442\u043a\u0438\u0439 \u0430\u0434\u0440\u0435\u0441, \u0447\u0442\u043e \u0438 \u0432 \u043f\u043e\u043b\u043e\u0441\u0435 (\u0441\u043c. renderAll): \u0434\u043b\u0438\u043d\u043d\u044b\u0439 \u0438\u0437 \u0444\u0438\u0434\u0430
    //    \u0437\u0430\u043d\u0438\u043c\u0430\u043b \u0442\u0440\u0438 \u0441\u0442\u0440\u043e\u043a\u0438, \u0430 \u043f\u0440\u0438 \u043f\u0443\u0441\u0442\u043e\u043c \u0440\u0430\u0439\u043e\u043d\u0435 \u0434\u0430\u0432\u0430\u043b \u0432\u0438\u0441\u044f\u0449\u0435\u0435 \u00ab \u00b7 \u0440-\u043d\u00bb.
    jkApplyInfoAddress();
    var favBtn = $('jkFavV2');
    if (favBtn) { favBtn.classList.remove('jk-hidden'); favBtn.addEventListener('click', function() { favBtn.classList.toggle('jk-btn-fav-active'); }); }
  }

  function renderGalleryTags() {
    var container = $('jkGalleryTags'); if (!container || !JK) return;
    var tags = ['\u0412\u0441\u0435 \u0444\u043e\u0442\u043e'];
    if (JK.photos && JK.photos.length) tags.push('\u0420\u0435\u043d\u0434\u0435\u0440\u044b');
    if (JK.construction && JK.construction.length) tags.push('\u0421\u0442\u0440\u043e\u0439\u043a\u0430');
    if (JK.planPhotos && JK.planPhotos.length) tags.push('\u041f\u043b\u0430\u043d\u0438\u0440\u043e\u0432\u043a\u0438');
    if (tags.length < 2) return;
    container.classList.remove('jk-hidden');
    container.innerHTML = tags.map(function(t, i) {
      return '<div class="jk-gallery-tag' + (i === 0 ? ' active' : '') + '">' + esc(t) + '</div>';
    }).join('');
    container.querySelectorAll('.jk-gallery-tag').forEach(function(tag) {
      tag.addEventListener('click', function() {
        container.querySelectorAll('.jk-gallery-tag').forEach(function(t) { t.classList.remove('active'); });
        tag.classList.add('active');
      });
    });
  }

  function renderBookingSidebar() {
    if (!JK) return;
    var priceEl = $('jkAsidePrice');
    if (priceEl && JK.priceFrom) priceEl.textContent = fmt(JK.priceFrom);
    var ctaBtn = $('jkAsideCta');
    if (ctaBtn) ctaBtn.addEventListener('click', function() { var mainCta = $('jkCta'); if (mainCta) mainCta.click(); });
    var callBtn = $('jkAsideCall');
    if (callBtn) callBtn.addEventListener('click', function() { window.location.href = 'tel:+79191701918'; });
    // Timer from promos
    if (JK.promos && JK.promos.length) {
      var promo = JK.promos.find(function(p) { return p.deadline; });
      if (promo) {
        var timerEl = $('jkAsideTimer');
        var timerText = $('jkAsideTimerText');
        if (timerEl && timerText) { timerEl.classList.remove('jk-hidden'); timerText.textContent = '\u0410\u043a\u0446\u0438\u044f \u0434\u043e ' + esc(promo.deadline); }
      }
    }
  }

  /**
   * Листание снимков прямо в блоке «О ЖК» (17.08.2026, просьба владельца —
   * «поставь стрелки как в форме обратной связи»).
   *
   * Раньше крупный кадр был неподвижен: сменить его можно было только через
   * миниатюры или открыв лайтбокс. Стрелки листают на месте.
   *
   * ⛔ Кладём стрелки НЕ внутрь `.jk-about__hero`: это <button>, а кнопка в
   *    кнопке — невалидная разметка, и браузер разбирает её непредсказуемо.
   *    Вешаем на `.jk-about__gal`, позиционируя по высоте крупного кадра.
   * ⛔ Меньше двух снимков — ничего не рисуем: листать нечего, а пустые стрелки
   *    обещают то, чего нет.
   */
  function bindAboutGallery(section) {
    var gal = section.querySelector('.jk-about__gal');
    var hero = section.querySelector('.jk-about__hero');
    var big = hero && hero.querySelector('img');
    if (!gal || !big) return;

    // ⛔ СПИСОК КАДРОВ — ВСЕ, А НЕ ПЯТЬ НАПЕЧАТАННЫХ. Сначала он собирался из
    //    разметки — крупный кадр плюс миниатюры. Но лента показывает не все снимки:
    //    последняя плитка несёт значок «+N», а подпись под кадром печатает полное
    //    количество. Получалось «Галерея комплекса · 7» при счётчике «1 / 5» — два
    //    числа об одном и том же, разошедшиеся на глазах у человека.
    // ⛔ ПОРЯДОК — СВОЙ, БЛОКА «О ЖК» (vision), А НЕ ЛЕНТЫ ГЕРОЯ (браузерный).
    //    Адреса берём из JK.photos (это лента героя), а последовательность — из
    //    data-about-order, куда сервер положил перестановку номерами. До 18.08 здесь
    //    стоял голый JK.photos: миниатюры показывали один порядок, а стрелка над
    //    крупным кадром уводила в другой — то есть нажатие ► рядом с первым кадром
    //    показывало НЕ второй кадр блока. Порядки разные намеренно, см. памятку в
    //    app/templates/pages/jk_content.php.
    // ⛔ Прогоняем через thumbUrl(..., 1200): в JK.photos лежат ИСХОДНЫЕ адреса
    //    (CDN застройщика, до 10 МБ), а разметка отдаёт их через наш прокси.
    //    Без этого листание тянуло бы оригиналы мимо кэша.
    var shots = [];
    if (JK && JK.photos && JK.photos.length) {
      var order = (section.getAttribute('data-about-order') || '').split(',');
      var picked = [];
      for (var oi = 0; oi < order.length; oi++) {
        var oat = parseInt(order[oi], 10);
        if (!isNaN(oat) && JK.photos[oat]) picked.push(JK.photos[oat]);
      }
      // Разметка без перестановки (страница из кэша браузера) — прежнее поведение.
      shots = (picked.length ? picked : JK.photos).map(function(url) { return thumbUrl(url, 1200); });
    }
    if (shots.length < 2) {
      // Запасной путь: страница без JK.photos (или снимков меньше двух) —
      // собираем что есть в разметке. Адреса миниатюр приходят с w=480, а
      // крупному нужен w=1200, иначе мыло на 358 px.
      shots = [big.getAttribute('src')];
      section.querySelectorAll('.jk-about__thumb img').forEach(function(t) {
        var src = (t.getAttribute('src') || '').replace(/([?&]w=)\d+/, '$11200');
        if (src && shots.indexOf(src) === -1) shots.push(src);
      });
    }
    if (shots.length < 2) return;

    var at = 0;
    var nav = document.createElement('div');
    nav.className = 'jk-about__nav';
    var count = document.createElement('span');
    count.className = 'jk-about__nav-count';

    // ⛔ РАЗДЕЛЕНО НАМЕРЕННО. Раньше при запуске звался show(), а он переписывает
    //    src крупного кадра. Адрес из JK.photos не обязан совпадать посимвольно
    //    с тем, что отдал сервер, поэтому браузер заново качал ПЕРВОЕ фото на
    //    каждом открытии страницы — лишний трафик и заметный скачок вёрстки
    //    (в проверке он успевал сбросить наведение и погасить стрелки).
    //    При запуске трогаем только подпись; картинку — лишь когда листают.
    function label() {
      count.textContent = (at + 1) + ' / ' + shots.length;
    }

    function show() {
      big.setAttribute('src', shots[at]);
      label();
    }

    function arrow(dir, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jk-about__nav-btn jk-about__nav-btn--' + dir;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      b.addEventListener('click', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        at = (at + (dir === 'prev' ? -1 : 1) + shots.length) % shots.length;
        show();
      });
      return b;
    }

    nav.appendChild(arrow('prev', 'Предыдущий снимок', '‹'));
    nav.appendChild(arrow('next', 'Следующий снимок', '›'));
    nav.appendChild(count);
    gal.appendChild(nav);
    label();
  }

  /**
   * ⛔ КАКОЙ КАДР ОТКРЫВАТЬ ПО НАЖАТИЮ НА МИНИАТЮРУ БЛОКА «О ЖК».
   *
   * У блока «О ЖК» СВОЙ порядок кадров (vision — фасады по уверенности), у ленты
   * героя — свой (браузерный, AI-кадр первым). Списки те же, порядок разный, и это
   * намеренно: см. памятку в app/templates/pages/jk_content.php.
   *
   * До 18.08.2026 сюда шёл голый номер `data-shot`, а лайтбокс листает ленту героя —
   * то есть нажатие на вторую миниатюру открывало ЧУЖУЮ фотографию. Не теория: так
   * было на проде у 137 ЖК из 152. Ищем по АДРЕСУ (`data-shot-src`), потому что адрес
   * — единственное, что у двух списков общее.
   *
   * ⛔ Запасной путь по номеру обязателен: разметку рисует сервер, и старая страница
   *    из кэша браузера/CDN приедет без `data-shot-src`. Прежнее поведение хуже
   *    нового, но лучше «кнопка не работает».
   */
  function aboutShotIndex(btn) {
    var src = btn.getAttribute('data-shot-src') || '';
    if (src) {
      var at = activeHeroPhotos.indexOf(src);
      if (at >= 0) return at;
    }
    var idx = parseInt(btn.getAttribute('data-shot'), 10);
    return isNaN(idx) ? 0 : idx;
  }

  function bindHeroButtons() {
    // Gallery button → open lightbox
    var galleryBtn = $('jkGalleryBtn');
    if (galleryBtn) galleryBtn.addEventListener('click', function() { openLightbox(0); });
    // 28.07.2026: галерея внутри блока «О ЖК» (jk_content.php). Делегат на секции:
    // карточки рендерит сервер, отдельных биндов на каждую не нужно.
    // ⛔ НОМЕР МИНИАТЮРЫ — НЕ ИНДЕКС В ЛАЙТБОКСЕ. Порядки двух лент разные, кадр
    //    находим по адресу — см. aboutShotIndex() выше.
    var aboutSection = $('jkAiDescServer');
    if (aboutSection) {
      aboutSection.addEventListener('click', function(e) {
        // ⛔ Стрелки листания лежат ВНУТРИ секции и не имеют data-shot: без этой
        //    проверки клик по стрелке всплывал бы сюда и открывал лайтбокс —
        //    то есть листать на месте стало бы невозможно.
        if (e.target.closest('.jk-about__nav')) return;
        var shot = e.target.closest('[data-shot]');
        if (!shot) return;
        openLightbox(aboutShotIndex(shot));
      });
      bindAboutGallery(aboutSection);
    }
    // Hero CTA → main CTA
    // 02.07: «Контакты застройщика» → «Забронировать квартиру» (решение владельца):
    // вместо tel: открываем модалку заявки — лид с формой, воронка БРОНИДОМ.
    // ⛔ 17.08.2026 ПОВЕДЕНИЕ ВЕРНУЛИ К ЗАЯВКЕ — решение владельца.
    //    Было: «подпись обещает выбор — пусть и ведёт к выбору», кнопка
    //    прокручивала к разделу квартир (и только на телефоне открывала форму).
    //    Стало: форма всегда. Довод владельца — «страница короткая, до квартир
    //    человек и так дойдёт сам, а с первого экрана нужнее звонок».
    //    Прокрутку убрали целиком: раздел квартир остаётся в липкой панели и в
    //    оглавлении, то есть путь к выбору не потерян.
    //    ⛔ Зовём openLeadModal, а НЕ openCallbackModal напрямую: выбор между
    //    карточным окном (с рендером, ценой, метро) и простым «Заказать звонок»
    //    живёт именно в openLeadModal. Прямой вызов открывал простую форму даже
    //    на широком экране — проверено кликом, окно поднималось не то.
    //    За карточный вид отвечает ещё и запись `jkHeroContact` в
    //    CARD_LEAD_SOURCES (jk-card.js): без неё метка источника заявки пустая.
    var heroContact = $('jkHeroContact');
    if (heroContact) heroContact.addEventListener('click', function(e) {
      e.preventDefault();
      openLeadModal();
    });
    var heroCallback = $('jkHeroCallback');
    if (heroCallback) heroCallback.addEventListener('click', function() { var mainCta = $('jkCta'); if (mainCta) mainCta.click(); });
    // Phase F3: CTA-footer callback button → вызываем главный jkCta (открывает callback-форму)
    var ctaFooterCallback = $('jkCtaFooterCallback');
    if (ctaFooterCallback) ctaFooterCallback.addEventListener('click', function() { var mainCta = $('jkCta'); if (mainCta) mainCta.click(); });
    // Sticky nav buttons
    var stickyPhone = $('jkStickyPhone');
    if (stickyPhone) stickyPhone.addEventListener('click', function() { window.location.href = 'tel:+79191701918'; });
    var stickyFav = $('jkStickyFav');
    if (stickyFav) stickyFav.addEventListener('click', function() { var mainFav = $('jkFav'); if (mainFav) mainFav.click(); });
    // R2.1 — sticky rail (desktop): заявка / избранное / поделиться
    var railCta = $('jkRailCta');
    if (railCta) railCta.addEventListener('click', function() { var mainCta = $('jkCta'); if (mainCta) mainCta.click(); });
    var railFav = $('jkRailFav');
    if (railFav) railFav.addEventListener('click', function() {
      var favV2 = $('jkFavV2'); if (favV2) favV2.click();
      railFav.classList.toggle('is-active');
    });
    var railShare = $('jkRailShare');
    if (railShare) railShare.addEventListener('click', function() {
      if (navigator.share) {
        navigator.share({ title: document.title, url: location.href })['catch'](function() {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(location.href)['catch'](function() {});
        railShare.classList.add('is-active');
      }
    });
  }

  function renderSpecs() {
    if (!JK) return;

    // Fill dynamic spec cells from API data
    var specCell, specVal;
    if (JK.wall_material) { specCell = $('jkSpecWall'); if (specCell) { specCell.classList.remove('jk-hidden'); specVal = $('jkSpecWallVal'); if (specVal) specVal.textContent = JK.wall_material; } }
    // ⛔ Потолки печатаются ГОТОВОЙ строкой сервера: «2,7 м» либо «3,2–6,7 м».
    // Сервер уже напечатал ту же надпись в разметке — если бы здесь осталась своя
    // склейка `+ ' м'`, JS затирал бы диапазон одним числом сразу после загрузки.
    if (JK.ceiling_text || JK.ceiling_height) { specCell = $('jkSpecCeiling'); if (specCell) { specCell.classList.remove('jk-hidden'); specVal = $('jkSpecCeilingVal'); if (specVal) specVal.textContent = JK.ceiling_text || (JK.ceiling_height + ' м'); } }
    if (JK.finishing_type) { specCell = $('jkSpecFinish'); if (specCell) { specCell.classList.remove('jk-hidden'); specVal = $('jkSpecFinishVal'); if (specVal) specVal.textContent = JK.finishing_type; } }
    if (JK.parking_type) { specCell = $('jkSpecParking'); if (specCell) { specCell.classList.remove('jk-hidden'); specVal = $('jkSpecParkingVal'); if (specVal) specVal.textContent = JK.parking_type; } }

    // Metro / transport info
    // ⛔ АЭРОПОРТ УБРАН ОТСЮДА 25.08.2026 — аудит партнёра Галс, находка В-20.
    //    Здесь стояла вторая, КЛИЕНТСКАЯ отрисовка строки «Внуково (VKO) — 21,9 км»:
    //    из списка JK.metros отбирались записи с типом аэропорта, блок паспорта
    //    с самолётиком снимал класс скрытия и заполнялся готовой вёрсткой.
    //    ⚠️ Убрать её было ОБЯЗАТЕЛЬНО: удаления одного PHP мало — этот код вернул бы
    //    строку на экран уже после загрузки страницы. Замер 25.08: аэропорт ближе 5 км
    //    (отсечка выборки в jk_manager.php) есть у трёх домов — то есть путь живой,
    //    а не теоретический.
    //    Почему показатель убран целиком и при каком условии его можно вернуть —
    //    в шапке app/templates/pages/jk_content.php, там же замер по 154 домам.
    //    Фильтр type !== 'airport' ниже ОСТАВЛЕН намеренно: без него аэропорт
    //    провалился бы в строку метро и подписался бы значком метро.
    if (JK.metros && JK.metros.length) {
      var metroItems = JK.metros.filter(function(m) { return m.type !== 'airport'; });

      var metroEl = $('jkSpecsMetro');
      if (metroEl && metroItems.length) {
        metroEl.classList.remove('jk-hidden');
        metroEl.innerHTML = metroItems.slice(0, 2).map(function(m) {
          var icon = (m.type === 'train') ? 'fa-train' : 'fa-subway';
          return '<i class="fas ' + icon + '"></i> ' + esc(m.name) + (m.distance_km ? ' <span class="jk-specs-metro-walk">' + esc(m.distance_km) + ' км</span>' : '');
        }).join(' &nbsp; ');
      }
    }

    // Minimap init (Yandex Maps) — ПАССИВНО (JK-PERF 31.07): миниатюра больше не
    // заказывает ядро сама (оно тянулось за семь экранов до карты и морозило
    // раскрытие планировок — см. whenYmapsLoaded). Пока ядра нет, у миниатюры
    // стоит её SSR-плейсхолдер, а клик по ней и так только пролистывает к карте.
    var minimapEl = $('jkSpecsMinimap');
    if (minimapEl && JK.lat && JK.lng) {
      // ⛔ В НОЛЬ-РАЗМЕРНЫЙ УЗЕЛ КАРТУ НЕ ЗАВОДИМ. На 901-1180 px миниатюра скрыта
      //    стилем (@media max-width:1180px .hero-specs__map{display:none}), а ymaps
      //    считает размеры при создании: карта осталась бы пустым прямоугольником
      //    и после расширения окна сама бы не пересчиталась. Ждём, пока узел
      //    получит размер, и только тогда создаём.
      // ⛔ Картинка карты (SSR) закрывает промежуток до приезда ядра. Если она НЕ
      //    загрузилась — ключ Яндекса для статических карт бывает отдельный от
      //    ключа JS-API — убираем её совсем, иначе пустой прямоугольник накроет
      //    заглушку «Смотреть на карте» и человек увидит дыру вместо подсказки.
      var mapStill = minimapEl.querySelector('.jk-specs-minimap__still');
      if (mapStill) {
        // ⛔ ПРОВЕРЯЕМ РАЗМЕР, А НЕ ТОЛЬКО СОБЫТИЕ `error`. 16.08 на проде источник
        //    ответил 403 «Invalid api key», а наш img-thumb отдал это КАК УСПЕХ —
        //    картинкой 1×1 в 74 байта. Событие `error` не наступило, пустышка
        //    растянулась на весь узел и закрыла собой заглушку «Смотреть на карте»:
        //    вместо подсказки человек видел пустой прямоугольник.
        var dropStill = function() { if (mapStill.parentNode) mapStill.parentNode.removeChild(mapStill); };
        var checkStill = function() { if (mapStill.naturalWidth <= 2 || mapStill.naturalHeight <= 2) dropStill(); };
        mapStill.addEventListener('error', dropStill);
        mapStill.addEventListener('load', checkStill);
        if (mapStill.complete) { if (mapStill.naturalWidth === 0) { dropStill(); } else { checkStill(); } }
      }
      var minimapDone = false;
      var initMinimap = function() {
        if (minimapDone) return true;
        if (!minimapEl.offsetWidth || !minimapEl.offsetHeight) return false;
        minimapDone = true;
        var map = new ymaps.Map(minimapEl, { center: [JK.lat, JK.lng], zoom: 15, controls: [] });
        map.behaviors.disable(['scrollZoom', 'drag']);
        map.geoObjects.add(new ymaps.Placemark([JK.lat, JK.lng], {}, { preset: 'islands#darkOrangeCircleDotIcon' }));
        // Phase E13: скрыть SSR-placeholder после инициализации карты
        minimapEl.classList.add('ymaps-ready');
        return true;
      };
      whenYmapsLoaded(function() {
        if (initMinimap()) return;
        var minimapTimer = null;
        var retryMinimap = function() {
          clearTimeout(minimapTimer);
          minimapTimer = setTimeout(function() {
            if (initMinimap()) window.removeEventListener('resize', retryMinimap);
          }, 200);
        };
        window.addEventListener('resize', retryMinimap);
      });
      minimapEl.addEventListener('click', function() {
        var mapSection = $('jkMap');
        if (mapSection) mapSection.scrollIntoView({ behavior: 'smooth' });
      });
      // Phase E13: keyboard activation (Enter/Space) — role=button tabindex=0
      minimapEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var mapSection = $('jkMap');
          if (mapSection) mapSection.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    // Extra specs (toggle)
    var extra = [];
    if (JK.apartments_count) extra.push({ icon: 'fa-door-open', label: flatsLabelCap(), value: JK.apartments_count });
    if (JK.developer) extra.push({ icon: 'fa-hard-hat', label: 'Застройщик', value: JK.developer });
    if (JK.contract_type) extra.push({ icon: 'fa-file-contract', label: 'Тип договора', value: JK.contract_type });
    if (JK.escrow_bank) extra.push({ icon: 'fa-shield-halved', label: 'Эскроу', value: JK.escrow_bank });
    if (JK.features && JK.features.length) extra.push({ icon: 'fa-tree', label: 'На территории', value: JK.features.map(function(f) { return f.name; }).join(', ') });

    // ⛔ ПОВТОРЫ НЕ РИСУЕМ ВОВСЕ, а не прячем после отрисовки. «Застройщик» и
    //    «Тип договора» слово в слово стоят выше — в полосе фактов, в сетке
    //    характеристик и в обязательном юр-блоке 214-ФЗ. Сравниваем ПАРУ
    //    «подпись + значение»: другое название застройщика — это не повтор.
    // ⛔ Только на компьютере: на телефоне полоса фактов и рамка выглядят иначе,
    //    и «Застройщик» с «Типом договора» там НЕ повтор — их надо оставить.
    if (cardDesktop && jkCard) {
      var shown = jkCard.shownPairs($('jkSpecsExtra'));
      extra = extra.filter(function(s) {
        return !shown['#' + jkCard.norm(s.label) + '|' + jkCard.norm(String(s.value))];
      });
    }

    var extraEl = $('jkSpecsExtra');
    var toggleBtn = $('jkSpecsToggle');
    if (extra.length && extraEl && toggleBtn) {
      extraEl.innerHTML = extra.map(function(s) {
        return '<div class="jk-spec-cell"><i class="fas ' + safeIcon(s.icon) + ' jk-spec-cell__icon"></i><span class="jk-spec-cell__label">' + esc(s.label) + '</span><span class="jk-spec-cell__value">' + esc(String(s.value)) + '</span></div>';
      }).join('');
      toggleBtn.addEventListener('click', function() {
        extraEl.classList.toggle('open');
        toggleBtn.classList.toggle('open');
        toggleBtn.querySelector('span').textContent = extraEl.classList.contains('open') ? 'Скрыть характеристики' : 'Все характеристики комплекса';
      });
    } else if (toggleBtn) {
      toggleBtn.style.display = 'none';
    }

    // Ask developer chips → call
    var askPhone = $('jkAskDevPhone');
    if (askPhone) askPhone.addEventListener('click', function() { window.location.href = 'tel:+79191701918'; });
    var chips = document.querySelectorAll('.jk-ask-dev__chip');
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() { if (askPhone) askPhone.click(); });
    });
  }

  function renderMortgageMini() {
    if (!JK || !JK.mortgagePrograms || !JK.mortgagePrograms.length) return;
    var container = $('jkAsideMortgage'); if (!container) return;
    container.classList.remove('jk-hidden');
    var best = JK.mortgagePrograms.reduce(function(a, b) { return a.rate < b.rate ? a : b; });
    var rateEl = $('jkAsideMortRate'); if (rateEl) rateEl.textContent = best.rate + '%';
    // Calculate monthly payment
    var price = JK.priceFrom || 0;
    var downPct = best.minDown || 15;
    var loan = price * (1 - downPct / 100);
    var mr = best.rate / 100 / 12;
    var months = 25 * 12;
    if (loan > 0 && mr > 0) {
      var mp = loan * mr / (1 - Math.pow(1 + mr, -months));
      var payEl = $('jkAsideMortPayment'); if (payEl) payEl.textContent = fmtK(Math.round(mp)) + '/\u043c\u0435\u0441';
    }
    var downEl = $('jkAsideMortDown'); if (downEl) downEl.textContent = downPct + '% (' + fmtK(Math.round(price * downPct / 100)) + ')';
    var btn = $('jkAsideMortBtn');
    if (btn) btn.addEventListener('click', function() {
      var tabBtn = document.querySelector('[data-tab="mortgage"]');
      if (tabBtn) tabBtn.click();
    });
  }

  function renderTimeline() {
    if (!JK || !JK.construction || !JK.construction.length) return;
    var container = $('jkTimeline'); if (!container) return;
    var items = $('jkTimelineItems'); if (!items) return;
    container.classList.remove('jk-hidden');
    var html = '';
    JK.construction.forEach(function(c, idx) {
      var pct = parseInt(c.progress, 10) || 0;
      var state = pct >= 100 ? 'done' : (idx === JK.construction.length - 1 || pct > 0 ? 'active' : 'future');
      html += '<div class="jk-timeline-item"><div class="jk-timeline-dot ' + state + '"></div>' +
        '<div class="jk-timeline-label ' + state + '">' + esc(c.label || c.date || '') + '</div>' +
        '<div class="jk-timeline-desc">' + pct + '%</div></div>';
    });
    items.innerHTML = html;
  }

  // ═══ LIVE PROMO TIMER (Phase 8, v2 redesign) ═══
  var promoTimerInterval = null;

  function initPromoTimer() {
    if (!JK || !JK.promos || !JK.promos.length) return;
    var promo = JK.promos.find(function(p) { return p.deadline; });
    if (!promo) return;
    var dlDate = new Date(promo.deadline);
    if (isNaN(dlDate.getTime())) return;

    function tick() {
      var diff = dlDate.getTime() - Date.now();
      if (diff <= 0) {
        if (promoTimerInterval) clearInterval(promoTimerInterval);
        var dEl = $('jkTimerDays'); if (dEl) dEl.textContent = '00';
        var hEl = $('jkTimerHours'); if (hEl) hEl.textContent = '00';
        var mEl = $('jkTimerMins'); if (mEl) mEl.textContent = '00';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      dEl = $('jkTimerDays'); if (dEl) dEl.textContent = String(d).padStart(2, '0');
      hEl = $('jkTimerHours'); if (hEl) hEl.textContent = String(h).padStart(2, '0');
      mEl = $('jkTimerMins'); if (mEl) mEl.textContent = String(m).padStart(2, '0');
    }

    tick();
    if (promoTimerInterval) clearInterval(promoTimerInterval);
    promoTimerInterval = setInterval(tick, 60000); // Update every minute
  }

  function renderReviewsSummary() {
    if (!JK || !JK.reviews || !JK.reviews.length) return;
    var container = $('jkReviewsSummary'); if (!container) return;
    container.classList.remove('jk-hidden');
    var total = JK.reviews.length;
    var avg = JK.reviews.reduce(function(s, r) { return s + (r.rating || 0); }, 0) / total;
    avg = Math.round(avg * 10) / 10;
    var ratingEl = $('jkReviewsRating'); if (ratingEl) ratingEl.textContent = avg.toFixed(1);
    var starsEl = $('jkReviewsStars');
    if (starsEl) starsEl.innerHTML = Array.from({length: 5}, function(_, i) { return '<i class="fas fa-star ' + (i < Math.round(avg) ? 'jk-star-on' : 'jk-star-off') + '"></i>'; }).join('');
    var countEl = $('jkReviewsCount'); if (countEl) countEl.textContent = total + ' ' + pluralize(total, '\u043e\u0442\u0437\u044b\u0432', '\u043e\u0442\u0437\u044b\u0432\u0430', '\u043e\u0442\u0437\u044b\u0432\u043e\u0432');
  }

  function renderHotOffer() {
    if (!JK || !JK.promos || !JK.promos.length) return;
    var promo = JK.promos.find(function(p) { return p.deadline; });
    if (!promo) return;
    var container = $('jkHotOffer'); if (!container) return;
    container.classList.remove('jk-hidden');
    var badge = $('jkHotBadge'); if (badge) badge.textContent = esc(promo.title || '\u0410\u041a\u0426\u0418\u042f');
    var text = $('jkHotText'); if (text) text.textContent = promo.desc || promo.title || '';
    // Simple countdown (static display from deadline string)
    var days = $('jkTimerDays');
    var hours = $('jkTimerHours');
    var mins = $('jkTimerMins');
    // Parse deadline to compute remaining time
    var dlDate = new Date(promo.deadline);
    if (!isNaN(dlDate.getTime())) {
      var diff = dlDate.getTime() - Date.now();
      if (diff > 0) {
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        if (days) days.textContent = String(d).padStart(2, '0');
        if (hours) hours.textContent = String(h).padStart(2, '0');
        if (mins) mins.textContent = String(m).padStart(2, '0');
      }
    }
  }

  function pluralize(n, one, few, many) {
    var abs = Math.abs(n) % 100;
    var last = abs % 10;
    if (abs > 10 && abs < 20) return many;
    if (last > 1 && last < 5) return few;
    if (last === 1) return one;
    return many;
  }

  // ФИДЫ-2.0 бл.2: склонение счётчика по СОСТАВУ дома. Формы приходят с бэка
  // (JK.inventory_forms = [1, 2-4, 5+]) — их считает домен ApartmentStatus по лесенке
  // (флаг фида ИЛИ пометка куратора): «квартира/…» / «апартамент/…» / «объект/…».
  // Дефолт «квартира» = поведенческий ноль: пока данные не доехали, текст сегодняшний.
  function flatsPlural(n) {
    var f = (JK && Array.isArray(JK.inventory_forms) && JK.inventory_forms.length === 3)
      ? JK.inventory_forms
      : ['квартира', 'квартиры', 'квартир'];
    return pluralize(n, f[0], f[1], f[2]);
  }

  // Родит. мн. с заглавной для спец-меток «Квартир: N» → «Апартаментов: N».
  function flatsLabelCap() {
    var n = (JK && JK.inventory_noun) ? JK.inventory_noun : 'квартир';
    return n.charAt(0).toUpperCase() + n.slice(1);
  }

  // ═══ ENRICH API DATA ═══
  function roomsDisplay(n) {
    if (n === 0 || n === '0') return 'Студия';
    if (n == null || n === '' || n === false) return '—';
    return String(n);
  }

  // 1.7.5: сводка инвентаря с бэка (flats_summary). Применяется, когда массив
  // flats ПУСТ — при выключенном легаси-флаге сервер его не собирает
  // (7.85 МБ → ~40 КБ). Числа те же, что раньше считал enrichJK сам, поэтому
  // ипотечный калькулятор, «от N ₽/м²» и счётчики не меняются. При откате флага
  // и непустом ЖК flats возвращается и считает он — эта ветка молчит. (Пустой ЖК
  // под флагом=1 тоже попадёт сюда: сводка отдаёт там те же нули.)
  function applyFlatsSummary(jk, s) {
    if (!s || typeof s !== 'object') return false;
    jk.totalFlats = Number(s.total_available) || 0;
    jk.rooms = (Array.isArray(s.by_rooms) ? s.by_rooms : []).map(function(r) {
      var n = r.rooms;
      return {
        type: (n === 0 || n === '0') ? 'Студия' : (n ? String(n) + '-комн.' : '—'),
        ord: (n === 0 || n === '0') ? 0 : (n ? Number(n) : 99),
        count: Number(r.count) || 0,
        priceFrom: Number(r.price_from) || 0,
        icon: 'fa-door-open'
      };
    }).sort(function(a, b) { return a.ord - b.ord; });
    var pf = Number(s.price_from) || 0;
    if (pf > 0) {
      jk.priceFrom = pf;
      jk.priceTo = Number(s.price_to) || pf;
    }
    jk.priceM2From = Number(s.price_m2_from) || 0;
    var aMin = Number(s.area_min) || 0;
    var aMax = Number(s.area_max) || 0;
    if (!jk.areaRange && aMin > 0) {
      jk.areaRange = aMin.toFixed(1) + ' – ' + aMax.toFixed(1) + ' м²';
    }
    return true;
  }

  // Все строки срока в перерисованном паспорте используют серверный диапазон.
  // Исходный deadline остаётся для определения готовности и фильтров.
  function applyDeadlineDisplay(jk) {
    if (jk.deadline_display !== undefined) jk.deadlineLabel = jk.deadline_display;
    else if (window.BRONI_JK_DEADLINE_DISPLAY !== undefined) jk.deadlineLabel = window.BRONI_JK_DEADLINE_DISPLAY;
    else if (!jk.deadlineLabel) jk.deadlineLabel = jk.deadline || 'Строится';
  }

  function enrichJK(jk, flats, summary) {
    // N5 lifecycle: hidden не показываем (бэк уже фильтрует — защита), reserved
    // остаётся в списках с реальным статусом (плашка «Забронирована»).
    jk.apartments = flats.filter(f => f.status !== 'sold' && f.status !== 'hidden').map(f => ({
      id: f.id || 0,
      rooms: roomsDisplay(f.rooms),
      area: f.area,
      floor: f.floor,
      floors: f.floors_total || '—',
      corpus: f.section || '—',
      price: f.price,
      price_old: f.price_old || 0,
      status: f.status === 'reserved' ? 'reserved' : 'sale',
      number: f.number || '',
      kitchen_area: f.kitchen_area || 0,
      living_area: f.living_area || 0,
      decoration: f.decoration || '',
      windows_view: f.windows_view || '',
      ceiling_height: f.ceiling_height || 0,
      layout_url: f.layout_url || '',
    }));
    // N5: счётчики «в продаже» и min-цены — ТОЛЬКО available (без reserved/hidden).
    const forSale = flats.filter(f => !f.status || f.status === 'available');
    jk.totalFlats = forSale.length;
    const roomMap = {};
    forSale.forEach(f => {
      const n = f.rooms;
      const key = (n === 0 || n === '0') ? 'Студия' : (n ? String(n) + '-комн.' : '—');
      const ord = (n === 0 || n === '0') ? 0 : (n ? Number(n) : 99);
      if (!roomMap[key]) roomMap[key] = {type: key, ord: ord, count:0, priceFrom: Infinity, icon:'fa-door-open'};
      roomMap[key].count++;
      if (f.price > 0 && f.price < roomMap[key].priceFrom) roomMap[key].priceFrom = f.price;
    });
    jk.rooms = Object.values(roomMap).sort((a,b) => a.ord - b.ord);
    jk.rooms.forEach(r => { if (r.priceFrom === Infinity) r.priceFrom = 0; });
    // Price range
    const prices = forSale.map(f=>f.price).filter(p=>p>0);
    if (prices.length) {
      jk.priceFrom = Math.min(...prices);
      jk.priceTo = Math.max(...prices);
      jk.priceM2From = Math.min(...forSale.map(f=>f.price_m2).filter(p=>p>0)) || 0;
    } else if (jk.priceFrom && jk.priceFrom < 1000) {
      // API returns priceFrom in millions — normalize to rubles
      jk.priceFrom = Math.round(jk.priceFrom * 1000000);
      if (jk.priceTo && jk.priceTo < 1000) jk.priceTo = Math.round(jk.priceTo * 1000000);
    }
    // 1.7.5: поштучных данных нет → те же числа берём из серверной сводки.
    // Порядок важен: сводка обязана лечь ДО блока умолчаний ниже, иначе
    // areaRange успеет зафиксироваться пустой строкой.
    if (!flats.length) applyFlatsSummary(jk, summary);
    // Defaults for missing fields
    if (typeof jk.priceM2From !== 'number') jk.priceM2From = 0;
    if (!jk.rating) jk.rating = 0;
    if (!jk.reviewsCount) jk.reviewsCount = 0;
    if (!jk.badges) jk.badges = [];
    if (!jk.areaRange) {
      const areas = flats.map(f=>f.area).filter(a=>a>0);
      jk.areaRange = areas.length ? Math.min(...areas).toFixed(1) + ' – ' + Math.max(...areas).toFixed(1) + ' м²' : '';
    }
    applyDeadlineDisplay(jk);
    if (!jk.description && jk.desc) jk.description = jk.desc;
    if (!jk.mortgagePrograms) jk.mortgagePrograms = [];
    if (!jk.construction) jk.construction = [];
    // Enrich nearby from API nearby_pois (building_metros)
    if (!jk.nearby) jk.nearby = [];
    if (jk.nearby_pois && jk.nearby_pois.length && !jk.nearby.length) {
      var poiIcons = {metro:'fa-subway',train:'fa-train',highway:'fa-road',school:'fa-school',kindergarten:'fa-child-reaching',hospital:'fa-hospital',mall:'fa-shopping-bag',park:'fa-tree',sport:'fa-dumbbell',bus_stop:'fa-bus',tram:'fa-train-tram',university:'fa-graduation-cap',pharmacy:'fa-prescription-bottle-medical',cafe:'fa-mug-hot',bank:'fa-building-columns'};
      jk.nearby = jk.nearby_pois.map(function(p) {
        // ⛔ ВТОРАЯ ТОЧКА той же выдумки «расстояние ÷ 5 км/ч». Отсюда `dist`
        //    печатается на шаре карты и в списке «рядом»: аэропорт за 65 км
        //    выходил «780 мин пешком». Дальше 5 км показываем само расстояние, а
        //    флаг walkable говорит печатающим местам, ставить ли слово «пешком»
        //    и значок пешехода. Порог работает на всех ширинах: это правка текста,
        //    а не вёрстки (решение 16.08).
        var pKm = parseFloat(p.distance_km) || 0;
        var walkMin = (pKm > 0 && pKm <= 5) ? Math.round(pKm / 5 * 60) : 0;
        return { name: p.name, type: p.type, icon: poiIcons[p.type] || 'fa-location-dot',
          dist: walkMin ? walkMin + ' мин' : (pKm ? pKm.toFixed(1) + ' км' : ''),
          walkable: walkMin > 0,
          distance_km: pKm, lat: parseFloat(p.latitude) || 0, lng: parseFloat(p.longitude) || 0 };
      });
    }
    if (!jk.reviews) jk.reviews = [];
    if (!jk.qa) jk.qa = [];
    if (!jk.similar) jk.similar = [];
    if (!jk.corpus) jk.corpus = [];
    if (!jk.promos) jk.promos = [];
    // FEED-017 (2026-04-11): fallback — если photos пустой, но image_url есть,
    // используем его как единственный слайд героя. photos в БД теперь immutable
    // через фид, но image_url заполняем вручную (tools/apply_jk_renders.php).
    if ((!jk.photos || !jk.photos.length) && jk.image_url) {
      jk.photos = [jk.image_url];
    }
    // FEED-032: AI-улучшенное фото первым слайдом.
    // ⛔ М1 (18.08.2026): ЭТОТ ШАГ ПЕРЕЕХАЛ НА СЕРВЕР и здесь СНЯТ НАМЕРЕННО.
    //    Тут стояло `jk.photos.unshift(jk.enhanced_image_url)` с дедупом. Сервер о
    //    нём не знал и рисовал ленту прямо из колонки `photos` — то есть первый
    //    слайд у сервера и у браузера отличался у 38 ЖК гарантированно. С ленивой
    //    лентой это уже не «лишний трафик», а тёмный прямоугольник: показанный кадр
    //    никем не скачан.
    //    ⛔ ПОРЯДОК НЕ ИЗМЕНИЛСЯ НИ НА КАДР. Ровно это же теперь делает сервер —
    //    ImageVerdictPolicy::galleryForShowcase() — и на обоих концах сразу:
    //    enhanced первым без дубля, дальше колонка как есть. Браузер получает
    //    готовый список и НЕ переставляет его.
    //    ⛔ ВЕРНУТЬ unshift СЮДА НЕЛЬЗЯ: у 7 ЖК, где enhanced нет в `photos`, кадр
    //    задвоится, а у 31 — порядок разъедется с серверным. Сторож —
    //    tests/JS/jk-gallery-order-passthrough.test.js (он же и ловит возврат).
    // Map API snake_case → JS camelCase aliases
    if (!jk.lat && jk.latitude) jk.lat = jk.latitude;
    if (!jk.lng && jk.longitude) jk.lng = jk.longitude;
    if (!jk.class && jk.building_class) jk.class = jk.building_class;
    if (!jk.ceilingHeight && jk.ceiling_height) jk.ceilingHeight = jk.ceiling_height;
    if (!jk.parking && jk.parking_type) jk.parking = jk.parking_type;
    if (!jk.buildingType && jk.material) jk.buildingType = jk.material;
    if (!jk.buildingType && jk.wall_material) jk.buildingType = jk.wall_material;
    if (!jk.devBuilt && jk.developer_built) jk.devBuilt = jk.developer_built;
    if (!jk.devProjects && jk.developer_projects) jk.devProjects = jk.developer_projects;
    // Phase B fields passthrough
    if (jk.building_class === undefined) jk.building_class = null;
    if (jk.wall_material === undefined) jk.wall_material = null;
    if (jk.finishing_type === undefined) jk.finishing_type = null;
    if (jk.parking_type === undefined) jk.parking_type = null;
    if (jk.ceiling_height === undefined) jk.ceiling_height = null;
    if (jk.ceiling_text === undefined) jk.ceiling_text = null;
    if (jk.contract_type === undefined) jk.contract_type = null;
    if (jk.escrow_bank === undefined) jk.escrow_bank = null;
    if (jk.area_score === undefined) jk.area_score = null;
    if (jk.transit_score === undefined) jk.transit_score = null;
    if (jk.kids_score === undefined) jk.kids_score = null;
    if (!jk.documents) jk.documents = [];
    if (!jk.specs) jk.specs = [];
    if (!jk.price_history) jk.price_history = null;
    if (jk.market_comparison === undefined) jk.market_comparison = null;
    if (jk.cadastral === undefined) jk.cadastral = null;
    if (jk.ai_description === undefined) jk.ai_description = null;
    if (jk.landmarks === undefined) jk.landmarks = [];
    // 3.1.1/3.1.1b: similar_by_price/recently_built больше не рендерятся (секции убраны).
    // 7.3 (24.09.2026): same_developer тоже больше не читается — «Другие ЖК
    // застройщика» печатает сервер (см. renderSimilar).
    // Phase C8: SEO-перелинковка
    if (jk.seo_links === undefined) jk.seo_links = null;
    // Phase C9: индикатор цены + FOMO
    if (jk.price_change === undefined) jk.price_change = null;
    if (jk.recent_viewers === undefined) jk.recent_viewers = 0;
    // FEED-030: расширенные поля фидов
    if (!jk.infrastructure) jk.infrastructure = [];
    if (!jk.promotions) jk.promotions = [];
    if (!jk.mortgage_programs) jk.mortgage_programs = [];
    if (!jk.video_url) jk.video_url = null;
    // Extract unique plan images from flats.
    // 1.7.5: при выключенном легаси-флаге поштучного массива нет, и здесь
    // остаётся пустой список — чертежи для таба «Планировки» досыпает
    // initHeroPlansFromFilter() из ответа умного фильтра (view=plans).
    if (!jk.plans) {
      const planSet = {};
      flats.forEach(function(f) { if (f.layout_url) planSet[f.layout_url] = true; });
      jk.plans = Object.keys(planSet);
    }
    if (!jk.constructionPhotos) jk.constructionPhotos = [];
    return jk;
  }

  // ═══ НИЖНЯЯ ПАНЕЛЬ «ЗАЯВКА / ЗВОНОК / MAX» — ПО ПРОКРУТКЕ (yandex-mobile 1.2, вариант А) ═══
  // ⛔ РЕШЕНИЕ ВЛАДЕЛЬЦА 18.09.2026. Панель стояла на телефоне с первого экрана:
  //    замер 320×568 — шапка 10,6 % + панель 10,9 % + планка cookie 8,6 % + кружки
  //    = 34,6 % экрана под плавающими панелями, заголовок закрыт наполовину. Мобильный
  //    робот Яндекса смотрит ровно этот первый экран. Теперь панель выезжает, когда
  //    ряд кнопок героя («Выбрать квартиру / Перезвоните мне») УШЁЛ ВВЕРХ за экран:
  //    пока он виден или ещё впереди — те же действия уже под пальцем.
  //    Панель fixed — макет не прыгает. Спрятанная панель — `visibility:hidden`
  //    (css/jk.css), то есть вне Tab-порядка и вне дерева скринридера; показанная —
  //    обычные кнопки. Без наблюдателя, без ряда героя или если ряд скрыт —
  //    панель показывается всегда, как было: действие не имеет права пропасть.
  (function initBottomBarReveal() {
    var bar = $('jkBottomBar');
    var anchor = document.querySelector('.jk-hero-cta-row');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    // Высота панели — в переменную: на неё сдвигаются кружки и планка cookie, когда панель
    // выезжает (css/jk.css). Сдвиг через `translate`, а не через `bottom`: смена `bottom`
    // у fixed-элемента — сдвиг макета, его считает CLS (VERIFY-1.2b, P1-1: 0,008 → 0,150).
    // ⛔ Высоту пересчитываем при смене размера (VERIFY-1.2b, P2-6): открыли на 1366 —
    //    панель скрыта (display:none), высота 0; сузили до 375 — без пересчёта кружки и
    //    планка стояли бы без подъёма и легли бы на панель. Не чаще раза в кадр.
    var lastH = '';
    function setH() {
      var h = bar.offsetHeight;
      if (!h) return;                         // панель не показана на этой ширине — запасное значение CSS
      if (h + 'px' !== lastH) { lastH = h + 'px'; document.documentElement.style.setProperty('--jk-bb-h', lastH); }
    }
    setH();
    var hQueued = false;
    function queueH() {
      if (hQueued) return;
      hQueued = true;
      (window.requestAnimationFrame || setTimeout)(function () { hQueued = false; setH(); });
    }
    window.addEventListener('resize', queueH);
    if (typeof ResizeObserver === 'function') new ResizeObserver(queueH).observe(bar);
    // Панель нужна, когда ряд кнопок героя ушёл ВВЕРХ за экран или скрыт стилями.
    function passed(r) { return r.height === 0 || r.bottom <= 0; }
    function sync() { bar.classList.toggle('jk-bb-shown', passed(anchor.getBoundingClientRect())); }
    // Первое положение — СРАЗУ и без анимации: иначе панель, нарисованная до запуска
    // скрипта, на глазах уезжала бы вниз (замер: на срезе `load` она ещё ехала).
    sync();
    bar.classList.add('jk-bb-reveal');
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { bar.classList.add('jk-bb-anim'); });
      });
    }
    var io = new IntersectionObserver(sync, { threshold: 0 });
    io.observe(anchor);
    // ⛔ Наблюдатель молчит, если ряд перепрыгнул из «выше экрана» сразу в «ниже экрана»:
    //    признак пересечения не меняется (мгновенный прыжок наверх, якорь, Home) — панель
    //    оставалась на первом экране (VERIFY-1.2b, P2-1). Поэтому ещё сверка по прокрутке,
    //    не чаще раза в кадр.
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { queued = false; sync(); });
    }, { passive: true });
  })();

  // ═══ STICKY HEADER (C7) ═══
  (function initStickyBar() {
    const bar = $('jkStickyBar');
    if (!bar || !hero) return;

    var stickyObserver = null;

    function startObserver() {
      if (stickyObserver) return;
      stickyObserver = new IntersectionObserver(function(entries) {
        var isVisible = entries[0].isIntersecting;
        bar.classList.toggle('visible', !isVisible);
        bar.setAttribute('aria-hidden', isVisible ? 'true' : 'false');
      }, { threshold: 0, rootMargin: '-60px 0px 0px 0px' });
      stickyObserver.observe(hero);
    }

    // ⛔ Раньше наблюдатель включался только при min-width: 641px, и на телефоне
    // панель не появлялась ВООБЩЕ — ни меню разделов, ни кнопки «Забронировать»
    // (замер 21.09.2026 на 390 px: visible=false на всей странице). При этом
    // правило E15 ниже прячет её при листании вниз и возвращает при листании
    // вверх — то есть само предполагает, что на телефоне она есть. Два условия
    // ширины противоречили друг другу; наблюдатель теперь работает везде.
    startObserver();

    // 02.07: sticky-CTA «Забронировать» → модалка заявки (решение владельца,
    // консистентно с hero-кнопкой; раньше скроллила к форме в aside).
    const cta = $('jkStickyCta');
    if (cta) cta.addEventListener('click', openLeadModal);

    // ⛔ Прятание панели при листании вниз (Phase E15) ОТМЕНЕНО 21.09.2026 словом
    // владельца: «пусть не пропадает совсем». На телефоне оно давало почти всегда
    // скрытую панель — класс scroll-hidden снимался только при листании ВВЕРХ
    // больше чем на 6 точек, то есть меню разделов и кнопка «Забронировать»
    // пропадали ровно там, где человек листает страницу вниз и выбирает корпус.
    // Панель теперь видна на всей странице ниже первого экрана.
    bar.classList.remove('scroll-hidden');
  })();

  // ═══ STICKY NAV — ACTIVE SECTION HIGHLIGHT (v2 redesign) ═══
  (function initStickyNavSections() {
    var navLinks = document.querySelectorAll('.jk-sticky-nav__link[data-section]');
    if (!navLinks.length) return;

    var sections = [];
    navLinks.forEach(function(link) {
      var sectionEl = document.getElementById(link.dataset.section);
      if (sectionEl) sections.push({ el: sectionEl, link: link });
    });
    if (!sections.length) return;

    var sectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Card-2026 Polish: a11y — снимаем .active И aria-current со всех, потом ставим на match
          navLinks.forEach(function(l) { l.classList.remove('active'); l.removeAttribute('aria-current'); });
          var match = sections.find(function(s) { return s.el === entry.target; });
          if (match) { match.link.classList.add('active'); match.link.setAttribute('aria-current', 'location'); }
        }
      });
    }, { rootMargin: '-80px 0px -60% 0px', threshold: 0 });

    sections.forEach(function(s) { sectionObserver.observe(s.el); });

    // Smooth scroll on nav link click
    navLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(link.dataset.section);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  // ═══ ЛИСТАНИЕ СТРАНИЦЫ ПО БЛОКАМ — СТРЕЛКИ ВВЕРХ/ВНИЗ (17.08.2026) ═══
  //
  // Просьба владельца: «стрелки аккуратные, по блокам вверх-вниз листать,
  // анимированные». Колесо прокручивает на произвольную высоту и человек
  // приземляется на середину блока; здесь прыжок всегда к началу следующего.
  //
  // ⛔ СПИСОК БЛОКОВ БЕРЁМ У ЛИПКОЙ ПАНЕЛИ, а не заводим свой. Два списка с
  //    одним смыслом расходятся всегда: добавят раздел в панель — стрелки о нём
  //    не узнают и молча его перепрыгнут. Источник один: [data-section].
  // ⛔ ТОЛЬКО КОМПЬЮТЕР (правило владельца 17.08 — «мы телефон не меняем, только
  //    комп»). На узком экране внизу висит своя панель действий, и плавающие
  //    стрелки садились бы прямо на неё. Порог тот же 900 px, что у раскладки.
  // ⛔ Позицию считаем от ЖИВОЙ высоты шапки, а не от числа: шапка на карточке
  //    прозрачная и меняет высоту, а промах вверх на её высоту возвращает
  //    человека в конец предыдущего блока — выглядит как «стрелка не сработала».
  (function initBlockPager() {
    var links = document.querySelectorAll('.jk-sticky-nav__link[data-section]');
    if (links.length < 2) return;
    // ⛔ ПОРОГ 1700, А НЕ 901 — ПО ЗАМЕРУ, НЕ ПО ВКУСУ. Свободного поля сбоку у
    //    карточки нет ни слева, ни справа, пока окно уже ~1700:
    //      слева  1720 → 95 px | 1600 → 49 px (панели нужно 68)
    //      справа 1440 и 1280 → панель задевает `.jk-infra-cat__dist`,
    //             1024 → шесть элементов блока инфраструктуры
    //    Плавающая кнопка поверх текста хуже, чем её отсутствие: она заслоняет
    //    содержимое и перехватывает нажатия. Поэтому на ноутбуках панели нет.
    if (!window.matchMedia || !window.matchMedia('(min-width: 1700px)').matches) return;

    var blocks = [];
    links.forEach(function(link) {
      var el = document.getElementById(link.dataset.section);
      if (el && blocks.indexOf(el) === -1) blocks.push(el);
    });
    if (blocks.length < 2) return;

    // Блоки в разметке могут идти не в том порядке, в каком перечислены в
    // панели: сортируем по фактическому положению на странице.
    blocks.sort(function(a, b) {
      return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });

    function headerOffset() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var px = parseInt(raw, 10);
      return (isNaN(px) ? 72 : px) + 18;
    }

    var pager = document.createElement('div');
    pager.className = 'jk-pager';
    pager.setAttribute('aria-label', 'Листать по разделам');

    function button(dir, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jk-pager__btn jk-pager__btn--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<i class="fa-solid ' + glyph + '" aria-hidden="true"></i>';
      b.addEventListener('click', function() { jump(dir); });
      return b;
    }

    function jump(dir) {
      var edge = window.scrollY + headerOffset();
      var target = null;
      if (dir === 'next') {
        for (var i = 0; i < blocks.length; i++) {
          var topDown = blocks[i].getBoundingClientRect().top + window.scrollY;
          // Допуск 4 px: сразу после прыжка блок стоит ровно на грани, и без
          // него вторая стрелка вниз «залипала» бы на текущем разделе.
          if (topDown > edge + 4) { target = blocks[i]; break; }
        }
      } else {
        for (var j = blocks.length - 1; j >= 0; j--) {
          var topUp = blocks[j].getBoundingClientRect().top + window.scrollY;
          if (topUp < edge - 4) { target = blocks[j]; break; }
        }
        // Выше первого блока — уводим в самый верх страницы, а не в никуда.
        if (!target) { window.scrollTo({ top: 0, behavior: scrollMode() }); return; }
      }
      if (target) target.scrollIntoView({ behavior: scrollMode(), block: 'start' });
    }

    function scrollMode() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    // Стрелка гаснет, когда идти в её сторону некуда: неактивная кнопка честнее
    // кнопки, которая нажимается и ничего не делает.
    var up = button('prev', 'К предыдущему разделу', 'fa-chevron-up');
    var down = button('next', 'К следующему разделу', 'fa-chevron-down');
    pager.appendChild(up);
    pager.appendChild(down);
    document.body.appendChild(pager);

    var ticking = false;
    function sync() {
      var edge = window.scrollY + headerOffset();
      var last = blocks[blocks.length - 1].getBoundingClientRect().top + window.scrollY;
      var atEnd = last <= edge + 4;
      var atTop = window.scrollY < 40;
      down.disabled = atEnd;
      up.disabled = atTop;
      // Панель появляется, только когда первый экран уехал: поверх героя она
      // спорит со стрелками галереи, а листать оттуда всё равно нечего.
      pager.classList.toggle('is-shown', window.scrollY > 420);
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  })();

  // ═══ ПЛАНИРОВКИ В ГАЛЕРЕЕ ИЗ УМНОГО ФИЛЬТРА (1.7.5) ═══
  //
  // JK.plans — список чертежей для таба «Планировки» в hero-галерее. Раньше он
  // собирался из поштучного flats[].layout_url; с 1.7.5 инвентарь не приезжает.
  // Берём готовые чертежи у фильтра: он и так грузит view=plans на старте (это
  // дефолтный вид выдачи), layout_url там решён СЕРВЕРНО через LayoutPolicy —
  // ни одного лишнего запроса и ни одного поэтажника-склейки в галерее.
  // Пересчитывать cardPlanUrl по 6.5k квартир ради этого нельзя: ровно эти
  // секунды блок 1.7.5 и убирал.
  function collectPlanUrls(payload) {
    if (!payload || payload.mode !== 'plans') return null;
    const list = Array.isArray(payload.floorplans) ? payload.floorplans : [];
    const seen = {};
    const urls = [];
    list.forEach(function(p) {
      const u = p && p.layout_url;
      if (typeof u !== 'string' || !u || seen[u]) return;
      seen[u] = true;
      urls.push(u);
    });
    return urls;
  }

  // Последний известный набор чертежей. Нужен потому, что гонка двусторонняя:
  // выдача фильтра может приехать РАНЬШЕ, чем ответ jk_manager (тогда JK ещё
  // null), и позже её никто не переотдаст — onResults делает replay только новым
  // подписчикам. Держим набор у себя и досыпаем его, когда появится JK.
  let heroPlanUrls = null;

  function syncHeroPlans() {
    if (!heroPlanUrls || !heroPlanUrls.length || !JK) return false;
    const prev = JK.plans || [];
    // Идемпотентность: onResults прилетает и на смену фильтра, и реплеем поздним
    // подписчикам. Перерисовывать табы на том же наборе — лишний скачок вёрстки.
    if (prev.length === heroPlanUrls.length && prev.every(function(u, i) { return u === heroPlanUrls[i]; })) return false;
    JK.plans = heroPlanUrls;
    window.JK = JK;
    renderHeroTabs();
    return true;
  }

  function applyHeroPlans(payload) {
    const urls = collectPlanUrls(payload);
    if (!urls || !urls.length) return false;
    heroPlanUrls = urls;
    return syncHeroPlans();
  }

  function initHeroPlansFromFilter() {
    const api = window.BroniJkFilter;
    // Страница без умного фильтра (или старый кэш jk-filter.js без onResults) —
    // галерея живёт как раньше, просто без таба планировок. Не ломаем.
    if (!api || typeof api.onResults !== 'function') return;
    api.onResults(applyHeroPlans);
  }

  // Весь страничный JS грузится с defer и в порядке $pageJS: jk.js исполняется
  // РАНЬШЕ jk-filter.js, поэтому window.BroniJkFilter на этот момент ещё нет.
  // DOMContentLoaded наступает после всех defer-скриптов — там контракт готов.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroPlansFromFilter);
  } else {
    initHeroPlansFromFilter();
  }

  // ═══ LOAD DATA ═══
  async function loadJK() {
    // D.1: на ЧПУ-адресе карточки query-параметра ?id= нет — идентификатор приходит
    // серверной переменной (jk.php). Query остаётся фолбэком для старого адреса.
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(window.BRONI_JK_ID, 10) || parseInt(params.get('id'), 10) || 1;
    try {
      const r = await fetch('/jk_manager.php?action=get&id=' + id, { credentials: 'same-origin' });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const d = await r.json();
      if (d.ok && d.jk) {
        // 1.7.5: flats/floorplans/floorplans_by_type приходят только под легаси-флагом
        // (JK_FLATS_LEGACY_CARDS). Без них считает сводка d.flats_summary.
        JK = enrichJK(d.jk, d.flats || [], d.flats_summary || null);
        // J1/J2/J3 (jk-card-accuracy): агрегация уникальных планировок по ТИПАМ
        // комнатности (бэк RoomTypeFloorplans) — 4 карточки-типа с чертежами +
        // модалка вариаций. JK.floorplans (плоский список I2/I3) сохранён для совместимости.
        JK.floorplans = Array.isArray(d.floorplans) ? d.floorplans : [];
        JK.floorplansByType = Array.isArray(d.floorplans_by_type) ? d.floorplans_by_type : [];
        window.JK = JK; renderAll(); removeSkeletons();
        // 1.7.5: выдача фильтра могла приехать раньше ответа jk_manager — тогда
        // чертежи ждут в heroPlanUrls и таб «Планировки» досыпается сейчас.
        // Строго ПОСЛЕ пары renderAll(); removeSkeletons() — она запинена
        // дословно (jk-card-redesign «removeSkeletons called after renderAll»),
        // а порядок с табами галереи не связан.
        syncHeroPlans();
        return;
      }
    } catch (e) { console.warn('loadJK error:', e.message); }
    // ⛔⛔ СООБЩЕНИЕ ДОБАВЛЯЕМ, А НЕ ЗАТИРАЕМ ИМ ГЕРОЙ.
    //    Раньше здесь стоял `hero.innerHTML = '…недоступен…'`, и это было терпимо,
    //    пока внутри .jk-hero жила только галерея. Теперь на компьютере внутрь него
    //    переезжают .hero-deal, .hero-specs и .hero-around, а в окружение —
    //    вся группа вкладок с #jkInfraCategories, #jkNearbyMetros, #jkNearbyServices,
    //    #jkInfraQuick и #jkNeighborhood. Один 500-й от jk_manager.php стирал бы
    //    ПЯТЬ полностью готовых серверных разделов — и у человека, и у робота
    //    Яндекса, который исполняет JS. Между тем сервер уже отдал рабочую
    //    карточку: фото, H1, цену, полосу фактов, окружение, юр-блок.
    //    Поэтому показываем полосу-предупреждение и оставляем всё остальное на месте.
    //
    // ⛔⛔ БЛОК С-4 (09.09.2026): ПОЛОСА ОСТАЁТСЯ, МЕНЯЕТСЯ ТОЛЬКО МЕСТО ВСТАВКИ.
    //    Была `hero.insertBefore(warn, hero.firstChild)` — то есть ПЕРВЫМ ребёнком
    //    героя, а герой открывает страницу. Робот Яндекса исполняет наш JS и берёт
    //    текст из готового DOM, поэтому первым текстом документа становилось
    //    сообщение о поломке. 09.09.2026 владелец показал живую выдачу по запросу
    //    «жк теплые края крансодар»: наш результат начинался словами «Часть данных
    //    ЖК временно недоступна. Перейти в каталог.» Тот же класс, что приветствие
    //    ИИ-виджета в сниппете 1 456 страниц (memory/feedback_yandex_renders_our_js_
    //    widget_text_becomes_snippet).
    //
    //    Куда переехало: ВНУТРЬ .jk-hero-info, сразу ПОСЛЕ заголовка первого уровня.
    //    Человек видит полосу там, куда и так смотрит, — под названием ЖК; робот
    //    встречает раньше неё имя дома, то есть текст, написанный для людей.
    //    ⚠️ ВИДИМОСТЬ ПРОВЕРЕНА, А НЕ ПРЕДПОЛОЖЕНА (Playwright, диверсия 500 от
    //    jk_manager.php, 09.09.2026): полоса видна и на прежнем месте, и на новом —
    //    `document.elementFromPoint` в её центре возвращает саму полосу в обоих
    //    случаях. Переезд сделан ради ПОРЯДКА ТЕКСТА, а не ради видимости.
    //    Запасной путь — в конец героя: без .jk-hero-info полоса всё равно обязана
    //    показаться, молча проглотить аварию нельзя.
    const hero = document.querySelector('.jk-hero');
    if (hero && !hero.querySelector('.jk-load-error')) {
      const warn = document.createElement('div');
      warn.className = 'jk-load-error';
      warn.setAttribute('role', 'status');
      warn.style.padding = '14px 24px';
      warn.style.textAlign = 'center';
      warn.style.color = 'var(--muted)';
      warn.style.background = 'rgba(0,0,0,.55)';
      warn.appendChild(document.createTextNode('Часть данных ЖК временно недоступна. '));
      const link = document.createElement('a');
      link.href = '/novostroyki/krasnodar/na-karte/';
      link.textContent = 'Перейти в каталог';
      link.style.color = 'var(--gold)';
      warn.appendChild(link);
      const info = hero.querySelector('.jk-hero-info');
      const title = info ? info.querySelector('h1') : null;
      if (title && title.nextSibling) {
        info.insertBefore(warn, title.nextSibling);
      } else if (info) {
        info.appendChild(warn);
      } else {
        hero.appendChild(warn);
      }
    }
  }


  // ═══ VR TOUR (v17.3 — Pannellum) ═══
  let tourViewer = null;
  let tourInited = false;

  function initTour() {
    if (tourInited) return;
    tourInited = true;

    const viewerEl = $('jkTourViewer');
    const wrapEl = $('jkTourWrap');
    const emptyEl = $('jkTourEmpty');
    const placeholderEl = $('jkTourPlaceholder');
    if (!viewerEl) return;

    // ⛔ В-4 (28.08.2026): подпись заглушки ставится ЗДЕСЬ, а не в шаблоне.
    //    В серверном HTML <p> приходит пустым — иначе «Загрузка 3D-тура…» лежит
    //    на карточке ЖК и достаётся поисковику даром (робот исполняет наш JS, но
    //    вкладок не нажимает, а сюда мы попадаем только по нажатию вкладки).
    if (placeholderEl) {
      const initialP = placeholderEl.querySelector('p');
      if (initialP && initialP.textContent === '') initialP.textContent = 'Загрузка 3D-тура...';
    }

    const tours = (JK && JK.tours) ? JK.tours : null;
    if (!tours || !tours.scenes || tours.scenes.length === 0) {
      if (wrapEl) wrapEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = '';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (wrapEl) wrapEl.style.display = '';

    if (typeof pannellum === 'undefined') {
      // PERF-1: сюда попадаем ТОЛЬКО когда у ЖК реально есть сцены тура (проверка выше).
      // Тянем движок по требованию и заходим в initTour повторно — сняв tourInited,
      // иначе ранний guard выкинет нас на втором заходе.
      if (vendorState.pannellum !== 'fail') {
        tourInited = false;
        loadVendor('pannellum', function(ok) {
          if (ok) { initTour(); return; }
          if (placeholderEl) {
            var errEl = placeholderEl.querySelector('p');
            if (errEl) errEl.textContent = '\u041e\u0448\u0438\u0431\u043a\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043a\u0438 3D-\u0434\u0432\u0438\u0436\u043a\u0430';
          }
        });
        return;
      }
      if (placeholderEl) {
        var pEl = placeholderEl.querySelector('p');
        if (pEl) pEl.textContent = '\u041e\u0448\u0438\u0431\u043a\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043a\u0438 3D-\u0434\u0432\u0438\u0436\u043a\u0430';
      }
      return;
    }

    const scenes = {};
    const firstScene = tours.scenes[0].id;

    tours.scenes.forEach(function(scene) {
      const hotSpots = [];
      if (scene.hotSpots) {
        scene.hotSpots.forEach(function(hs) {
          hotSpots.push({
            pitch: hs.pitch || 0,
            yaw: hs.yaw || 0,
            type: 'scene',
            text: hs.text || '',
            sceneId: hs.sceneId || ''
          });
        });
      }
      scenes[scene.id] = {
        title: scene.title || '',
        panorama: scene.panorama,
        hfov: scene.hfov || 110,
        pitch: scene.pitch || 0,
        yaw: scene.yaw || 0,
        hotSpots: hotSpots
      };
    });

    if (placeholderEl) placeholderEl.style.display = 'none';

    tourViewer = pannellum.viewer(viewerEl, {
      default: {
        firstScene: tours.firstScene || firstScene,
        sceneFadeDuration: 800,
        autoLoad: true,
        compass: false,
        showControls: false,
        mouseZoom: true,
        draggable: true,
        type: 'equirectangular'
      },
      scenes: scenes
    });

    renderTourScenes(tours.scenes);

    tourViewer.on('scenechange', function(sceneId) {
      updateActiveScene(sceneId);
    });
  }

  // DOM-009: Listener один раз, а не при каждом renderTourScenes()
  let tourScenesListenerBound = false;

  function renderTourScenes(scenes) {
    const el = $('jkTourScenes');
    if (!el || !scenes) return;
    el.innerHTML = scenes.map(function(s, i) {
      return '<button class="jk-tour-scene' + (i === 0 ? ' active' : '') + '" data-scene="' + esc(s.id) + '">' +
        '<i class="fas ' + safeIcon(s.icon || 'fa-image') + '"></i> ' + esc(s.title) + '</button>';
    }).join('');

    if (!tourScenesListenerBound) {
      tourScenesListenerBound = true;
      el.addEventListener('click', function(e) {
        const btn = e.target.closest('.jk-tour-scene');
        if (!btn || !tourViewer) return;
        const sceneId = btn.dataset.scene;
        tourViewer.loadScene(sceneId);
        updateActiveScene(sceneId);
      });
    }
  }

  function updateActiveScene(sceneId) {
    const el = $('jkTourScenes');
    if (!el) return;
    el.querySelectorAll('.jk-tour-scene').forEach(function(btn) {
      btn.classList.toggle('active', btn.dataset.scene === sceneId);
    });
  }

  const tourFsBtn = $('jkTourFullscreen');
  if (tourFsBtn) {
    tourFsBtn.addEventListener('click', function() {
      const wrap = $('jkTourWrap');
      if (!wrap) return;
      if (document.fullscreenElement) {
        document.exitFullscreen();
        tourFsBtn.innerHTML = '<i class="fas fa-expand"></i>';
      } else {
        wrap.requestFullscreen().catch(function() {});
        tourFsBtn.innerHTML = '<i class="fas fa-compress"></i>';
      }
    });
  }

  // ═══ LIGHTBOX ═══
  let lbIdx = 0;
  let lbPrevFocus = null;

  function openLightbox(idx) {
    lbIdx = idx;
    const lb = $('jkLightbox');
    if (!lb || !activeHeroPhotos.length) return;
    lbPrevFocus = document.activeElement;
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
    updateLightbox();
    var closeBtn = $('jkLbClose');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox() {
    const lb = $('jkLightbox');
    if (lb) lb.classList.remove('open');
    document.body.style.overflow = '';
    if (lbPrevFocus && lbPrevFocus.focus) lbPrevFocus.focus();
    lbPrevFocus = null;
  }

  function updateLightbox() {
    const img = $('jkLbImg');
    const counter = $('jkLbCounter');
    if (!activeHeroPhotos.length) return;
    lbIdx = (lbIdx + activeHeroPhotos.length) % activeHeroPhotos.length;
    // ⛔ В ГАЛЕРЕЕ — ПОЛНОРАЗМЕРНЫЙ КАДР (владелец 16.08). Раньше и здесь стояла
    //    миниатюра шириной 1200 — то есть «увеличить» показывало то же, что уже
    //    видно на странице. Теперь берём исходник, и грузится он ТОЛЬКО в момент
    //    открытия галереи: на скорость страницы это не влияет, потому что до
    //    клика запроса нет вовсе.
    //    ⛔ Запасной путь обязателен: часть исходников у застройщиков отдаёт 404
    //    (замер 16.08 — 19 мёртвых кадров у шести ЖК). Не открылся исходник —
    //    молча показываем прежнюю миниатюру, а не пустой экран.
    if (img) {
      var full = activeHeroPhotos[lbIdx];
      // ⛔ ЗАПАСНОЙ ПУТЬ ИМЕЕТ СМЫСЛ, ТОЛЬКО ЕСЛИ ОН ДРУГОЙ АДРЕС (доводка 2
      //    блока 2.1, VERIFY-2.1-3 P2-3). На проде показывается ИСХОДНИК, и
      //    подмена его миниатюрой — настоящая починка. На стенде показанный
      //    кадр САМ и есть миниатюра (`standSrc()` === `thumbUrl()`), поэтому
      //    повтор того же запроса не чинит ничего — он лишь делает вид, что
      //    запасной путь есть. Пусто честнее: на стенде `/img-thumb.php` и так
      //    отвечает 200 и своей заглушкой, до `onerror` дело не доходит.
      img.onerror = (window.BRONIDOM_STAND === true)
        ? null
        : function() { img.onerror = null; img.src = thumbUrl(full, 1200); };
      // На проде — исходник (слово владельца 16.08), на стенде — своя миниатюра.
      img.src = standSrc(full, 1200);
    }
    if (counter) counter.textContent = (lbIdx + 1) + ' / ' + activeHeroPhotos.length;
  }

  // ⛔ ПО РЕНДЕРУ БОЛЬШЕ НЕ КЛИКАЕМ (владелец 15.08: «сделай так, чтоб я не мог
  //    нажимать на рендер и увеличивать, только стрелками листать»). Раньше клик
  //    по ЛЮБОМУ месту героя — по краешкам, по тёмной полосе, по маленькой карте
  //    внутри рамки — открывал галерею на весь экран. Убрано в корне, а не глухим
  //    перехватом события: галерею открывают кнопка «Галерея комплекса»
  //    (bindHeroButtons), кадры блока «О ЖК» и тап на телефоне (HERO TOUCH ниже).
  //    На телефоне поведение прежнее — владелец просил его не трогать.
  // ⛔ 16.08.2026 владелец РАЗВЕРНУЛ прежнее решение: «сделай, чтоб при нажатии
  //    на фото открывался полноразмерный рендер». Клик снова открывает галерею —
  //    но ТОЛЬКО по самой фотографии: краешки соседних кадров, тёмная полоса,
  //    мини-карта и кнопки по-прежнему не открывают. Именно неразборчивый клик
  //    «по любому месту героя» и был причиной запрета 15.08.
  hero.addEventListener('click', function(e) {
    if (e.target.closest('button') || e.target.closest('a') ||
        e.target.closest('.jk-hero-tabs') || e.target.closest('.jk-hero-badges')) return;
    if (cardDesktop && !e.target.closest('.jk-hero-slide-img')) return;
    openLightbox(heroIdx);
  });
  if (!cardDesktop) hero.style.cursor = 'pointer';

  const lbClose = $('jkLbClose');
  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  const lbPrev = $('jkLbPrev');
  if (lbPrev) lbPrev.addEventListener('click', function() { lbIdx--; updateLightbox(); });
  const lbNext = $('jkLbNext');
  if (lbNext) lbNext.addEventListener('click', function() { lbIdx++; updateLightbox(); });

  // Close on background click
  const lbEl = $('jkLightbox');
  if (lbEl) {
    lbEl.addEventListener('click', function(e) {
      if (e.target === lbEl) closeLightbox();
    });
  }

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    const lb = $('jkLightbox');
    if (!lb || !lb.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') { lbIdx--; updateLightbox(); }
    if (e.key === 'ArrowRight') { lbIdx++; updateLightbox(); }
  });

  // Lightbox touch/swipe
  (function() {
    var lb = $('jkLightbox');
    if (!lb) return;
    var startX = 0, startY = 0, dx = 0;
    lb.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
    }, {passive: true});
    lb.addEventListener('touchmove', function(e) {
      dx = e.touches[0].clientX - startX;
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (Math.abs(dx) > dy && Math.abs(dx) > 10) e.preventDefault();
    }, {passive: false});
    lb.addEventListener('touchend', function() {
      if (dx > 50) { lbIdx--; updateLightbox(); }
      else if (dx < -50) { lbIdx++; updateLightbox(); }
    }, {passive: true});
  })();

  // ═══ HERO TOUCH/SWIPE ═══
  (function() {
    var slides = $('jkHeroSlides');
    if (!slides) return;
    var startX = 0, dx = 0;
    slides.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      dx = 0;
    }, {passive: true});
    slides.addEventListener('touchmove', function(e) {
      dx = e.touches[0].clientX - startX;
    }, {passive: true});
    slides.addEventListener('touchend', function() {
      if (dx > 50) goSlide(heroIdx - 1);
      else if (dx < -50) goSlide(heroIdx + 1);
      // B.3 (2026-07-19): на мобиле кнопку «Галерея комплекса» убрали с чистого
      // фото — чистый тап (без свайпа) открывает лайтбокс на текущем кадре.
      else if (Math.abs(dx) < 10 && typeof openLightbox === 'function') openLightbox(heroIdx);
    }, {passive: true});
  })();

  // ═══ MOBILE BOTTOM SHEET (Phase 10) ═══
  var sheetOverlay = $('jkSheetOverlay');
  var bottomSheet = $('jkBottomSheet');

  function openBottomSheet() {
    if (!bottomSheet || !sheetOverlay) return;
    // Fill price from JK data
    var amountEl = $('jkSheetAmount');
    if (amountEl && window.JK && window.JK.priceFrom) amountEl.textContent = fmt(window.JK.priceFrom);
    var titleEl = $('jkSheetTitle');
    if (titleEl && window.JK && window.JK.name) titleEl.textContent = jkDisplay(window.JK.name);
    sheetOverlay.classList.add('open');
    bottomSheet.classList.add('open');
    document.body.style.overflow = 'hidden';
    bottomSheet.focus();
  }

  function closeBottomSheet() {
    if (!bottomSheet || !sheetOverlay) return;
    sheetOverlay.classList.remove('open');
    bottomSheet.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Bottom bar CTA opens sheet on mobile, modal on desktop
  var bbCta = $('jkBbCta');
  if (bbCta) {
    bbCta.addEventListener('click', function() {
      if (window.innerWidth <= 1024 && bottomSheet) {
        openBottomSheet();
      } else {
        openLeadModal();
      }
    });
  }

  // Sheet book button opens callback modal
  var sheetBookBtn = $('jkSheetBookBtn');
  if (sheetBookBtn) {
    sheetBookBtn.addEventListener('click', function() {
      closeBottomSheet();
      openLeadModal();
    });
  }

  // Close handlers
  var sheetCloseBtn = $('jkSheetClose');
  if (sheetCloseBtn) sheetCloseBtn.addEventListener('click', closeBottomSheet);
  if (sheetOverlay) sheetOverlay.addEventListener('click', closeBottomSheet);

  // Escape key closes sheet
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && bottomSheet && bottomSheet.classList.contains('open')) {
      closeBottomSheet();
    }
  });

  // Swipe down to close (touch)
  (function() {
    if (!bottomSheet) return;
    var startY = 0;
    bottomSheet.addEventListener('touchstart', function(e) {
      startY = e.touches[0].clientY;
    }, {passive: true});
    bottomSheet.addEventListener('touchend', function(e) {
      var dy = e.changedTouches[0].clientY - startY;
      if (dy > 80) closeBottomSheet();
    }, {passive: true});
  })();

  // ═══ SKELETON REMOVAL (Phase 11) ═══
  function removeSkeletons() {
    var skeletons = document.querySelectorAll('.jk-skeleton-accordion, .jk-reviews-list > .jk-skeleton');
    for (var i = 0; i < skeletons.length; i++) {
      skeletons[i].remove();
    }
  }

  // ═══════════════════════════════════════════════════════════════════════
  // КАРТОЧКА ЖК 2026 — МОСТ К ОТДЕЛЬНОМУ ФАЙЛУ js/jk-card.js
  //
  // Сам код первого экрана (ряд «краешек — рендер — краешек», строка цены, рамка
  // характеристик, «Что вокруг дома», геометрия, окно заявки .jkcb-*) переехал в
  // js/jk-card.js. Причина одна: он работает ТОЛЬКО от 901 px, обе точки входа
  // выходили первой же строкой при узком окне — а телефон качал и разбирал его
  // целиком на каждой карточке, ради кода, который не исполнялся ни разу.
  //
  // ⛔ ШИРИНУ ПРОВЕРЯЕМ ДО СОЗДАНИЯ ТЕГА, а не внутри модуля: иначе запрос всё
  //    равно уходил бы с телефона, и вся затея теряла смысл.
  // ⛔ АДРЕС ФАЙЛА НЕ ВЫДУМЫВАЕМ. На проде отдаётся собранный файл с хэшем
  //    содержимого (/dist/js/jk-card-HASH.min.js), адреса /js/jk-card.js там
  //    просто нет. Готовую строку печатает public/jk.php через assetUrl() —
  //    тем же способом, что window.YMAPS_KEY и window.BRONI_JK_ID.
  // ⛔ CSP: под 'strict-dynamic' скрипт, вставленный нашим nonce-скриптом,
  //    доверенный, плюс в script-src-elem явно стоит 'self' — правки app/csp.php
  //    не требуется (тот же приём, что у loadVendor выше).
  // ═══════════════════════════════════════════════════════════════════════
  window.BroniJkCardHost = {
    // Помощники страницы: модуль не заводит своих копий.
    $: $,
    safeIcon: safeIcon,
    jkDisplay: jkDisplay,
    pluralize: pluralize,
    addressText: jkAddressText,
    // Номер текущего кадра галереи двигает листание ЗДЕСЬ — отдаём значением.
    heroIndex: function () { return heroIdx; },
    // Модуль зовёт это, когда полностью разобран.
    ready: function (api) {
      jkCard = api;
      api.stage();
      // Строки адреса могли уже быть написаны длинными (модуль приехал позже
      // ответа API) — переписываем набело.
      jkApplyStripAddress();
      jkApplyInfoAddress();
      if (jkCardDataArrived) api.applyData();
    }
  };

  function jkCardBoot() {
    if (!cardDesktop) return;
    var src = window.BRONI_JK_CARD_JS;
    if (typeof src !== 'string' || !src) return;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    // Не приехал (сеть, 404, чужой кэш) — тег убираем и молчим: страница остаётся
    // в прежнем серверном виде, ошибок в консоль не сыпем.
    s.onerror = function () { if (s.parentNode) s.parentNode.removeChild(s); };
    document.head.appendChild(s);
  }
  jkCardBoot();

  // ═══ INIT ═══
  loadJK();
})();

// ═══════════════════════════════════════════════════════════════════════
// ⛔ A/B-ТЕСТ ЗАГОЛОВКА «АРЕНА» СНЯТ 15.08.2026 (решение владельца).
//
// Что здесь было. Через секунду после загрузки блок забирал заголовок из
// /arena_api.php и клал его в H1 простым текстом (`jkTitleEl.textContent =
// data.headline`), стирая и золочение имени, и город: сервер печатает
// «ЖК «Публицист» в Подмосковье», а тест возвращал «ЖК «Публицист» — от …».
// Вторым запросом (`action: 'convert'`) он считал конверсии по клику на CTA.
//
// Почему снят целиком, а не починен поверх:
//   • во всех 54 раундах из 54 варианты заголовка ДОСЛОВНО ОДИНАКОВЫ — выбрать
//     победителя тест не может в принципе;
//   • причина в самом коде: при неответе callAI() все пять агентов падают на
//     один запасной текст, то есть ИИ не отвечал ни разу с апреля;
//   • при этом заголовок он исправно портил на всех 156 карточках, а один раз
//     принёс в H1 цену 112-дневной давности — чинили коммитом c96e01217
//     (храним ссылку на цену, а не отрисованное число).
//
// Обработчики конверсии сняты вместе с показом: без подмены заголовка считать
// было бы нечего, а мёртвый слушатель на каждой CTA — лишняя работа страницы.
// Серверный H1 остаётся единственным. Сам /arena_api.php не трогали — он
// обслуживает и бронирования (SEC-019), это отдельная правка бэкенда.
// ═══════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════
// ⛔ АНИМАЦИЯ КОЛЕЦ РЕЙТИНГА УДАЛЕНА 26.08.2026 (была Phase 2A, 20.04.2026)
//
// Здесь жил IIFE: он находил на странице кольца оценок (.jk-ring__fg
// с атрибутом data-score) и при въезде кольца в экран плавно доводил
// золотую дугу до записанного в атрибуте балла.
//
// Анимировать стало нечего: секция «Рейтинг жилого комплекса»
// (#jkRatings) удалена из app/templates/pages/jk_content.php — решение владельца
// «оценки из вёрстки убираем совсем». Замер и условие возврата — в шаблоне,
// ищи «ОЦЕНКИ ЖК УБРАНЫ ИЗ ВЁРСТКИ».

// ═══════════════════════════════════════════════════════════════════════
// ⛔ АНИМАЦИЯ ПРОГРЕСС-БАРА СТРОЙКИ УДАЛЕНА 25.08.2026 (была Phase 2A, 20.04.2026)
//
// Здесь жил отдельный IIFE: он находил на странице полосы готовности по их классу
// и атрибуту с процентом, и при въезде полосы в экран (IntersectionObserver)
// плавно растягивал золотую заливку до записанного в атрибуте значения.
//
// Анимировать стало нечего: секция #jkConstructionProgress удалена из
// app/templates/pages/jk_content.php — проценты готовности выводились из СРОКА
// СДАЧИ, а не со стройки (аудит партнёра Галс, находка В-07, критично).
// Замер и условие возврата — в шаблоне, ищи «ХОД СТРОИТЕЛЬСТВА УДАЛЁН».
//
// Код снесён, а не оставлен «на всякий случай», намеренно: живая анимация
// несуществующего блока выглядит как случайно потерянная разметка и подталкивает
// следующего вернуть секцию, чтобы «починить». Вернётся блок — вернётся и код,
// он короткий.
// ═══════════════════════════════════════════════════════════════════════

// ─── 5.3: РАССРОЧКА — CTA «Узнать про рассрочку» → модалка обратного звонка ───
// Отдельный IIFE + guard: секция рендерится только для ЖК с рассрочкой (data-gated
// в jk_content.php), поэтому не зависим от блока ипотеки.
(() => {
  'use strict';
  const btn = document.getElementById('jkInstLeadBtn');
  if (!btn) return;
  // ⛔ Через единую точку входа: иначе на одной странице жили бы ДВЕ формы заявки
  //    с разными полями и разными путями согласия.
  btn.addEventListener('click', () => {
    if (typeof window.openJkLeadModal === 'function') { window.openJkLeadModal(); return; }
    if (typeof window.openCallbackModal === 'function') window.openCallbackModal();
  });
})();

// ─── seo-master I.7 (2026-08-02): ЛИДОГЕН у ЖК без квартир в продаже ───
// Блок components/jk-flats-soldout.php рендерится ВМЕСТО секции #jkFlats при
// $_flatsCnt = 0. Кнопка открывает ту же готовую модалку заявки, что ипотека и
// рассрочка (CSRF + honeypot + согласие 152-ФЗ в footer.php): своей формы у блока
// нет, второго механизма заявок на странице не заводим.
// ⛔ Адресацию модалки по id НЕ дублируем (инвариант jk-callback-modal-class):
// единственная ссылка на id живёт в fallback openLeadModal().
// Отдельный IIFE + guard: у 148 из 151 ЖК блока на странице нет.
(() => {
  'use strict';
  const btn = document.getElementById('jkSoldoutLeadBtn');
  if (!btn) return;
  // ⛔ Через единую точку входа — см. рассрочку выше.
  btn.addEventListener('click', () => {
    if (typeof window.openJkLeadModal === 'function') { window.openJkLeadModal(); return; }
    if (typeof window.openCallbackModal === 'function') window.openCallbackModal();
  });
})();
